// Translation system for EyeControl App

export type Language = "he" | "en" | "ar" | "ru";

export const translations = {
  he: {
    // Navigation & Layout
    home: "בית",
    back: "חזרה",
    settings: "הגדרות",
    help: "עזרה",
    rest: "מנוחה",
    clock: "שעון",
    volume: "עוצמת קול",
    control: "שליטה",
    
    // Home page
    goodMorning: "בוקר טוב",
    goodAfternoon: "צהריים טובים",
    goodEvening: "ערב טוב",
    goodNight: "לילה טוב",
    whatToDo: "מה נעשה היום?",
    whatToDoMale: "מה תרצה לעשות היום?",
    whatToDoFemale: "מה תרצי לעשות היום?",
    quickSpeak: "אמירה מהירה:",
    
    // Quick phrases
    hello: "שלום",
    thanks: "תודה",
    yes: "כן",
    no: "לא",
    please: "בבקשה",
    water: "מים",
    food: "אוכל",
    
    // Main actions
    communicationBoard: "לוח תקשורת",
    contacts: "יצירת קשר",
    games: "משחקים",
    youtube: "יוטיוב",
    spotify: "ספוטיפיי",
    keyboard: "מקלדת",
    keyboardShort: "מקלדת",
    translator: "מתרגם",
    history: "היסטוריה",
    music: "מוזיקה",
    tv: "טלוויזיה",
    radio: "רדיו",
    calendar: "יומן",
    news: "חדשות",
    guide: "מדריך",
    smartHome: "בית חכם",
    more: "עוד",
    aiChat: "צ'אט AI",
    aacKeyboard: "מקלדת AAC",
    entertainment: "בידור",
    
    // Settings page
    settingsTitle: "הגדרות",
    appearance: "מראה",
    darkMode: "מצב כהה",
    lightMode: "מצב בהיר",
    darkModeDesc: "החליפו בין תצוגה כהה ובהירה",
    fontSize: "גודל גופן",
    small: "קטן",
    medium: "בינוני",
    large: "גדול",
    
    soundAndVoice: "קול ושמע",
    muteAll: "השתק קולות",
    muteAllDesc: "כבה את כל הצלילים",
    voiceSelection: "קול דיבור",
    voiceSelectionDesc: "בחרו בין קול גברי לנשי",
    female: "אישה",
    male: "גבר",
    speechSpeed: "מהירות דיבור",
    speechLanguage: "שפת דיבור",
    speechLanguageDesc: "שפת הפלט הקולי (ברירת מחדל: שפת המשתמש)",
    
    accessibility: "נגישות",
    keyboardNav: "ניווט במקלדת",
    keyboardNavDesc: "הפעילו ניווט באמצעות מקשי החצים",
    // Head tracking settings
    headTrackingRange: "רגישות מעקב ראש",
    headTrackingRangeDesc: "ככל שהרגישות גבוהה יותר - צריך פחות להזיז את הראש",
    rangeWide: "נמוכה",
    rangeNarrow: "גבוהה",
    // Gaze tracking settings
    gazeTrackingSmoothing: "החלקת סמן",
    gazeTrackingSmoothingDesc: "כמה חלקה תנועת הסמן - איטי יותר = חלק יותר",
    smoothingLow: "מדויק (קופצני)",
    smoothingHigh: "חלק (איטי)",
    
    // Status bar
    headTrackingActive: "מעקב ראש פעיל",
    gazeTrackingActive: "מעקב מבט פעיל",
    mouthGestureTrackingActive: "מעקב תנועות פה פעיל",
    cookies: "עוגיות",
    cookieSettings: "הגדרות עוגיות",
    
    profile: "פרופיל המשתמש",
    profileMale: "פרופיל המשתמש",
    profileFemale: "פרופיל המשתמשת",
    name: "שם",
    enterName: "הכנס שם",
    addressing: "מגדר (לצורך פניה ודיבור)",
    neutral: "ניטרלי",
    language: "שפה",
    hebrew: "עברית",
    english: "English",
    arabic: "العربية",
    russian: "Русский",
    
    // Contacts page
    contactsTitle: "יצירת קשר",
    email: "אימייל",
    sms: "SMS",
    whatsapp: "וואטסאפ",
    caregiverDetails: "פרטי מטפל",
    phone: "טלפון",
    notSet: "לא הוגדר",
    caregiverSettings: "הגדרות מטפל",
    caregiverEmail: "אימייל מטפל",
    pushNotificationsDescription: "להגדרת התראות Push למטפלים, עבור להגדרות",
    goToSettings: "עבור להגדרות",
    save: "שמור",
    savedSuccessfully: "נשמר בהצלחה",
    caregiverUpdated: "פרטי המטפל עודכנו",
    to: "אל",
    toOptional: "אל (אופציונלי - ברירת מחדל: מטפל)",
    message: "הודעה",
    writeMessage: "כתוב את ההודעה שלך...",
    noPhone: "אין מספר טלפון",
    enterPhoneOrSet: "יש להזין מספר טלפון או להגדיר טלפון מטפל",
    noEmail: "אין כתובת אימייל",
    enterEmailOrSet: "יש להזין כתובת אימייל או להגדיר אימייל מטפל",
    
    // Help alert
    needHelpMale: "אני צריך עזרה!",
    needHelpFemale: "אני צריכה עזרה!",
    close: "סגור",
    pressEnterToClose: "Enter לסגירה",
    pressMale: "לחץ",
    pressFemale: "לחצי",
    toClose: "לסגירה",
    emoji: "אימוג'י",
    cells: "תאים",
    icon: "אייקון",
    orChooseEmoji: "או בחר אימוג'י",
    preview: "תצוגה מקדימה",
    textMalePlaceholder: "לדוגמה: כואב לי",
    textFemalePlaceholder: "לדוגמה: כואב לי",
    openSourceDescription: "EyeControl App משתמשת בספריות הקוד הפתוח הבאות:",
    cookiesInUseSubtitle: "Cookies in Use",
    notInUse: "לא בשימוש כרגע",
    
    // Rest mode
    restMode: "מצב מנוחה",
    pressToWake: "במסך או Enter להתעוררות",
    restModeDwellInstruction: "החזיקי מבט על העיגול למשך 3 שניות",
    restModeDwellInstructionMale: "החזק מבט על העיגול למשך 3 שניות",
    restModeDwellInstructionFemale: "החזיקי מבט על העיגול למשך 3 שניות",
    restModeSelectInstruction: "בצעי פעולת בחירה 3 פעמים כדי לצאת",
    restModeSelectInstructionMale: "בצע פעולת בחירה 3 פעמים כדי לצאת",
    restModeSelectInstructionFemale: "בצעי פעולת בחירה 3 פעמים כדי לצאת",
    restModeVoiceInstruction: "אמרי את המספר שלוש פעמים",
    restModeVoiceInstructionMale: "אמור את המספר שלוש פעמים",
    restModeVoiceInstructionFemale: "אמרי את המספר שלוש פעמים",
    pressEscapeToWake: "ניתן ללחוץ Escape ליציאה מהירה",
    mediaRestBlinkInstruction: "מצמצי 3 פעמים לצאת",
    mediaRestBlinkInstructionMale: "מצמץ 3 פעמים לצאת",
    mediaRestBlinkInstructionFemale: "מצמצי 3 פעמים לצאת",
    
    // Time info
    sunday: "ראשון",
    monday: "שני",
    tuesday: "שלישי",
    wednesday: "רביעי",
    thursday: "חמישי",
    friday: "שישי",
    saturday: "שבת",
    day: "יום",
    january: "ינואר",
    february: "פברואר",
    march: "מרץ",
    april: "אפריל",
    may: "מאי",
    june: "יוני",
    july: "יולי",
    august: "אוגוסט",
    september: "ספטמבר",
    october: "אוקטובר",
    november: "נובמבר",
    december: "דצמבר",
    loadingLocation: "טוען מיקום...",
    locationUnavailable: "מיקום לא זמין",
    unknownLocation: "מיקום לא ידוע",
    locationError: "שגיאה בטעינת מיקום",
    noLocationPermission: "אין הרשאת מיקום",
    loadingWeather: "טוען מזג אוויר...",
    weatherUnavailable: "מזג אוויר לא זמין",
    
    // Volume
    volumeTitle: "עוצמת קול",
    veryLow: "נמוך מאוד",
    low: "נמוך",
    mediumVol: "בינוני",
    high: "גבוה",
    veryHigh: "גבוה מאוד",
    navInstructions: "↑↓ לניווט • Enter לבחירה",
    
    // Control Methods
    controlMethodsTitle: "שיטת השליטה באפליקציה",
    controlMethodsTitleMale: "שיטת השליטה באפליקציה",
    controlMethodsTitleFemale: "שיטת השליטה באפליקציה",
    controlMethodsSubtitle: "בחרו את השיטה המתאימה למשתמש",
    controlMethodsSubtitleMale: "בחרו את השיטה המתאימה למשתמש",
    controlMethodsSubtitleFemale: "בחרו את השיטה המתאימה למשתמשת",
    control_standard_pointer_title: "מגע / עכבר",
    control_standard_pointer_desc: "שליטה רגילה במגע או עכבר",
    control_voice_title: "שליטה קולית",
    control_voice_desc: "שליטה באמצעות פקודות קוליות",
    control_eye_control_title: "מכשיר EyeControl",
    control_eye_control_desc: "שליטה עם מכשיר EyeControl",
    control_external_switch_title: "מתגים חיצוניים",
    control_external_switch_desc: "שליטה באמצעות מתגים",
    control_gaze_tracking_title: "מעקב מבט",
    control_gaze_tracking_desc: "שליטה בתנועות עיניים",
    control_head_tracking_title: "מעקב ראש",
    control_head_tracking_desc: "שליטה בתנועות ראש",
    control_mouth_gestures_title: "תנועות פה",
    control_mouth_gestures_desc: "שליטה בתנועות פה",
    
    // AAC & Communication
    aacTitle: "מקלדת AAC",
    speak: "דבר",
    clear: "נקה",
    delete: "מחק",
    space: "רווח",
    enter: "אישור",
    wordCompletion: "השלמת מילים",
    acronymMode: "מצב ראשי תיבות",
    suggestions: "הצעות",
    recentWords: "מילים אחרונות",
    addToDictionary: "הוסף למילון",
    
    // Communication Board
    boardTitle: "לוח תקשורת",
    editBoard: "ערוך לוח",
    editBoards: "עריכת לוחות",
    userContacts: "אנשי קשר",
    userContactsTitle: "אנשי קשר של המשתמש",
    editHelpBoard: "עריכת לוח עזרה",
    editCommunicationBoard: "עריכת לוח תקשורת",
    editTopActionBar: "עריכת שורת פעולות עליונה",
    addCategory: "הוסף קטגוריה",
    spatialNavigation: "ניווט מרחבי",
    createBoard: "צרו לוח חדש",
    boardName: "שם הלוח",
    selectIcon: "בחר אייקון",
    selectColor: "בחר צבע",
    category: "קטגוריה",
    utterance: "אמירה",
    utterances: "היגדים",
    rows: "שורות",
    columns: "עמודות",
    deleteBoard: "מחק לוח",
    saveBoard: "שמור לוח",
    boardDeleted: "הלוח נמחק בהצלחה",
    boardReset: "הלוח אופס לברירת מחדל",
    resetBoard: "אפס לוח",
    buildNewBoard: "בניית לוח חדש",
    items: "פריטים",
    
    // Actions menu
    speakAction: "הקרא",
    sendToContacts: "שלח לאנשי קשר",
    sendToAI: "שלח לצ'אט AI",
    translateAction: "תרגם",
    addToDict: "הוסף למילון",
    
    // Translation
    translateTitle: "תרגום",
    selectLanguage: "בחר שפה",
    translatedText: "טקסט מתורגם",
    speakTranslation: "הקרא תרגום",
    
    // AI Chat
    aiChatTitle: "צ'אט עם AI",
    typeMessage: "הקלד הודעה...",
    sendMessage: "שלח",
    clearChat: "נקה שיחה",
    aiThinking: "AI חושב...",
    
    // YouTube
    youtubeTitle: "יוטיוב",
    searchVideos: "חפש סרטונים",
    search: "חפש",
    searchTab: "חיפוש",
    noResults: "לא נמצאו תוצאות",
    views: "צפיות",
    
    // TV & Radio
    tvTitle: "טלוויזיה",
    radioTitle: "רדיו",
    selectCountry: "בחר מדינה",
    selectGenre: "בחר ז'אנר",
    channels: "ערוצים",
    stations: "תחנות",
    nowPlaying: "מתנגן עכשיו",
    
    // Games
    gamesTitle: "משחקים",
    accessibleGameHub: "מרכז משחקים נגיש",
    accessibleGameHubDesc: "משחקים מותאמים לכל שיטות השליטה",
    memoryGame: "משחק זיכרון",
    memoryGameDesc: "מצא זוגות תואמים של קלפים",
    game2048: "2048",
    game2048Desc: "מזג אריחים כדי להגיע ל-2048",
    slidingPuzzle: "פאזל הזזה",
    slidingPuzzleDesc: "פתור את הפאזל במספר מהלכים",
    simonSays: "סיימון אומר",
    simonSaysDesc: "חזור על דפוסי הצבעים",
    dinoRunner: "דינו ראנר",
    dinoRunnerDesc: "קפוץ מעל מכשולים - מתג אחד",
    pongGame: "פונג",
    pongGameDesc: "טניס שולחן - שני מתגים",
    spaceDefender: "מגן החלל",
    spaceDefenderDesc: "הגן על החללית - 5 מתגים",
    balloonPopper: "פוצץ בלונים",
    balloonPopperDesc: "מיקוד מבט - ללא לחיצות",
    gridMemoryGame: "זיכרון מספרים",
    gridMemoryDesc: "שליטה קולית - אמור מספר",
    moves: "מהלכים",
    newGame: "משחק חדש",
    wonInMoves: "ניצחת ב-{0} מהלכים!",
    gameSoonAvailable: "המשחק יהיה זמין בקרוב",
    cellScanning: "סריקת תאים",
    rowScanning: "סריקת שורות",
    ticTacToe: "איקס עיגול",
    puzzle: "פאזל",
    startGame: "התחל משחק",
    yourTurn: "תורך",
    aiTurn: "תור AI",
    youWin: "ניצחת!",
    youWon: "ניצחת!",
    aiWins: "AI ניצח",
    draw: "תיקו",
    playAgain: "שחק שוב",
    gameOver: "סיום משחק",
    score: "ניקוד",
    highScore: "שיא",
    up: "למעלה",
    down: "למטה",
    left: "שמאלה",
    right: "ימינה",
    slidingPuzzleHint: "לחץ על האריחים הסמוכים כדי להזיז אותם",
    simonSaysHint: "חזור על הרצף על ידי לחיצה על הצבעים",
    watchTheSequence: "צפה ברצף...",
    missed: "פספוסים",
    dinoTapToJump: "לחץ על מקש כלשהו או הקש על המסך לקפיצה",
    dinoTapAnywhere: "הקש בכל מקום לקפיצה",
    pongInstructions: "השתמש בחצים למעלה/למטה או בכפתורים לשליטה במחבט",
    balloonPopperInstructions: "עמוד עם המבט על בלון למשך שנייה כדי לפוצץ אותו",
    balloonPopperHint: "העבר את המבט מעל בלון והישאר שנייה כדי לפוצץ | ללא לחיצות!",
    
    // Eye Control Settings
    controlSetup: "הגדרת שליטה",
    selectGesturesMale: "בחרו את התנועות שהמשתמש יכול לבצע",
    selectGesturesFemale: "בחרו את התנועות שהמשתמשת יכולה לבצע",
    lookUp: "מבט למעלה",
    lookDown: "מבט למטה",
    lookLeft: "מבט שמאלה",
    lookRight: "מבט ימינה",
    blink: "מצמוץ",
    automaticScanning: "סריקה אוטומטית",
    automaticWithCancel: "סריקה אוטומטית עם ביטול",
    automaticWithCancelOption: "סריקה אוטומטית עם אפשרות לביטול",
    gestureScanning: "סריקה באמצעות מחוות",
    cursorMovesAuto: "הסמן זז אוטומטית, לחיצה אחת לבחירה",
    scanningByGestureDesc: "הסריקה עוברת על ידי המחווה שתעשה - למשל מבט ימינה, עוברים ריבוע. מצמוץ=אנטר",
    selectedMode: "מצב נבחר:",
    selectScanTypeMale: "סוג סריקה",
    selectScanTypeFemale: "סוג סריקה",
    scanMode: "אופן סריקה",
    cellByCellMode: "תא אחר תא",
    cellByCellDesc: "הסריקה עוברת על כל תא בנפרד",
    rowAndColumnMode: "שורה ועמודה",
    rowAndColumnDesc: "קודם בוחרים שורה, אחר כך תא בשורה",
    scanSpeedLabel: "מהירות סריקה",
    slow: "איטי",
    fast: "מהיר",
    continueButton: "המשך",
    previousButton: "הקודם",
    nextButton: "הבא",
    
    // Contacts (additional)
    savedSuccessMsg: "נשמר בהצלחה",
    noEmailAddressMsg: "אין כתובת אימייל",
    enterEmailOrSetCaregiverMsg: "יש להזין כתובת אימייל או להגדיר אימייל מטפל",
    noPhoneNumberMsg: "אין מספר טלפון",
    enterPhoneOrSetCaregiverMsg: "יש להזין מספר טלפון או להגדיר טלפון מטפל",
    messageFromAyuniSubject: "הודעה מ-EyeControl App",
    
    // Board Builder
    boardDetails: "פרטי הלוח",
    boardNameLabel: "שם הלוח",
    enterBoardName: "הכנס שם ללוח...",
    removeIcon: "הסר",
    orSelectEmoji: "או בחר אימוג'י",
    previewLabel: "תצוגה מקדימה:",
    confirmButton: "אישור",
    gridSizeLabel: "גודל רשת",
    rowsLabel: "שורות:",
    columnsLabel: "עמודות:",
    cellsLabel: "תאים",
    boardSavedMsg: "הלוח נשמר בהצלחה!",
    boardUpdatedMsg: "הלוח עודכן בהצלחה!",
    finishButton: "סיום",
    utterancesLabel: "היגדים",
    
    // Communication Board (additional)
    immediateSpeak: "הגייה מיידית",
    actionsScreen: "פעולות נוספות",
    modeHintSpeak: "לחיצה על פריט תקריא אותו מיד",
    modeHintActions: "לחיצה על פריט תפתח תפריט פעולות",
    boardDeletedMsg: "הלוח נמחק בהצלחה",
    editBoardBtn: "עריכה",
    deleteBoardBtn: "מחיקה",
    createNewBoardBtn: "יצירת לוח חדש",
    itemsLabel: "פריטים",
    sentenceBuilderMode: "מצב בניית משפטים",
    speakSentence: "דיבור",
    clearSentence: "נקה",
    deleteLastWord: "מחק מילה",
    sentenceBarPlaceholderMale: "לחץ על מילים כדי לבנות משפט...",
    sentenceBarPlaceholderFemale: "לחצי על מילים כדי לבנות משפט...",
    
    // Smart Home
    smartHomeTitle: "בית חכם",
    lights: "תאורה",
    lightsOn: "הדלק",
    lightsOff: "כבה",
    brightness: "בהירות",
    webhookButtons: "כפתורי Webhook",
    addButton: "הוסף כפתור",
    buttonName: "שם הכפתור",
    webhookUrl: "כתובת Webhook",
    
    // Scanning
    scanningSettings: "הגדרות סריקה",
    automaticScan: "סריקה אוטומטית",
    manualScan: "סריקה ידנית",
    scanSpeed: "מהירות סריקה",
    rowAndColumn: "שורות ועמודות",
    cellByCell: "תא אחר תא",
    
    // New SRS scanning/cursor settings (dwellTime, dwellTimeDesc, etc. - unique keys)
    dwellTime: "זמן שהייה",
    dwellTimeDesc: "כמה זמן להישאר על פריט לפני בחירה",
    seconds: "שניות",
    firstItemDelay: "השהיית תא ראשון",
    firstItemDelayDesc: "השהייה נוספת בכניסה לקבוצה חדשה",
    offSetting: "כבוי",
    normalSetting: "רגיל",
    longSetting: "ארוך",
    cursorSettings: "הגדרות סמן",
    cursorMagnetism: "מגנטיות סמן",
    cursorMagnetismDesc: "משיכת הסמן לכפתורים",
    weakSetting: "חלש",
    strongSetting: "חזק",
    cursorSmoothingSetting: "החלקת סמן",
    cursorSmoothingDesc: "רמת יציבות תנועת הסמן",
    lowSetting: "נמוך",
    highSetting: "גבוה",
    
    // Head/Gaze Tracking
    headTrackingTitle: "מעקב ראש - הגדרות",
    gazeTrackingTitle: "מעקב מבט - הגדרות",
    mouthGesturesTitle: "תנועות פה - הגדרות",
    calibration: "כיול",
    startCalibration: "התחל כיול",
    calibrationComplete: "הכיול הושלם",
    lookAtPoint: "הסתכל על הנקודה",
    sensitivity: "רגישות",
    testTracking: "בדוק מעקב",
    finishSetup: "סיים הגדרה",
    
    // Mouth Gestures
    selectGestures: "בחר עד 3 תנועות שברצונך להשתמש בהן לשליטה",
    smile: "חיוך",
    smileDesc: "חייך רחב",
    openMouth: "פה פתוח",
    openMouthDesc: "פתח את הפה רחב",
    kiss: "נשיקה",
    kissDesc: "שפתיים מקופלות",
    
    // Voice Control
    voiceControlTitle: "שליטה קולית - הגדרות",
    wakeWord: "מילת הפעלה",
    voiceCommands: "פקודות קוליות",
    sayCommand: "אמור פקודה",
    
    // External Switch
    externalSwitchTitle: "מתגים חיצוניים - הגדרות",
    switchCount: "מספר מתגים",
    assignActions: "הקצה פעולות",
    pressSwitch: "לחץ על מתג",
    pressSwitchFemale: "לחצי על מתג",
    switchLabel: "מתג",
    switchesLabel: "מתגים",
    switch1Desc: "מתג אחד - בחירה בלבד (סריקה אוטומטית)",
    switch2Desc: "שני מתגים - בחירה וחזרה",
    switch3Desc: "שלושה מתגים - בחירה, הבא, חזרה",
    switch4Desc: "ארבעה מתגים - בחירה, הבא, הקודם וחזרה",
    switch5Desc: "חמישה מתגים - ניווט כיוונים מלא",
    selectSwitchCountMale: "בחר מספר מתגים:",
    selectSwitchCountFemale: "בחרי מספר מתגים:",
    scanType: "סוג סריקה",
    automaticScanType: "אוטומטית",
    manualScanType: "ידנית",
    cursorMovesAutoSelect: "הסמן זז אוטומטית, לחיצה לבחירה",
    cursorMovesOnPress: "הסמן זז רק בלחיצה על מתג",
    recordSwitchInputMale: "לחץ על כל מתג כדי להקליט את הקלט שלו",
    recordSwitchInputFemale: "לחצי על כל מתג כדי להקליט את הקלט שלו",
    testSwitchInputMale: "לחץ על כל מתג כדי לוודא שהמערכת מזהה אותו",
    testSwitchInputFemale: "לחצי על כל מתג כדי לוודא שהמערכת מזהה אותו",
    recorded: "מוקלט",
    pressToRecordMale: "לחץ על המתג...",
    pressToRecordFemale: "לחצי על המתג...",
    allSwitchesConfigured: "כל המתגים הוגדרו בהצלחה!",
    selectAction: "בחירה",
    cancelAction: "ביטול",
    nextAction: "הבא",
    previousAction: "הקודם",
    backAction: "חזרה",
    upAction: "למעלה",
    downAction: "למטה",
    leftAction: "שמאלה",
    rightAction: "ימינה",
    
    // Action Mapping
    actionMappingTitle: "מיפוי פעולות",
    clickGestureToChangeMale: "לחץ על מחווה כדי לשנות אותה:",
    clickGestureToChangeFemale: "לחצי על מחווה כדי לשנות אותה:",
    selectGesturePrompt: "בחר מחווה",
    blinkGesture: "מצמוץ / סגירת עיניים",
    blinkGestureShort: "מצמוץ",
    lookUpGesture: "מבט למעלה (למעלה)",
    lookUpGestureShort: "מבט למעלה",
    lookDownGesture: "מבט למטה (למטה)",
    lookDownGestureShort: "מבט למטה",
    lookLeftGesture: "מבט שמאלה (שמאלה)",
    lookLeftGestureShort: "מבט שמאלה",
    lookRightGesture: "מבט ימינה (ימינה)",
    lookRightGestureShort: "מבט ימינה",
    selectEnter: "בחירה (אנטר)",
    fullDirectionalNav: "ניווט מרחבי מלא",
    fullDirectionalNavDesc: "ניווט חופשי בכל הכיוונים",
    advancedNav: "ניווט מתקדם",
    advancedNavDesc: "בחירה, הבא, הקודם וחזרה",
    manualScanNav: "סריקה ידנית",
    manualScanNavDesc: "בחירה, הבא וחזרה",
    autoScanWithCancel: "סריקה עם חזרה",
    autoScanWithCancelDesc: "סריקה אוטומטית עם אפשרות לחזרה",
    autoScanOnly: "סריקה אוטומטית",
    autoScanOnlyDesc: "הסריקה זזה אוטומטית, מחווה אחת לבחירה",
    
    // Head/Gaze Tracking Setup
    faceAndEyeDetection: "זיהוי פנים ועיניים",
    faceAndEyeDetectionDesc: "המערכת מזהה את הפנים והעיניים שלך. וודא שהפנים נמצאות במרכז המסך.",
    searchingForFace: "מחפש פנים...",
    tooClose: "קרוב מדי - התרחק מהמצלמה",
    tooFar: "רחוק מדי - התקרב למצלמה",
    distanceGood: "מרחק מצוין!",
    initializingTracking: "מאתחל מעקב...",
    eyePointsMarkedCyan: "נקודות העיניים מסומנות בצבע תכלת",
    foundPreviousCalibration: "נמצא כיול קודם - ניתן להשתמש בו או לכייל מחדש",
    usePreviousCalibration: "השתמש בכיול הקודם",
    recalibrate: "כייל מחדש",
    foundPreviousSetup: "נמצאה הגדרה קודמת - ניתן להתחיל מיד או להגדיר מחדש",
    startImmediately: "התחל מיד",
    setupAgain: "הגדר מחדש",
    testGazeTracking: "בדיקת מעקב מבט",
    lookAtContinueButton: "הסתכל על כפתור \"המשך\" כדי להפעיל אותו",
    excellentClickToContinue: "מצוין! לחץ להמשך",
    gazeTrackingActiveTitle: "מצב מבט פעיל",
    gazeTrackingReadyDesc: "המערכת מוכנה! הסמן יעקוב אחר המבט שלך. עצור על אלמנט כדי לבחור בו.",
    testButton: "כפתור",
    cameraErrorCannotAccess: "לא ניתן לגשת למצלמה - וודא שהמצלמה מחוברת ושיש הרשאה",
    videoElementError: "שגיאה בגישה לאלמנט וידאו",
    faceModelLoadError: "שגיאה בטעינת מודל זיהוי פנים",
    
    // Mouth Gesture Setup
    neutralCalibration: "כיול מצב רגוע",
    neutralCalibrationDesc: "הרפה את הפנים במצב טבעי",
    gestureCalibration: "כיול מחווה",
    performGesture: "בצע את המחווה",
    gestureTestTitle: "בדיקת מחוות",
    testGesturesDesc: "בצע את המחוות שבחרת כדי לוודא שהמערכת מזהה אותן",
    allGesturesTestedSuccess: "כל המחוות נבדקו בהצלחה!",
    gesture1Desc: "מחווה אחת - בחירה בלבד (סריקה אוטומטית)",
    gesture2Desc: "שתי מחוות - בחירה וחזרה",
    gesture3Desc: "שלוש מחוות - בחירה, הבא, וחזרה",
    
    // Voice Control Setup
    voiceControlSetupTitle: "שליטה קולית",
    voiceControlTestTitle: "בדיקת שליטה קולית",
    voiceControlExplanation: "כל כפתור במסך יציג מספר לידו. פשוט אמור את המספר כדי ללחוץ על הכפתור.",
    voiceControlExplanationFemale: "כל כפתור במסך יציג מספר לידו. פשוט אמרי את המספר כדי ללחוץ על הכפתור.",
    voiceControlExample: 'לדוגמה: אמור "1" כדי ללחוץ על הכפתור הראשון',
    voiceControlExampleFemale: 'לדוגמה: אמרי "1" כדי ללחוץ על הכפתור הראשון',
    voiceControlWakeWord: 'מילת השכמה: "אייקונטרול"',
    voiceControlWakeWordDesc: 'אמור "אייקונטרול" כדי להשהות או להפעיל מחדש את ההאזנה. כשההאזנה מושהית, המספרים יעלמו מהמסך.',
    voiceControlWakeWordDescFemale: 'אמרי "אייקונטרול" כדי להשהות או להפעיל מחדש את ההאזנה. כשההאזנה מושהית, המספרים יעלמו מהמסך.',
    voiceControlSubtitle: "כך תשלוט באפליקציה בקול",
    nowYourTurn: "עכשיו תורך!",
    sayTheNumber: "אמור את המספר שמופיע ליד הכפתור הירוק",
    sayTheNumberFemale: "אמרי את המספר שמופיע ליד הכפתור הירוק",
    youSaid: "אמרת:",
    listeningActive: "מקשיב...",
    clickToStart: "לחץ להתחלה",
    startTest: "התחל בדיקה",
    successes: "הצלחות:",
    buttonLabel: "כפתור",
    
    // Head Tracking Setup
    headTrackingSetupTitle: "מעקב ראש",
    faceDetectionTitle: "זיהוי פנים",
    faceDetectionDesc: "המערכת מזהה את הפנים שלך. וודא שהפנים נמצאות במרכז המסך.",
    trackingTestTitle: "בדיקת מעקב",
    trackingTestDesc: "הזז את הראש כדי להגיע עם הנקודה לכפתור \"המשך\"",
    cursorActiveTitle: "מצב סמן פעיל",
    cursorActiveDesc: "המערכת מוכנה! הסמן יעקוב אחר תנועות הראש שלך. עצור על אלמנט כדי לבחור בו.",
    
    // Gaze Tracking Setup
    gazeTrackingSetupTitle: "מעקב מבט",
    gazeTestDesc: "הסתכל על כפתור \"המשך\" כדי להפעיל אותו",
    gazeActiveTitle: "מצב מבט פעיל",
    gazeActiveDesc: "המערכת מוכנה! הסמן יעקוב אחר המבט שלך. עצור על אלמנט כדי לבחור בו.",
    
    // Mouth Gesture Setup (additional)
    mouthGestureSetupTitle: "הגדרת תנועות פה",
    selectUpTo3Gestures: "בחר עד 3 מחוות שברצונך להשתמש בהן לשליטה",
    selectUpTo3GesturesFemale: "בחרי עד 3 מחוות שברצונך להשתמש בהן לשליטה",
    actionMapping: "מיפוי פעולות",
    selectActionForGesture: "בחר מה כל מחווה תבצע",
    selectActionForGestureFemale: "בחרי מה כל מחווה תבצע",
    scanSettingsTitle: "הגדרות סריקה",
    scanModeLabel: "מצב סריקה:",
    manualScanning: "סריקה ידנית",
    gesture3ManualDesc: "3 מחוות - אתה מזיז את הסמן קדימה ואחורה",
    gesture2AutoDesc: "2 מחוות - הסריקה זזה אוטומטית, מחווה לבחירה ומחווה לחזרה",
    gesture1AutoDesc: "מחווה אחת - הסריקה זזה אוטומטית, מחווה לבחירה בלבד",
    scanCellsMode: "תאים",
    rowsAndColumns: "שורות ועמודות",
    scanSpeedSeconds: "מהירות סריקה: {0} שניות",
    usePreviousCalibrationOption: "נמצא כיול קודם - ניתן להשתמש בו או לכייל מחדש",
    usePreviousBtn: "השתמש בכיול הקודם",
    recalibrateBtn: "כייל מחדש",
    neutralCalibrationTitle: "כיול - פנים רפויות",
    keepFaceRelaxed: "שמור על פנים רפויות ופה סגור. לחץ על הכפתור ללכידה.",
    keepFaceRelaxedFemale: "שמרי על פנים רפויות ופה סגור. לחצי על הכפתור ללכידה.",
    faceDetected: "פנים זוהו ✓",
    faceNotDetected: "לא זוהו פנים",
    capturing: "מצלם...",
    capture: "לכידה",
    gestureCalibrationTitle: "כיול - {0}",
    performGestureDesc: "בצע את המחווה: {0}",
    performGestureDescFemale: "בצעי את המחווה: {0}",
    gestureTestDesc: "בצע כל מחווה כדי לוודא שהמערכת מזהה אותה",
    gestureTestDescFemale: "בצעי כל מחווה כדי לוודא שהמערכת מזהה אותה",
    neutralState: "רגיל",
    allGesturesDetected: "כל המחוות זוהו בהצלחה!",
    setupComplete: "ההגדרה הושלמה!",
    gesturesCalibrated: "תנועות הפה שלך כוילו בהצלחה. כעת תוכל להשתמש בהן לשליטה באפליקציה.",
    gesturesCalibratedFemale: "תנועות הפה שלך כוילו בהצלחה. כעת תוכלי להשתמש בהן לשליטה באפליקציה.",
    configStage: "הגדרות",
    calibrateStage: "כיול",
    calibrateGestureStage: "כיול מחוות",
    testStage: "בדיקה",
    completeStage: "סיום",
    
    // External Switch Setup
    switchSetupTitle: "הגדרת מתגים",
    recordingSwitchesTitle: "הקלטת מתגים",
    testingSwitchesTitle: "בדיקת מתגים",
    stageXOfY: "שלב {0} מתוך {1}",
    pressSwitchToRecord: "לחץ על כל מתג כדי להקליט את הקלט שלו",
    pressSwitchToRecordFemale: "לחצי על כל מתג כדי להקליט את הקלט שלו",
    recordedLabel: "מוקלט: {0}",
    pressSwitchPrompt: "לחץ על המתג...",
    pressSwitchPromptFemale: "לחצי על המתג...",
    pressSwitchToTest: "לחץ על כל מתג כדי לוודא שהמערכת מזהה אותו",
    pressSwitchToTestFemale: "לחצי על כל מתג כדי לוודא שהמערכת מזהה אותו",
    allSwitchesRecognized: "מצוין! כל המתגים זוהו בהצלחה",
    
    // Additional switch setup keys
    performEachGestureToTest: "בצע כל מחווה כדי לוודא שהמערכת מזהה אותה",
    performEachGestureToTestFemale: "בצעי כל מחווה כדי לוודא שהמערכת מזהה אותה",
    
    // General UI
    loading: "טוען...",
    error: "שגיאה",
    retry: "נסה שוב",
    cancel: "ביטול",
    confirm: "אישור",
    edit: "ערוך",
    add: "הוסף",
    remove: "הסר",
    next: "הבא",
    previous: "הקודם",
    finish: "סיים",
    continue: "המשך",
    skip: "דלג",
    select: "בחר",
    selected: "נבחר",
    copied: "הועתק!",
    textCopied: "הטקסט הועתק ללוח",
    copyError: "לא ניתן להעתיק",
    typeHere: "הקלד כאן...",
    keyboardTitle: "מקלדת",
    readAloudBtn: "הקרא",
    copyBtn: "העתק",
    
    // Camera/Tracking Errors
    cameraError: "לא ניתן לגשת למצלמה - וודא שהמצלמה מחוברת ושיש הרשאה",
    videoError: "שגיאה בגישה לאלמנט וידאו",
    faceModelError: "שגיאה בטעינת מודל זיהוי פנים",
    searchingFace: "מחפש פנים...",
    
    // Guide
    guideTitle: "מדריך למשתמש",
    guideIntro: "ברוכים הבאים למדריך המשתמש של EyeControl App",
    guideIntroDesc: "EyeControl App היא מערכת תקשורת חלופית ומתקדמת (AAC) המיועדת לאנשים עם מוגבלויות תקשורת ומוטוריות. המדריך הזה יעזור לך להכיר את כל הפונקציות במערכת.",
    
    // Guide sections
    guideControlMethods: "שליטה",
    guideControlMethodsDesc: "המערכת מיועדת לשליטה על ידי EyeControl ומאפשרת שימוש גם ע\"י מתגים או עכבר/מגע",
    guideControlEyeControl: "מכשיר EyeControl - מכשיר תקשורת מבוסס מחוות עיניים לשליטה מלאה במערכת. \nניתן לבחור בין 1–5 מחוות עיניים (כגון עצימה, מבט מעלה, מטה, ימינה ושמאלה). 4 תנועות עיניים ומעלה מפעילות מצב שליטה ידנית- כל תנועה מבצעת פעולה ספציפית. עד 3 תנועות מפעילות סריקה אוטומטית- המערכת עוברת בין פריטים בקצב שניתן לכוונון. ניתן להגדיר מהירות סריקה בהגדרות.",
    guideControlTouch: "מגע/עכבר - שליטה סטנדרטית בנגיעה או לחיצת עכבר",
    guideControlHead: "מעקב ראש - שליטה בסמן על ידי הזזת הראש. המצלמה עוקבת אחר תנועות הראש",
    guideControlGaze: "מעקב מבט - שליטה בסמן באמצעות תנועות עיניים עם כיול 9 נקודות",
    guideControlMouth: "תנועות פה - שליטה בסריקה באמצעות חיוך, פתיחת פה או נשיקה",
    guideControlSwitch: "מתגים חיצוניים - חיבור של 1-5 מתגים פיזיים לשליטה בסריקה",
    guideControlVoice: "שליטה קולית - מתן פקודות קוליות לניווט ובחירה",
    
    guideCommunication: "תקשורת",
    guideCommunicationDesc: "כלי תקשורת מתקדמים:",
    guideCommBoard: "לוח תקשורת - מכיל מילים וקטגוריות, וניתן לעריכה והתאמה אישית. לאחר בניית מסר- ניתן להשמיע אותו לצורך דיבור או לשלוח לאנשי קשר שמורים במערכת.",
    guideCommAAC: "מקלדת AAC - הקלדה עם השלמת מילים חכמה ואימוגים. לאחר בניית מסר ניתן להשמיע אותו או לשלוח לאנשי קשר שמורים במערכת.",
    guideCommAI: "צ'אט AI - שיחה עם עוזר AI חכם לעזרה בניסוח הודעות",
    guideCommContacts: "קשר מרחוק- ניתן לשמור אנשי קשר במערכת דרך תפריט > אנשי קשר. באמצעות המקלדת ולוח התקשורת ניתן לשלוח מסרים שיגיעו לטלפון האישי של אנשי הקשר שנשמרו.",
    guideCommHelp: "קריאה לעזרה - כפתור המשמיע קריאה לעזרה ומאפשר לבחור מה קרה. ניתן להגדיר אנשי קשר אליהם נשלחת הקריאה לטלפון האישי.",
    guideCommTranslator: "תרגום דיבור - ניתן לבחור את שפת הדיבור בה יושמעו המסרים. ניתן לשנות זאת בכל רגע דרך התפריט > הגדרות > קול ושמע.",

    guideContacts: "אנשי קשר",
    guideContactsDesc: "קשר מרחוק עם אנשי הקשר של המשתמש",
    guideContactsItem0: "ניתן לשמור אנשי קשר של המשתמש לשליחת הודעות מהמערכת",
    guideContactsItem1: "דרך התפריט, אנשי קשר יכולים לסרוק קוד מהטלפון ולאשר קבלת הודעות מהמשתמש, המגיעות כהתראה לטלפון",
    guideContactsItem2: "ניתן לבחור את סוג ההתראות: הכל (כולל קריאה לעזרה) — או רק הודעות רגילות לשמירה על קשר",
    guideContactsItem3: "אנשי הקשר יקבלו התראות בהתאם להודעות שהמשתמש שולח",
    guideContactsItem4: "אם מופעלת קבלת קריאה לעזרה — תישלח התראה מיידית כאשר המשתמש לוחץ על כפתור העזרה",

    guideMedia: "מדיה ובידור",
    guideMediaDesc: "יוטיוב, רדיו ומוזיקה ישירות מהמערכת:",
    guideMediaYT: "יוטיוב - חיפוש וצפייה בסרטונים ישירות באפליקציה",
    guideMediaTV: "טלוויזיה - צפייה בערוצי IPTV מישראל ומהעולם",
    guideMediaRadio: "רדיו - האזנה לתחנות רדיו לפי מדינה או ז'אנר",
    guideMediaSpotify: "ספוטיפיי - חיבור לחשבון פרטי ושימוש נגיש מתוך המערכת.",
    guideMediaGames: "משחקים - משחקי זיכרון, איקס-עיגול ופאזלים",
    
    guideSmartHome: "בית חכם",
    guideSmartHomeDesc: "שליטה במכשירים חכמים בבית:",
    guideSmartLights: "תאורה - שליטה בנורות Philips Hue",
    guideSmartHA: "Home Assistant - חיבור למערכת Home Assistant",
    guideSmartWebhook: "Webhooks - כפתורים מותאמים לפעולות Make/Zapier/IFTTT",
    
    guideSettings: "הגדרות",
    guideSettingsDesc: "התאמת המערכת לצרכים האישיים:",
    guideSettingsAppearance: "מראה - מצב כהה/בהיר, גודל גופן",
    guideSettingsVoice: "קול ושמע- בחירת קול גברי/נשי, מהירות דיבור, שפת דיבור",
    guideSettingsProfile: "פרופיל - שם, שפה, סגנון פנייה",
    guideSettingsControl: "שליטה - הגדרת שיטת השליטה המועדפת",
    guideSettingsBoards: "עריכת לוחות – התאמה אישית של התוכן והמסכים השונים במערכת למשתמש. מסך הבית והבידור- קביעת התכנים שיופיעו והסידור המרחבי שלהם. קריאה לעזרה- עריכת המסרים המופיעים לאחר קריאה לעזרה (\"מה קרה\"). לוח התקשורת- עריכת מסרים, אלמנטים ויזואליים והסידור המרחבי שלהם. מקלדת- עריכת פעולות נלוות.",
    
    guideAccessibility: "נגישות",
    guideAccessibilityDesc: "תכונות נגישות מתקדמות:",
    guideAccessScanning: "סריקה - סריקה אוטומטית או ידנית של אלמנטים על המסך",
    guideAccessDwell: "השהייה בעת שימוש עם מצלמת מיקוד מבט - לחיצה אוטומטית לאחר השהייה על אלמנט",
    guideAccessHelp: "כפתור עזרה - התראה קולית או צליל לקריאה לעזרה",
    guideAccessRest: "מצב מנוחה - מסך כהה להפסקה מהמערכת",
    
    guideTips: "טיפים",
    guideTipsDesc: "טיפים לשימוש יעיל:",
    guideTip1: "מומלץ להתחיל עם שיטת השליטה הפשוטה ביותר ולהתקדם בהדרגה",
    guideTip2: "כדאי להתאים את מהירות הסריקה ורגישות המעקב לנוחות מקסימלית",
    guideTip3: "ניתן להוסיף מילים נפוצות ללוח התקשורת דרך עריכת לוחות > עריכת לוח תקשורת",
    guideTip4: "שימוש בלוחות תקשורת לנושאים או סיוטאציות מסוימות, כגון פגישה או ארוחה",
    guideTip5: "ניתן לבנות לוח תקשורת מותאם אישית לנושאים ספציפיים ויומיומיים דרך עריכת לוחות > עריכת לוח תקשורת",
    
    // Auth
    login: "התחברות",
    signup: "הרשמה",
    loginToAccount: "התחבר לחשבון שלך",
    createAccount: "צרו חשבון חדש",
    emailLabel: "אימייל",
    passwordLabel: "סיסמה",
    invalidEmail: "כתובת אימייל לא תקינה",
    passwordMinLength: "הסיסמה חייבת להכיל לפחות 6 תווים",
    loginSuccess: "התחברת בהצלחה",
    welcomeBack: "ברוך הבא!",
    signupSuccess: "נרשמת בהצלחה",
    checkEmail: "נשלח אליך אימייל לאימות. אנא בדוק את תיבת הדואר שלך.",
    authError: "אירעה שגיאה",
    invalidCredentials: "אימייל או סיסמה שגויים",
    userExists: "המשתמש כבר רשום, נסה להתחבר",
    emailNotConfirmed: "יש לאשר את האימייל לפני התחברות",
    passwordBreached: "הסיסמה שהזנת נמצאה ברשימת סיסמאות שדלפו באינטרנט. למען אבטחת חשבונך, אנא בחר סיסמה אחרת וייחודית.",
    googleSignInError: "אירעה שגיאה בהתחברות עם Google",
    or: "או",
    noAccount: "אין לך חשבון?",
    haveAccount: "יש לך חשבון?",
    forgotPassword: "שכחת סיסמה?",
    resetPassword: "איפוס סיסמה",
    resetEmailSent: "נשלח בהצלחה",
    resetEmailDesc: "נשלח אליך אימייל עם קישור לאיפוס הסיסמה",
    resetError: "אירעה שגיאה בשליחת האימייל, נסה שוב",
    sendResetEmail: "שלח קישור",
    backToLogin: "חזור להתחברות",
    invalidResetLink: "קישור איפוס הסיסמה אינו תקין או פג תוקפו",
    passwordsDoNotMatch: "הסיסמאות אינן תואמות",
    passwordResetSuccess: "הסיסמה עודכנה בהצלחה",
    passwordResetSuccessDesc: "כעת ניתן להתחבר עם הסיסמה החדשה",
    newPassword: "סיסמה חדשה",
    confirmNewPassword: "אישור סיסמה חדשה",
    setNewPassword: "הגדר סיסמה חדשה",
    
    // MFA
    twoFactorAuth: "אימות דו-שלבי",
    enterAuthCode: "הזן את הקוד מאפליקציית האימות שלך",
    verificationCode: "קוד אימות",
    verifyAndLogin: "אמת והתחבר",
    mfaCodeError: "קוד האימות חייב להכיל 6 ספרות",
    mfaCodeWrong: "קוד האימות שגוי, נסה שוב",
    
    // Email Verification
    verifyingEmail: "מאמת את כתובת המייל...",
    pleaseWait: "אנא המתן",
    emailVerified: "המייל אומת בהצלחה!",
    emailVerifiedDesc: "כתובת המייל {email} אומתה. כעת ניתן להתחבר.",
    goToLogin: "מעבר להתחברות",
    tokenExpired: "הקישור פג תוקף",
    tokenExpiredDesc: "קישור האימות פג תוקף. אנא הירשם מחדש.",
    backToSignup: "חזרה להרשמה",
    verificationFailed: "האימות נכשל",
    verificationFailedDesc: "הקישור אינו תקין או שכבר השתמשת בו.",
    
    myVoice: "הקול שלי",
    voiceCloning: "שכפול קול",
    voiceCloningDesc: "צרו קול מותאם אישית מההקלטה שלך",
    
    // Night Monitoring
    nightMonitoringTitle: "ניטור לילה",
    nightMonitoringDesc: "התראה למטפל כשהמשתמש ער בלילה",
    nightMonitoringEyeControlOnly: "ניטור לילה זמין רק במצב אייקונטרול",
    nightCaregiverEmail: "אימייל המטפל/ת",
    nightCaregiverEmailDesc: "ההתראות יישלחו לכתובת זו",
    nightHoursRange: "טווח שעות לילה",
    startTime: "שעת התחלה",
    endTime: "שעת סיום",
    awakeDurationThreshold: "זמן ערות להתראה",
    awakeDurationDesc: "אם המשתמש/ת ער/ה ליותר מזמן זה, תישלח התראה",
    minutes: "דקות",
    howItWorks: "איך זה עובד?",
    nightMonitoringInfo1: "כשהמשתמש ישן, האייקונטרול שולח סיגנל Enter רציף",
    nightMonitoringInfo2: "כשהסיגנל נפסק לזמן ממושך, המערכת מזהה ערות",
    nightMonitoringInfo3: "אחרי הזמן שהוגדר, נשלחת התראה למטפל",
    cloneAgain: "שכפל מחדש",
    cloneVoice: "שכפל קול",
    
    // User Contacts
    caregiverAlerts: "אנשי קשר",
    userContactsDescription: "אנשי קשר שהמשתמש יכול לשלוח אליהם הודעות לשמירה על קשר וקריאה לעזרה בעת הצורך.",
    addContact: "הוספת איש קשר",
    savedContacts: "אנשי קשר שמורים",
    caregiverQRTitle: "חיבור מכשיר מטפל",
    caregiverQRDesc: "סרקו לחיבור מכשיר טלפון",
    caregiverQRInstructions: "סריקת הקוד מאפשרת קבלת הודעות מהמשתמש כהתראות Push לטלפון האישי, גם כאשר הדפדפן סגור. ניתן להגדיר קבלת הודעות רגילות ו/או התראות קריאה לעזרה.",
    linkCopied: "הקישור הועתק!",
    copyFailed: "לא הצלחנו להעתיק",
    copyLink: "העתק קישור",
    connectedCaregivers: "אנשי קשר שמורים",
    noCaregiversConnected: "אין אנשי קשר מחוברים עדיין",
    caregiverRemoved: "המכשיר הוסר בהצלחה",
    removeError: "שגיאה בהסרת המכשיר",
    unknownDevice: "מכשיר לא ידוע",
    confirmDeleteCaregiver: "מחיקת איש קשר",
    confirmDeleteCaregiverDesc: "איש הקשר לא יקבל יותר עדכונים לטלפון. אפשר תמיד לחבר אותו מחדש דרך ההגדרות.",
    recentlyConnected: "חובר לאחרונה",
    loginRequired: "יש להתחבר כדי לצפות בקוד QR",
    howPushAlertsWork: "איך זה עובד?",
    pushAlertInfo1: "אנשי קשר סורקים את הקוד או נכנסים לקישור מהטלפון.",
    pushAlertInfo2: "מאשרים קבלת התראות בדפדפן שלהם.",
    pushAlertInfo3: "בוחרים את סוג ההתראות: הכל (כולל קריאה לעזרה) או רק הודעות רגילות לשמירה על קשר.",
    pushAlertInfo4: "מקבלים הודעות מהמשתמש בהתאם לשליחה שלו, כהתראה לטלפון האישי.",
    pushAlertInfo5: "אם מוגדרת קבלת קריאה לעזרה- מקבלים התראה מיידית כשהמשתמש לוחץ על כפתור העזרה.",
    sendTestNotification: "שלח התראת בדיקה",
    testNotificationSent: "התראת בדיקה נשלחה בהצלחה!",
    testNotificationFailed: "שגיאה בשליחת התראת בדיקה",
    noCaregiversToNotify: "אין מטפלים מחוברים לשליחת התראה",
    qrExpiresAt: "תוקף עד:",
    qrExpired: "הקוד פג תוקף",
    refresh: "רענן",
    qrAutoRefreshing: "מרענן את קוד ה-QR אוטומטית...",
    messagesOnly: "הודעות בלבד",
    allAlerts: "הכל",
    notificationTypeAll: "הכל (כולל קריאה לעזרה)",
    notificationTypeMessagesOnly: "הודעות רגילות בלבד",
    qrAutoRefreshed: "קוד ה-QR רוענן בהצלחה",
    refreshQR: "רענן קוד",
    enterCodeAt: "באתר",
    generateNewQR: "צור QR חדש",
    orEnterCode: "או הקלידו קוד:",
    iphoneCodeInstruction: "למשתמשי iPhone, הזינו את הקוד הבא לאחר ההתקנה-",
    allCaregiversRemoved: "כל המכשירים הוסרו בהצלחה",
    clearAllCaregivers: "הסר את כל אנשי הקשר",
    pushNotConfigured: "התראות Push עדיין לא הוגדרו במערכת",
    clearError: "שגיאה בניקוי המכשירים",
    
    // Settings - Help Alert
    helpAlertSound: "צליל עזרה",
    helpAlertSoundDesc: "בחר מה יושמע בלחיצה על עזרה",
    voiceAlert: "קול",
    sirenAlert: "סירנה",
    beepAlert: "צפצוף",
    trainAlert: "קטר",
    
    // Settings - Security
    security: "אבטחה",
    twoFactorSetup: "אימות דו-שלבי (2FA)",
    twoFactorSetupDesc: "הוסף שכבת אבטחה נוספת לחשבון",
    setup2FA: "הגדר 2FA",
    auditLog: "יומן אבטחה",
    auditLogDesc: "פעולות אבטחה אחרונות בחשבון",
    noAuditLogs: "אין פעולות אבטחה להצגה",
    auditTokenRegister: "רישום מכשיר מטפל",
    auditEmailAlert: "התראת אימייל",
    auditPushAlert: "התראת Push",
    auditLinkGenerate: "יצירת קישור QR",
    
    // Sidebar
    main: "בית",
    disableTracking: "כבה מעקב",
    logout: "התנתק",
    
    // Smart Home page
    buttons: "כפתורים",
    hueTab: "Hue",
    haTab: "HA",
    settingsTab: "הגדרות",
    addButtonLabel: "הוסף כפתור",
    noLightsFound: "לא נמצאו מנורות",
    checkHueConnection: "וודא שהחיבור ל-Hue תקין",
    hueError: "שגיאה בטעינת מנורות Hue",
    lightTurnedOn: "המנורה הודלקה",
    lightTurnedOff: "המנורה כבתה",
    lightControlError: "שגיאה בשליטה במנורה",
    brightnessError: "שגיאה בהגדרת בהירות",
    haError: "שגיאה בטעינת Home Assistant",
    noHAEntities: "לא נמצאו התקנים",
    checkHAConnection: "וודא שהחיבור ל-Home Assistant תקין",
    actionCompleted: "הפעולה בוצעה",
    deviceControlError: "שגיאה בשליטה בהתקן",
    buttonTriggered: "הופעל!",
    buttonTriggerError: "שגיאה בהפעלת הכפתור",
    buttonUpdated: "הכפתור עודכן",
    buttonAdded: "הכפתור נוסף",
    buttonDeleted: "הכפתור נמחק",
    fillNameAndUrl: "נא למלא שם וכתובת webhook",
    editButton: "ערוך כפתור",
    newButton: "כפתור חדש",
    iconLabel: "אייקון",
    colorLabel: "צבע",
    methodLabel: "שיטה",
    saveChanges: "שמור שינויים",
    
    // Smart Home Settings
    smartHomeEnabled: "מופעל - הגדר במסך הבית החכם",
    smartHomeDisabled: "הפעל כדי לשלוט בבית החכם",
    philipsHueSettings: "הגדרות Philips Hue",
    bridgeIP: "כתובת IP של הגשר",
    hueUsername: "שם משתמש",
    hueInstructions: "לחץ על כפתור הגשר ולאחר מכן לחץ 'חבר'",
    connect: "חבר",
    homeAssistantSettings: "הגדרות Home Assistant",
    serverUrl: "כתובת השרת",
    accessToken: "Access Token",
    
    // Button icons
    iconPower: "הפעלה",
    iconLamp: "מנורה",
    iconSun: "שמש",
    iconMoon: "ירח",
    iconHome: "בית",
    iconPlay: "הפעל",
    
    // Colors
    colorTeal: "טורקיז",
    colorOrange: "כתום",
    colorBlue: "כחול",
    colorGreen: "ירוק",
    colorPurple: "סגול",
    colorPink: "ורוד",
    colorYellow: "צהוב",
    colorRed: "אדום",
    
    // Translator page
    realtimeTranslator: "מתרגם בזמן אמת",
    speaking: "מדברים",
    translation: "תרגום",
    pressToStart: "לחץ להתחיל",
    listening: "מאזין...",
    pressMicToSpeak: "לחץ על המיקרופון והתחל לדבר",
    speechRecognitionError: "שגיאה בזיהוי דיבור",
    allowMicAccess: "נא לאשר גישה למיקרופון בדפדפן",
    browserNotSupported: "הדפדפן לא תומך בזיהוי דיבור",
    translationError: "שגיאה בתרגום",
    
    // AI Chat page (additional)
    chatCleared: "השיחה נמחקה",
    helloImHere: "שלום! אני כאן לעזור",
    writeMessageBelow: "כתוב הודעה למטה ואני אענה לך",
    readAloud: "הקרא",
    sendMessageError: "שגיאה בשליחת ההודעה",
    
    // AAC Keyboard page
    aacKeyboardTitle: "מקלדת AAC",
    aacTip: "טיפ:",
    aacTipText: "במצב ראשי תיבות, הקלד את האות הראשונה של כל מילה",
    aacExample: 'לדוגמה: "מנ" = "מה נשמע" | "hay" = "how are you"',
    
    // YouTube page (additional)
    popular: "פופולרי",
    searchYoutube: "חיפוש ביוטיוב",
    typeToSearch: "הקלד מה לחפש...",
    popularVideos: "סרטונים פופולריים",
    homePage: "דף הבית",
    searchResults: "תוצאות חיפוש",
    recommendedVideos: "סרטונים מומלצים",
    watchHistory: "היסטוריית צפייה",
    searchError: "שגיאה בחיפוש",
    loginError: "שגיאה בהתחברות",
    loginToSearch: "התחבר כדי לחפש",
    googleSignInRequired: "נדרשת התחברות עם Google",
    signInWithGoogleToSearch: "התחבר עם Google כדי לחפש סרטונים ב-YouTube",
    signInWithGoogle: "התחבר עם Google",
    closeVideo: "סגור",
    muteVideo: "השתק",
    unmuteVideo: "בטל השתקה",
    skipForward: "10 שניות קדימה",
    skipBackward: "10 שניות אחורה",
    newSearch: "חיפוש חדש",
    pauseVideo: "השהה",
    playVideo: "נגן",
    timesWatched: "צפיות",
    loginToWatch: "התחברו עם גוגל כדי לצפות ביוטיוב",
    connectWithGoogle: "התחבר עם גוגל",
    noHistory: "אין היסטוריית צפייה",
    clearHistory: "נקה היסטוריה",
    historySaved: "הסרטון נשמר להיסטוריה",
    historyCleared: "היסטוריה נוקתה",
    linkGoogleAccount: "קישור חשבון Google",
    linkGoogleDescription: "האם תרצה להוסיף כניסה עם Google לחשבון שלך? זה יאפשר לך להתחבר עם אימייל או עם Google.",
    useGoogleOnlyForYouTube: "רק ליוטיוב",
    linkToMyAccount: "קשר לחשבון שלי",
    
    // Spotify page
    spotifyTitle: "ספוטיפיי",
    welcomeToSpotify: "ברוכים הבאים לספוטיפיי",
    connectToSpotify: "התחבר לחשבון הספוטיפיי שלך כדי לגשת לפליילסטים ולשירים שלך",
    loginToSpotify: "התחבר לספוטיפיי",
    spotifySetup: "הגדרת Spotify",
    spotifySetupDesc: "כדי להתחבר לספוטיפיי, יש ליצור אפליקציה ב-",
    enterClientId: "הזן Client ID",
    continueAndLogin: "המשך והתחבר",
    yourPlaylists: "הפליילסטים שלך",
    noPlaylistsFound: "לא נמצאו פליילסטים",
    songsCount: "שירים",
    disconnectSpotify: "התנתק",
    useArrowsHint: "השתמש בחצים ↑↓ לניווט בתפריט ו-Enter לבחירה",
    previousTrack: "שיר קודם",
    nextTrack: "שיר הבא",
    play: "נגן",
    pause: "השהה",
    connectingToPlayer: "מתחבר לנגן...",
    premiumRequired: "נדרש חשבון Premium לנגינה מלאה",
    
    // TV page (additional)
    selectChannel: "בחר ערוץ להתחלה",
    noChannelsFound: "לא נמצאו ערוצים",
    channelLoadError: "שגיאה בטעינת הערוצים",
    channelPlayError: "לא ניתן להפעיל את הערוץ",
    channelError: "שגיאה בהפעלת הערוץ",
    formatNotSupported: "הדפדפן לא תומך בפורמט זה",
    tryAgain: "נסה שוב",
    generalCategory: "כללי",
    israel: "ישראל",
    usa: "ארה״ב",
    russiaCountry: "רוסיה",
    saudiArabia: "ערב הסעודית",
    restOfWorld: "שאר העולם",
    fullscreen: "מסך מלא",
    exitFullscreen: "יציאה ממסך מלא",
    
    // Radio page (additional)
    genresLabel: "ז'אנרים",
    countriesLabel: "מדינות",
    noStationsFound: "לא נמצאו תחנות",
    playingNow: "מנגן עכשיו",
    pausedStatus: "מושהה",
    uk: "בריטניה",
    franceCountry: "צרפת",
    germanyCountry: "גרמניה",
    spainCountry: "ספרד",
    italyCountry: "איטליה",
    brazilCountry: "ברזיל",
    japanCountry: "יפן",
    indiaCountry: "הודו",
    greeceCountry: "יוון",
    turkeyCountry: "טורקיה",
    polandCountry: "פולין",
    popGenre: "פופ",
    rockGenre: "רוק",
    jazzGenre: "ג'אז",
    classicalGenre: "קלאסית",
    electronicGenre: "אלקטרונית",
    hiphopGenre: "היפ הופ",
    countryGenre: "קאנטרי",
    bluesGenre: "בלוז",
    reggaeGenre: "רגיי",
    ambientGenre: "רגוע",
    oldiesGenre: "נוסטלגיה",
    the80sGenre: "שנות ה-80",
    the90sGenre: "שנות ה-90",
    danceGenre: "דאנס",
    soulGenre: "סול",
    latinGenre: "לטינית",
    loungeGenre: "לאונג'",
    metalGenre: "מטאל",
    alternativeGenre: "אלטרנטיבי",
    chilloutGenre: "צ'יל אאוט",
    
    // Device check
    deviceNotSupported: "האפליקציה מיועדת לטאבלטים ומחשבים בתצוגה רוחבית",
    deviceNotSupportedDesc: "לחוויה מיטבית, השתמשו במכשיר עם מסך גדול או סובבו את המסך לרוחב (לנדסקייפ)",
    minScreenSize: "גודל מסך מינימלי: 10 אינץ'",
    
    // Voice control overlay
    listeningStatus: "מקשיב...",
    notListeningStatus: 'לא מקשיב - אמור "EyeControl" להפעלה',
    
    // Onboarding
    whichLanguage: "מהי שפת המשתמש?",
    whichLanguageFemale: "מהי שפת המשתמשת?",
    whichLanguageMale: "מהי שפת המשתמש?",
    canChangeInSettings: "ניתן לשנות את זה בהגדרות בכל עת",
    greatReadyFemale: "מעולה",
    greatReadyMale: "מעולה",
    greatReady: "מעולה",
    niceToMeet: "נעים להכיר!",
    labelName: "שם:",
    labelAddress: "פנייה:",
    labelLanguage: "שפה:",
    labelControlMethod: "אופן שליטה:",
    
    // Scanning action labels
    actionSelect: "בחירה",
    actionCancel: "ביטול",
    actionNext: "הבא",
    actionPrev: "הקודם",
    actionBack: "חזרה",
    actionUp: "למעלה",
    actionDown: "למטה",
    actionLeft: "שמאלה",
    actionRight: "ימינה",
    
    // Pricing page
    pricingTitle: "בחר את התוכנית שלך",
    pricingSubtitle: "7 ימי ניסיון חינם לכל תוכנית",
    monthly: "חודשי",
    yearly: "שנתי",
    yearlyDiscount: "(20% הנחה)",
    personal: "אישי",
    group: "קבוצתי",
    forTeams: "לצוותים",
    perMonth: "לחודש",
    perUserPerMonth: "למשתמש לחודש",
    minUsers: "5 משתמשים מינימום",
    users: "משתמשים",
    regularPrice: "מחיר רגיל:",
    salePrice: "מחיר מבצע:",
    startFreeTrial: "התחל ניסיון חינם",
    whatsIncluded: "מה כלול:",
    startWith7Days: "התחל עם 7 ימים חינם",
    blackFridaySale: "מבצע Black Friday",
    limitedTimeOffer: "הנחה מיוחדת לזמן מוגבל",
    featureEyeTracking: "מעקב עיניים מתקדם",
    featureCommBoard: "לוח תקשורת מלא",
    featureSmartTyping: "כתיבה מהירה חכמה",
    featureCaregiverMsg: "שליחת הודעות למטפל",
    featureTvYoutube: "גישה לטלוויזיה ויוטיוב",
    featureGames: "משחקים נגישים",
    featureSupport: "תמיכה טכנית מלאה",
    featureUpdates: "עדכונים אוטומטיים",

    // Onboarding (additional)
    welcomeToAyuni: "ברוכים הבאים ל-EyeControl App",
    aacAppDescription: "אפליקציית תקשורת חלופית ומשלימה",
    letsSetup: "בואו נגדיר כמה הגדרות כדי להתאים את המערכת",
    letsStart: "בואו נתחיל",
    whatIsYourName: "שם המשתמש במערכת",
    willUseForPersonal: "נשתמש בשם הזה לפנייה אישית",
    yourName: "שם המשתמש",
    howToAddress: "באיזו לשון לפנות למשתמש?",
    willUseForAddressing: "נשתמש בזה לפנייה מותאמת במערכת",
    genderFemale: "נקבה",
    genderFemaleDesc: "פנייה בלשון נקבה",
    genderMale: "זכר",
    genderMaleDesc: "פנייה בלשון זכר",
    genderNeutral: "ניטרלי",
    genderNeutralDesc: "פנייה ניטרלית",
    letsStartFemale: "בואי נתחיל!",
    letsStartMale: "בוא נתחיל!",
    letsStartNeutral: "בואו נתחיל!",
    backToEdit: "חזרה לעריכה",
    
    // Contacts page additional
    noEmailAddress: "אין כתובת אימייל",
    setEmailFirst: "יש להגדיר אימייל מטפל",
    messageFromAyuni: "הודעה מ-EyeControl App",
    noPhoneNumber: "אין מספר טלפון",
    setPhoneFirst: "יש להגדיר טלפון מטפל",
    errorTitle: "שגיאה",
    pleaseLoginFirst: "יש להתחבר קודם",
    notificationSent: "ההתראה נשלחה",
    sentToDevices: "נשלחה התראה ל-{0} מכשירים",
    scanQRInSettings: "סרקו את קוד ה-QR בהגדרות",
    failedToSendNotification: "לא הצלחנו לשלוח התראה",
    pushAlert: "התראת Push",
    emailSent: "המייל נשלח",
    messageSentTo: "ההודעה נשלחה ל-{email}",
    failedToSendEmail: "לא הצלחנו לשלוח את המייל",
    
    // Board Builder (unique additions)
    newBoard: "לוח חדש",
    boardUpdated: "הלוח עודכן בהצלחה!",
    boardSaved: "הלוח נשמר בהצלחה!",
    confirmBtn: "אישור",
    gridSize: "גודל רשת",
    cellsCount: "תאים",
    utterancesCount: "היגדים",
    saveBtn: "שמור",
    finishBtn: "סיום",
    
    // Help Alert
    iNeedHelpMale: "אני צריך עזרה!",
    iNeedHelpFemale: "אני צריכה עזרה!",
    closeBtn: "סגור",
    whatHappened: "מה קרה?",
    toCloseText: "לסגירה",
    
    // Emergency Board
    emergencyPainMale: "כואב לי",
    emergencyPainFemale: "כואב לי",
    emergencyCallCaregiver: "לקרוא למטפל",
    emergencyBreathing: "קשה לי לנשום",
    emergencyNotWellMale: "אני מרגיש לא טוב",
    emergencyNotWellFemale: "אני מרגישה לא טוב",
    emergencyBathroom: "שירותים",
    emergencyThirsty: "אני רוצה לשתות",
    emergencySuction: "צריך סאקשן",
    emergencyPosition: "שינוי תנוחה",
    addCard: "הוסף כרטיס",
    resetToDefault: "איפוס לברירת מחדל",
    undo: "ביטול",
    doneEditing: "סיום עריכה",
    editBtn: "עריכה",
    editItem: "עריכת פריט",
    addNewItem: "הוספת פריט חדש",
    textMale: "טקסט (זכר)",
    textFemale: "טקסט (נקבה)",
    emojiLabel: "אימוג'י",
    cancelBtn: "ביטול",
    theUser: "המשתמש",
    userSelected: "בחר/ה:",
    
    // Legal page
    legalInfo: "מידע משפטי",
    privacyPolicy: "מדיניות פרטיות",
    cookiesPolicy: "מדיניות עוגיות",
    termsAndConditions: "תנאי שימוש",
    refundPolicyTitle: "מדיניות החזרים",
    openSource: "קוד פתוח",
    openSourceAttribution: "Open Source Attribution",
    cookiesInUse: "עוגיות בשימוש",
    essentialCookies: "חיוניים",
    essentialDesc: "עוגיות הנדרשות לפעולה תקינה של האפליקציה",
    functionalCookies: "פונקציונליים",
    functionalDesc: "עוגיות המשפרות פונקציונליות והתאמה אישית",
    analyticsCookies: "אנליטיקה",
    analyticsDesc: "עוגיות לניתוח שימוש באפליקציה",
    notCurrentlyUsed: "לא בשימוש כרגע",
    userSettingsCookie: "שמירת העדפות והגדרות משתמש",
    cookieConsentCookie: "שמירת הסכמה לעוגיות",
    aacDictionaryCookie: "שמירת מילים וביטויים שנלמדו",
    communicationBoardsCookie: "שמירת לוחות תקשורת מותאמים",
    smartHomeSettingsCookie: "שמירת הגדרות בית חכם",
    ayuniUsesLibraries: "EyeControl App משתמשת בספריות הקוד הפתוח הבאות:",
    
    // Caregiver Connect Page
    caregiverConnectTitle: "חיבור איש קשר",
    caregiverConnectPatientLabel: "חיבור לחשבון של:",
    caregiverConnectDescription: "אישור קבלת התראות פוש למכשיר כדי לקבל הודעות מ{patientName}",
    caregiverConnectNotificationTypeTitle: "בחירת סוג התראות",
    caregiverConnectAllAlerts: "הכל (כולל קריאה לעזרה)",
    caregiverConnectMessagesOnly: "הודעות רגילות בלבד (לשמירה על קשר)",
    caregiverConnectEnterCodeInstruction: "הזינו את הקוד שמופיע על מסך המשתמש",
    caregiverConnectEnableButton: "אישור קבלת התראות",
    caregiverConnectDeviceNote: "תקבלו התראות למכשיר הזה",
    caregiverConnectContactNameLabel: "שם איש קשר",
    caregiverConnectContactNamePlaceholder: "לדוגמה: אמא, דויד המטפל",
    caregiverConnectContactNameHint: "תנו שם כדי שהמשתמש יוכל לזהות אתכם",
    caregiverConnectSuccess: "מחובר!",
    caregiverConnectSuccessDesc: "תקבלו התראות כאשר {patientName} ישלח הודעות.",
    caregiverConnectSuccessNote: "ניתן לסגור את העמוד. התראות יגיעו גם כשהדפדפן סגור.",
    caregiverConnectError: "החיבור נכשל",
    caregiverConnectTryAgain: "נסו שוב",
    caregiverConnectUnsupported: "לא נתמך",
    caregiverConnectUnsupportedDesc: "התראות פוש אינן נתמכות בדפדפן זה. נסו להשתמש ב-Chrome, Firefox או Edge במכשיר נייד או מחשב.",
    caregiverConnectInvalidLink: "קישור לא תקין",
    caregiverConnectInvalidLinkDesc: "קישור זה חסר מידע נדרש. סרקו קוד QR תקין מאפליקציית EyeControl App.",
    caregiverConnectRequestingPermission: "מגדיר התראות...",
    caregiverConnectPermissionDenied: "ההרשאה נדחתה או לא הצלחנו לקבל טוקן התראות. ודאו שהתראות מופעלות בהגדרות הדפדפן.",
    caregiverConnectContactNameRequired: "יש להזין שם",
    caregiverConnectMissingPatientId: "קישור לא תקין - מזהה משתמש חסר",
    
    // iOS PWA Install
    iosInstallRequired: "שלב ראשון: התקנת האפליקציה",
    iosInstallExplanation: "באייפון צריך קודם להוסיף את האפליקציה למסך הבית, ואז לפתוח אותה משם.",
    iosInstallSteps: "איך עושים את זה:",
    iosStep1Tap: "לחצו על",
    iosStep1Share: "(שיתוף) למטה",
    iosStep2Tap: "בחרו",
    iosStep2AddToHome: "הוסף למסך הבית",
    iosStep3Open: "פתחו את האפליקציה מהאייקון החדש",
    iosStep4EnterCode: "הזינו את הקוד שעל מסך המשתמש",
    iosInstallNote: "זה נדרש רק פעם אחת. אחרי ההתקנה ההתראות יעבדו אוטומטית.",
    enterCodePlaceholder: "הזינו קוד",
    aboutApp: "אודות אפליקציית EyeControl",
  },
  
  en: {
    // Navigation & Layout
    home: "Home",
    back: "Back",
    settings: "Settings",
    help: "Help",
    rest: "Rest",
    clock: "Clock",
    volume: "Volume",
    control: "Control",
    
    // Home page
    goodMorning: "Good morning",
    goodAfternoon: "Good afternoon",
    goodEvening: "Good evening",
    goodNight: "Good night",
    whatToDo: "What would you like to do today?",
    whatToDoMale: "What would you like to do today?",
    whatToDoFemale: "What would you like to do today?",
    quickSpeak: "Quick speak:",
    
    // Quick phrases
    hello: "Hello",
    thanks: "Thanks",
    yes: "Yes",
    no: "No",
    please: "Please",
    water: "Water",
    food: "Food",
    
    // Main actions
    communicationBoard: "Talker",
    contacts: "Contacts",
    games: "Games",
    youtube: "YouTube",
    spotify: "Spotify",
    keyboard: "Keyboard",
    keyboardShort: "Keyboard",
    translator: "Translator",
    history: "History",
    music: "Music",
    tv: "Television",
    radio: "Radio",
    calendar: "Calendar",
    news: "News",
    guide: "Guide",
    smartHome: "Smart Home",
    more: "More",
    aiChat: "AI Chat",
    aacKeyboard: "AAC Keyboard",
    entertainment: "Media",
    
    // Settings page
    settingsTitle: "Settings",
    appearance: "Appearance",
    darkMode: "Dark Mode",
    lightMode: "Light Mode",
    darkModeDesc: "Switch between dark and light display",
    fontSize: "Font Size",
    small: "Small",
    medium: "Medium",
    large: "Large",
    
    soundAndVoice: "Sound & Voice",
    muteAll: "Mute Sounds",
    muteAllDesc: "Turn off all sounds",
    voiceSelection: "Voice Selection",
    voiceSelectionDesc: "Choose between male and female voice",
    female: "Female",
    male: "Male",
    speechSpeed: "Speech Speed",
    speechLanguage: "Speech Language",
    speechLanguageDesc: "Voice output language (default: user language)",
    
    accessibility: "Accessibility",
    keyboardNav: "Keyboard Navigation",
    keyboardNavDesc: "Enable navigation with arrow keys",
    // Head tracking settings
    headTrackingRange: "Head Movement Range",
    headTrackingRangeDesc: "How much head movement is needed to reach screen edges",
    rangeWide: "More movement",
    rangeNarrow: "Less movement",
    // Gaze tracking settings
    gazeTrackingSmoothing: "Cursor Smoothing",
    gazeTrackingSmoothingDesc: "How smooth cursor movement is - slower = smoother",
    smoothingLow: "Precise (jittery)",
    smoothingHigh: "Smooth (slower)",
    
    // Status bar
    headTrackingActive: "Head Tracking Active",
    gazeTrackingActive: "Gaze Tracking Active",
    mouthGestureTrackingActive: "Mouth Gesture Tracking Active",
    cookies: "Cookies",
    cookieSettings: "Cookie Settings",
    
    profile: "Profile",
    profileMale: "User Profile",
    profileFemale: "User Profile",
    name: "Name",
    enterName: "Enter name",
    addressing: "Gender",
    neutral: "Neutral",
    language: "Language",
    hebrew: "עברית",
    english: "English",
    arabic: "العربية",
    russian: "Русский",
    
    // Contacts page
    contactsTitle: "Contacts",
    email: "Email",
    sms: "SMS",
    whatsapp: "WhatsApp",
    caregiverDetails: "Caregiver Details",
    phone: "Phone",
    notSet: "Not set",
    caregiverSettings: "Caregiver Settings",
    caregiverEmail: "Caregiver Email",
    pushNotificationsDescription: "To configure Push notifications for caregivers, go to Settings",
    goToSettings: "Go to Settings",
    save: "Save",
    savedSuccessfully: "Saved Successfully",
    caregiverUpdated: "Caregiver details updated",
    to: "To",
    toOptional: "To (optional - default: caregiver)",
    message: "Message",
    writeMessage: "Write your message...",
    noPhone: "No phone number",
    enterPhoneOrSet: "Please enter a phone number or set caregiver phone",
    noEmail: "No email address",
    enterEmailOrSet: "Please enter an email or set caregiver email",
    
    // Help alert
    needHelpMale: "I need help!",
    needHelpFemale: "I need help!",
    close: "Close",
    pressEnterToClose: "Press Enter to close",
    pressMale: "Press",
    pressFemale: "Press",
    toClose: "to close",
    emoji: "Emoji",
    cells: "cells",
    icon: "Icon",
    orChooseEmoji: "Or choose emoji",
    preview: "Preview",
    textMalePlaceholder: "e.g. I'm in pain",
    textFemalePlaceholder: "e.g. I'm in pain",
    openSourceDescription: "EyeControl App uses the following open source libraries:",
    cookiesInUseSubtitle: "Cookies in Use",
    notInUse: "Not currently in use",

    // Rest mode
    restMode: "Rest Mode",
    pressToWake: "to wake up",
    restModeDwellInstruction: "Hold your gaze on the circle for 3 seconds",
    restModeDwellInstructionMale: "Hold your gaze on the circle for 3 seconds",
    restModeDwellInstructionFemale: "Hold your gaze on the circle for 3 seconds",
    restModeSelectInstruction: "Perform a select action 3 times to exit",
    restModeSelectInstructionMale: "Perform a select action 3 times to exit",
    restModeSelectInstructionFemale: "Perform a select action 3 times to exit",
    restModeVoiceInstruction: "Say the number three times",
    restModeVoiceInstructionMale: "Say the number three times",
    restModeVoiceInstructionFemale: "Say the number three times",
    pressEscapeToWake: "You can press Escape for quick exit",
    mediaRestBlinkInstruction: "Blink 3 times to exit",
    mediaRestBlinkInstructionMale: "Blink 3 times to exit",
    mediaRestBlinkInstructionFemale: "Blink 3 times to exit",
    
    // Time info
    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    day: "",
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",
    loadingLocation: "Loading location...",
    locationUnavailable: "Location unavailable",
    unknownLocation: "Unknown location",
    locationError: "Error loading location",
    noLocationPermission: "No location permission",
    loadingWeather: "Loading weather...",
    weatherUnavailable: "Weather unavailable",
    
    // Volume
    volumeTitle: "Volume",
    veryLow: "Very Low",
    low: "Low",
    mediumVol: "Medium",
    high: "High",
    veryHigh: "Very High",
    navInstructions: "↑↓ Navigate • Enter to select",
    
    // Control Methods
    controlMethodsTitle: "App Control Method",
    controlMethodsTitleMale: "App Control Method",
    controlMethodsTitleFemale: "App Control Method",
    controlMethodsSubtitle: "Choose the method suitable for the user",
    controlMethodsSubtitleMale: "Choose the method suitable for the user",
    controlMethodsSubtitleFemale: "Choose the method suitable for the user",
    control_standard_pointer_title: "Touch / Mouse",
    control_standard_pointer_desc: "Standard touch or mouse control",
    control_voice_title: "Voice Control",
    control_voice_desc: "Control with voice commands",
    control_eye_control_title: "EyeControl Device",
    control_eye_control_desc: "Control with EyeControl device",
    control_external_switch_title: "External Switches",
    control_external_switch_desc: "Control with switches",
    control_gaze_tracking_title: "Gaze Tracking",
    control_gaze_tracking_desc: "Control with eye movements",
    control_head_tracking_title: "Head Tracking",
    control_head_tracking_desc: "Control with head movements",
    control_mouth_gestures_title: "Mouth Gestures",
    control_mouth_gestures_desc: "Control with mouth movements",
    controlSetup: "Control Setup",
    selectGesturesMale: "Gestures the user can perform",
    selectGesturesFemale: "Gestures the user can perform",
    lookUp: "Look Up",
    lookDown: "Look Down",
    lookLeft: "Look Left",
    lookRight: "Look Right",
    blink: "Blink",
    gesture1Desc: "One gesture - selection only (automatic scanning)",
    gesture2Desc: "Two gestures - selection and back",
    gesture3Desc: "Three gestures - selection, next, and back",
    continueButton: "Continue",
    previousButton: "Previous",
    nextButton: "Next",
    
    // AAC & Communication
    aacTitle: "AAC Keyboard",
    speak: "Speak",
    clear: "Clear",
    delete: "Delete",
    space: "Space",
    enter: "Enter",
    wordCompletion: "Word Completion",
    acronymMode: "Acronym Mode",
    suggestions: "Suggestions",
    recentWords: "Recent Words",
    addToDictionary: "Add to Dictionary",
    
    // Communication Board
    boardTitle: "Talker",
    editBoard: "Edit Board",
    editBoards: "Edit Boards",
    userContacts: "Contacts",
    userContactsTitle: "User Contacts",
    editHelpBoard: "Edit Help Board",
    editCommunicationBoard: "Edit Talker Board",
    editTopActionBar: "Edit Top Action Bar",
    addCategory: "Add Category",
    spatialNavigation: "Spatial Navigation",
    createBoard: "Create New Board",
    boardName: "Board Name",
    selectIcon: "Select Icon",
    selectColor: "Select Color",
    category: "Category",
    utterance: "Utterance",
    utterances: "utterances",
    rows: "Rows",
    columns: "Columns",
    deleteBoard: "Delete Board",
    saveBoard: "Save Board",
    boardDeleted: "Board deleted successfully",
    boardReset: "Board reset to default",
    resetBoard: "Reset Board",
    buildNewBoard: "Build New Board",
    items: "items",
    
    // Actions menu
    speakAction: "Speak",
    sendToContacts: "Send to Contacts",
    sendToAI: "Send to AI Chat",
    translateAction: "Translate",
    addToDict: "Add to Dictionary",
    
    // Communication Board (additional)
    immediateSpeak: "Immediate Speak",
    actionsScreen: "Actions Menu",
    modeHintSpeak: "Tap an item to speak it immediately",
    modeHintActions: "Tap an item to open actions menu",
    editBoardBtn: "Edit",
    deleteBoardBtn: "Delete",
    createNewBoardBtn: "Create New Board",
    cellScanning: "Cell Scanning",
    rowScanning: "Row Scanning",
    sentenceBuilderMode: "Sentence Builder Mode",
    speakSentence: "Speak",
    clearSentence: "Clear",
    deleteLastWord: "Delete Word",
    sentenceBarPlaceholderMale: "Tap words to build a sentence...",
    sentenceBarPlaceholderFemale: "Tap words to build a sentence...",
    
    // Translation
    translateTitle: "Translation",
    selectLanguage: "Select Language",
    translatedText: "Translated Text",
    speakTranslation: "Speak Translation",
    
    // AI Chat
    aiChatTitle: "Chat with AI",
    typeMessage: "Type a message...",
    sendMessage: "Send",
    clearChat: "Clear Chat",
    aiThinking: "AI is thinking...",
    
    // YouTube
    youtubeTitle: "YouTube",
    searchVideos: "Search videos",
    search: "Search",
    searchTab: "Search",
    noResults: "No results found",
    views: "views",
    
    // TV & Radio
    tvTitle: "Television",
    radioTitle: "Radio",
    selectCountry: "Select Country",
    selectGenre: "Select Genre",
    channels: "Channels",
    stations: "Stations",
    nowPlaying: "Now Playing",
    
    // Games
    gamesTitle: "Games",
    accessibleGameHub: "Accessible Game Hub",
    accessibleGameHubDesc: "Games adapted for all control methods",
    memoryGame: "Memory Game",
    memoryGameDesc: "Find matching pairs of cards",
    game2048: "2048",
    game2048Desc: "Merge tiles to reach 2048",
    slidingPuzzle: "Sliding Puzzle",
    slidingPuzzleDesc: "Solve the puzzle with fewer moves",
    simonSays: "Simon Says",
    simonSaysDesc: "Repeat the color patterns",
    dinoRunner: "Dino Runner",
    dinoRunnerDesc: "Jump over obstacles - single switch",
    pongGame: "Pong",
    pongGameDesc: "Table tennis - two switches",
    spaceDefender: "Space Defender",
    spaceDefenderDesc: "Defend your spaceship - 5 switches",
    balloonPopper: "Balloon Popper",
    balloonPopperDesc: "Eye gaze - no clicks needed",
    gridMemoryGame: "Number Memory",
    gridMemoryDesc: "Voice control - say a number",
    moves: "Moves",
    newGame: "New Game",
    wonInMoves: "You won in {0} moves!",
    gameSoonAvailable: "Game coming soon",
    ticTacToe: "Tic Tac Toe",
    puzzle: "Puzzle",
    startGame: "Start Game",
    yourTurn: "Your Turn",
    aiTurn: "AI Turn",
    youWin: "You Win!",
    youWon: "You Won!",
    aiWins: "AI Wins",
    draw: "Draw",
    playAgain: "Play Again",
    gameOver: "Game Over",
    score: "Score",
    highScore: "High Score",
    up: "Up",
    down: "Down",
    left: "Left",
    right: "Right",
    slidingPuzzleHint: "Click on adjacent tiles to move them",
    simonSaysHint: "Repeat the sequence by clicking the colors",
    watchTheSequence: "Watch the sequence...",
    missed: "Missed",
    dinoTapToJump: "Press any key or tap the screen to jump",
    dinoTapAnywhere: "Tap anywhere to jump",
    pongInstructions: "Use up/down arrows or buttons to control the paddle",
    balloonPopperInstructions: "Hover over a balloon for one second to pop it",
    balloonPopperHint: "Hover over a balloon and stay for a second to pop | No clicks!",
    
    // Smart Home
    smartHomeTitle: "Smart Home",
    lights: "Lights",
    lightsOn: "Turn On",
    lightsOff: "Turn Off",
    brightness: "Brightness",
    webhookButtons: "Webhook Buttons",
    addButton: "Add Button",
    buttonName: "Button Name",
    webhookUrl: "Webhook URL",
    
    // Scanning
    scanningSettings: "Scanning Settings",
    automaticScan: "Automatic Scanning",
    manualScan: "Manual Scanning",
    scanSpeed: "Scan Speed",
    rowAndColumn: "Row and Column",
    cellByCell: "Cell by Cell",
    
    // New SRS scanning/cursor settings
    dwellTime: "Dwell Time",
    dwellTimeDesc: "How long to stay on an item before selecting",
    seconds: "seconds",
    firstItemDelay: "First Item Delay",
    firstItemDelayDesc: "Extra pause when entering a new group",
    offSetting: "Off",
    normalSetting: "Normal",
    longSetting: "Long",
    cursorSettings: "Cursor Settings",
    cursorMagnetism: "Cursor Magnetism",
    cursorMagnetismDesc: "Pull cursor towards buttons",
    weakSetting: "Weak",
    strongSetting: "Strong",
    cursorSmoothingSetting: "Cursor Smoothing",
    cursorSmoothingDesc: "Cursor movement stability level",
    lowSetting: "Low",
    highSetting: "High",
    
    scanMode: "Scan Mode",
    cellByCellMode: "Cell by Cell",
    cellByCellDesc: "Scanning goes through each cell separately",
    rowAndColumnMode: "Row and Column",
    rowAndColumnDesc: "First select row, then cell in row",
    scanSpeedLabel: "Scan Speed",
    slow: "Slow",
    fast: "Fast",
    automaticScanning: "Automatic Scanning",
    gestureScanning: "Gesture Scanning",
    selectScanTypeMale: "Select scan type:",
    selectScanTypeFemale: "Select scan type:",
    selectedMode: "Selected Mode:",
    // Head/Gaze Tracking
    headTrackingTitle: "Head Tracking - Setup",
    gazeTrackingTitle: "Gaze Tracking - Setup",
    mouthGesturesTitle: "Mouth Gestures - Setup",
    calibration: "Calibration",
    startCalibration: "Start Calibration",
    calibrationComplete: "Calibration Complete",
    lookAtPoint: "Look at the point",
    sensitivity: "Sensitivity",
    testTracking: "Test Tracking",
    finishSetup: "Finish Setup",
    
    // Mouth Gestures
    selectGestures: "Select up to 3 gestures to use for control",
    smile: "Smile",
    smileDesc: "Smile wide",
    openMouth: "Open Mouth",
    openMouthDesc: "Open your mouth wide",
    kiss: "Kiss",
    kissDesc: "Purse your lips",
    
    // Voice Control
    voiceControlTitle: "Voice Control - Setup",
    wakeWord: "Wake Word",
    voiceCommands: "Voice Commands",
    sayCommand: "Say a command",
    
    // External Switch
    externalSwitchTitle: "External Switches - Setup",
    switchCount: "Number of Switches",
    assignActions: "Assign Actions",
    pressSwitch: "Press a switch",
    pressSwitchFemale: "Press a switch",
    switchLabel: "switch",
    switchesLabel: "switches",
    switch1Desc: "One switch - selection only (automatic scanning)",
    switch2Desc: "Two switches - selection and back",
    switch3Desc: "Three switches - selection, next, back",
    switch4Desc: "Four switches - selection, next, previous and back",
    switch5Desc: "Five switches - full directional navigation",
    selectSwitchCountMale: "Select number of switches:",
    selectSwitchCountFemale: "Select number of switches:",
    scanType: "Scan Type",
    automaticScanType: "Automatic",
    manualScanType: "Manual",
    cursorMovesAutoSelect: "Cursor moves automatically, press to select",
    cursorMovesOnPress: "Cursor moves only when switch is pressed",
    recordSwitchInputMale: "Press each switch to record its input",
    recordSwitchInputFemale: "Press each switch to record its input",
    testSwitchInputMale: "Press each switch to verify the system recognizes it",
    testSwitchInputFemale: "Press each switch to verify the system recognizes it",
    recorded: "Recorded",
    pressToRecordMale: "Press the switch...",
    pressToRecordFemale: "Press the switch...",
    allSwitchesConfigured: "All switches configured successfully!",
    selectAction: "Select",
    cancelAction: "Cancel",
    nextAction: "Next",
    previousAction: "Previous",
    backAction: "Back",
    upAction: "Up",
    downAction: "Down",
    leftAction: "Left",
    rightAction: "Right",
    
    // Action Mapping
    actionMappingTitle: "Action Mapping",
    clickGestureToChangeMale: "Click a gesture to change it:",
    clickGestureToChangeFemale: "Click a gesture to change it:",
    selectGesturePrompt: "Select gesture",
    blinkGesture: "Blink / Close eyes",
    blinkGestureShort: "Blink",
    lookUpGesture: "Look up (up)",
    lookUpGestureShort: "Look up",
    lookDownGesture: "Look down (down)",
    lookDownGestureShort: "Look down",
    lookLeftGesture: "Look left (left)",
    lookLeftGestureShort: "Look left",
    lookRightGesture: "Look right (right)",
    lookRightGestureShort: "Look right",
    selectEnter: "Select (Enter)",
    fullDirectionalNav: "Full Spatial Navigation",
    fullDirectionalNavDesc: "Free navigation in all directions",
    advancedNav: "Advanced Navigation",
    advancedNavDesc: "Select, next, previous and back",
    manualScanNav: "Manual Scanning",
    manualScanNavDesc: "Select, next and back",
    autoScanWithCancel: "Scanning with Back",
    autoScanWithCancelDesc: "Automatic scanning with back option",
    autoScanOnly: "Automatic Scanning",
    autoScanOnlyDesc: "Scanning moves automatically, one gesture to select",
    
    // Head/Gaze Tracking Setup
    faceAndEyeDetection: "Face and Eye Detection",
    faceAndEyeDetectionDesc: "The system detects your face and eyes. Make sure your face is centered on the screen.",
    searchingForFace: "Searching for face...",
    tooClose: "Too close - move away from camera",
    tooFar: "Too far - move closer to camera",
    distanceGood: "Distance is great!",
    initializingTracking: "Initializing tracking...",
    eyePointsMarkedCyan: "Eye points are marked in cyan",
    foundPreviousCalibration: "Found previous calibration - you can use it or recalibrate",
    usePreviousCalibration: "Use Previous Calibration",
    recalibrate: "Recalibrate",
    foundPreviousSetup: "Found previous setup - you can start immediately or set up again",
    startImmediately: "Start Immediately",
    setupAgain: "Set Up Again",
    testGazeTracking: "Test Gaze Tracking",
    lookAtContinueButton: "Look at the \"Continue\" button to activate it",
    excellentClickToContinue: "Excellent! Click to continue",
    gazeTrackingActiveTitle: "Gaze Mode Active",
    gazeTrackingReadyDesc: "The system is ready! The cursor will follow your gaze. Stop on an element to select it.",
    testButton: "Button",
    cameraErrorCannotAccess: "Cannot access camera - make sure camera is connected and permission is granted",
    videoElementError: "Error accessing video element",
    faceModelLoadError: "Error loading face detection model",
    
    // Mouth Gesture Setup
    neutralCalibration: "Neutral State Calibration",
    neutralCalibrationDesc: "Relax your face in a natural state",
    gestureCalibration: "Gesture Calibration",
    performGesture: "Perform the gesture",
    gestureTestTitle: "Gesture Test",
    testGesturesDesc: "Perform the gestures you selected to verify the system recognizes them",
    allGesturesTestedSuccess: "All gestures tested successfully!",
    
    // Voice Control Setup
    voiceControlSetupTitle: "Voice Control",
    voiceControlTestTitle: "Voice Control Test",
    voiceControlExplanation: "Each button on screen will show a number next to it. Simply say the number to press the button.",
    voiceControlExplanationFemale: "Each button on screen will show a number next to it. Simply say the number to press the button.",
    voiceControlExample: 'For example: say "1" to press the first button',
    voiceControlExampleFemale: 'For example: say "1" to press the first button',
    voiceControlWakeWord: 'Wake word: "EyeControl"',
    voiceControlWakeWordDesc: 'Say "EyeControl" to pause or resume listening. When paused, numbers will disappear from screen.',
    voiceControlWakeWordDescFemale: 'Say "EyeControl" to pause or resume listening. When paused, numbers will disappear from screen.',
    voiceControlSubtitle: "Control the app with your voice",
    nowYourTurn: "Now your turn!",
    sayTheNumber: "Say the number next to the green button",
    sayTheNumberFemale: "Say the number next to the green button",
    youSaid: "You said:",
    listeningActive: "Listening...",
    clickToStart: "Click to start",
    startTest: "Start Test",
    successes: "Successes:",
    buttonLabel: "Button",
    
    // Head Tracking Setup
    headTrackingSetupTitle: "Head Tracking",
    faceDetectionTitle: "Face Detection",
    faceDetectionDesc: "The system is detecting your face. Make sure your face is centered on screen.",
    trackingTestTitle: "Tracking Test",
    trackingTestDesc: 'Move your head to reach the "Continue" button with the cursor',
    cursorActiveTitle: "Cursor Mode Active",
    cursorActiveDesc: "The system is ready! The cursor will follow your head movements. Hover on an element to select it.",
    
    // Gaze Tracking Setup
    gazeTrackingSetupTitle: "Gaze Tracking",
    gazeTestDesc: 'Look at the "Continue" button to activate it',
    gazeActiveTitle: "Gaze Mode Active",
    gazeActiveDesc: "The system is ready! The cursor will follow your gaze. Hover on an element to select it.",
    
    // Mouth Gesture Setup (additional)
    mouthGestureSetupTitle: "Mouth Gesture Setup",
    selectUpTo3Gestures: "Select up to 3 gestures you want to use for control",
    selectUpTo3GesturesFemale: "Select up to 3 gestures you want to use for control",
    actionMapping: "Action Mapping",
    selectActionForGesture: "Select what each gesture will do",
    selectActionForGestureFemale: "Select what each gesture will do",
    scanSettingsTitle: "Scanning Settings",
    scanModeLabel: "Scan Mode:",
    manualScanning: "Manual Scanning",
    gesture3ManualDesc: "3 gestures - you move the cursor forward and backward",
    gesture2AutoDesc: "2 gestures - scanning moves automatically, one gesture for selection and one for back",
    gesture1AutoDesc: "One gesture - scanning moves automatically, gesture for selection only",
    scanCellsMode: "Cells",
    rowsAndColumns: "Rows and Columns",
    scanSpeedSeconds: "Scan Speed: {0} seconds",
    usePreviousCalibrationOption: "Found previous calibration - you can use it or recalibrate",
    usePreviousBtn: "Use Previous Calibration",
    recalibrateBtn: "Recalibrate",
    neutralCalibrationTitle: "Calibration - Relaxed Face",
    keepFaceRelaxed: "Keep your face relaxed with mouth closed. Click the button to capture.",
    keepFaceRelaxedFemale: "Keep your face relaxed with mouth closed. Click the button to capture.",
    faceDetected: "Face detected ✓",
    faceNotDetected: "Face not detected",
    capturing: "Capturing...",
    capture: "Capture",
    gestureCalibrationTitle: "Calibration - {0}",
    performGestureDesc: "Perform the gesture: {0}",
    performGestureDescFemale: "Perform the gesture: {0}",
    gestureTestDesc: "Perform each gesture to verify the system recognizes it",
    gestureTestDescFemale: "Perform each gesture to verify the system recognizes it",
    neutralState: "Neutral",
    allGesturesDetected: "All gestures detected successfully!",
    setupComplete: "Setup Complete!",
    gesturesCalibrated: "Your mouth gestures have been calibrated successfully. You can now use them to control the app.",
    gesturesCalibratedFemale: "Your mouth gestures have been calibrated successfully. You can now use them to control the app.",
    configStage: "Settings",
    calibrateStage: "Calibration",
    calibrateGestureStage: "Gesture Calibration",
    testStage: "Test",
    completeStage: "Complete",
    
    // External Switch Setup
    switchSetupTitle: "Switch Setup",
    recordingSwitchesTitle: "Recording Switches",
    testingSwitchesTitle: "Testing Switches",
    stageXOfY: "Stage {0} of {1}",
    pressSwitchToRecord: "Press each switch to record its input",
    pressSwitchToRecordFemale: "Press each switch to record its input",
    recordedLabel: "Recorded: {0}",
    pressSwitchPrompt: "Press the switch...",
    pressSwitchPromptFemale: "Press the switch...",
    pressSwitchToTest: "Press each switch to verify the system recognizes it",
    pressSwitchToTestFemale: "Press each switch to verify the system recognizes it",
    allSwitchesRecognized: "Excellent! All switches recognized successfully",
    
    // Additional switch setup keys
    performEachGestureToTest: "Perform each gesture to verify the system recognizes it",
    performEachGestureToTestFemale: "Perform each gesture to verify the system recognizes it",
    
    // General UI
    loading: "Loading...",
    error: "Error",
    retry: "Retry",
    cancel: "Cancel",
    confirm: "Confirm",
    edit: "Edit",
    add: "Add",
    remove: "Remove",
    next: "Next",
    previous: "Previous",
    finish: "Finish",
    continue: "Continue",
    skip: "Skip",
    select: "Select",
    selected: "Selected",
    copied: "Copied!",
    textCopied: "Text copied to clipboard",
    copyError: "Could not copy",
    typeHere: "Type here...",
    keyboardTitle: "Keyboard",
    readAloudBtn: "Read",
    copyBtn: "Copy",
    
    // Camera/Tracking Errors
    cameraError: "Cannot access camera - make sure camera is connected and permission is granted",
    videoError: "Error accessing video element",
    faceModelError: "Error loading face detection model",
    searchingFace: "Searching for face...",
    
    // Guide
    guideTitle: "User Guide",
    guideIntro: "Welcome to the EyeControl App User Guide",
    guideIntroDesc: "EyeControl App is an advanced Alternative and Augmentative Communication (AAC) system designed for people with communication and motor disabilities. This guide will help you learn about all the features in the system.",
    
    // Guide sections
    guideControlMethods: "Control Methods",
    guideControlMethodsDesc: "The system is designed for EyeControl device and also supports external switches or touch/mouse:",
    guideControlEyeControl: "EyeControl Device - A communication device based on eye gestures for full system control. Choose 1–5 eye gestures (e.g. blink, look up, down, right, left). 4+ gestures enable manual control mode — each gesture performs a specific action. Up to 3 gestures activate automatic scanning — the system moves between items at an adjustable pace. Scan speed can be configured in settings",
    guideControlTouch: "Touch/Mouse - Standard control by touch or mouse click",
    guideControlHead: "Head Tracking - Control the cursor by moving your head. The camera tracks your head movements",
    guideControlGaze: "Gaze Tracking - Control the cursor with eye movements using 9-point calibration",
    guideControlMouth: "Mouth Gestures - Control scanning with smile, mouth open, or kiss gestures",
    guideControlSwitch: "External Switches - Connect 1-5 physical switches to control scanning",
    guideControlVoice: "Voice Control - Give voice commands for navigation and selection",
    
    guideCommunication: "Communication",
    guideCommunicationDesc: "Advanced communication tools:",
    guideCommBoard: "Communication Board - Contains words and categories, editable and fully customizable. After building a message, it can be spoken aloud or sent to saved contacts in the system.",
    guideCommAAC: "AAC Keyboard - Typing with smart word completion and emojis. After building a message it can be spoken aloud or sent to saved contacts in the system.",
    guideCommAI: "AI Chat - Chat with a smart AI assistant that can help you compose messages",
    guideCommContacts: "Remote Contact - Save contacts in the system via Menu > Contacts. Using the keyboard or communication board, you can send messages that will arrive on the personal phone of saved contacts.",
    guideCommHelp: "Call for Help - A button that sounds a help alert and lets you choose what happened. Contacts can be set to receive the alert on their personal phone.",
    guideCommTranslator: "Speech Translation - Choose the spoken language for messages. Change at any time via Menu > Settings > Voice & Audio.",

    guideContacts: "Contacts",
    guideContactsDesc: "Remote contact with the user's contacts",
    guideContactsItem0: "Save the user's contacts to send messages from the system",
    guideContactsItem1: "Via the menu, contacts can scan a code from their phone and confirm receiving messages from the user, delivered as a phone notification",
    guideContactsItem2: "You can choose the notification type: All (including Call for Help) — or only regular messages to stay in touch",
    guideContactsItem3: "Contacts will receive notifications according to the messages the user sends",
    guideContactsItem4: "If receiving Call for Help is enabled — an immediate alert is sent when the user presses the help button",

    guideMedia: "Media & Entertainment",
    guideMediaDesc: "YouTube, Radio and music directly from the system:",
    guideMediaYT: "YouTube - Search and watch videos directly in the app",
    guideMediaTV: "Television - Watch IPTV channels from Israel and around the world",
    guideMediaRadio: "Radio - Listen to radio stations by country or genre",
    guideMediaSpotify: "Spotify - Connect your personal account and use it accessibly from within the system.",
    guideMediaGames: "Games - Memory games, Tic-Tac-Toe, and puzzles",
    
    guideSmartHome: "Smart Home",
    guideSmartHomeDesc: "Control smart devices in your home:",
    guideSmartLights: "Lights - Control Philips Hue lights",
    guideSmartHA: "Home Assistant - Connect to Home Assistant system",
    guideSmartWebhook: "Webhooks - Custom buttons for Make/Zapier/IFTTT actions",
    
    guideSettings: "Settings",
    guideSettingsDesc: "Customize the system to your needs:",
    guideSettingsAppearance: "Appearance - Dark/light mode, font size",
    guideSettingsVoice: "Voice & Audio - Choose male/female voice, speech speed, spoken language",
    guideSettingsProfile: "Profile - Name, language, addressing style",
    guideSettingsControl: "Control - Set your preferred control method",
    guideSettingsBoards: "Board Editor – Personalize content and screens for the user. Home & Entertainment – Set what appears and the spatial layout. Call for Help – Edit messages shown after a help alert (\"What happened\"). Communication Board – Edit messages, visual elements and layout. Keyboard – Edit auxiliary actions.",
    
    guideAccessibility: "Accessibility",
    guideAccessibilityDesc: "Advanced accessibility features:",
    guideAccessScanning: "Scanning - Automatic or manual scanning of on-screen elements",
    guideAccessDwell: "Dwell Click - When using a gaze tracking camera, automatic click after hovering on an element",
    guideAccessHelp: "Help Button - Voice alert or sound to call for help",
    guideAccessRest: "Rest Mode - Dark screen for taking a break from the system",
    
    guideTips: "Tips",
    guideTipsDesc: "Tips for effective use:",
    guideTip1: "Start with the simplest control method and progress gradually",
    guideTip2: "Adjust scanning speed and tracking sensitivity for maximum comfort",
    guideTip3: "Add common words to the Communication Board via Board Editor > Edit Communication Board",
    guideTip4: "Use communication boards for specific topics or situations, such as a meeting or a meal",
    guideTip5: "Build a custom communication board for specific and daily topics via Board Editor > Edit Communication Board",
    
    // Auth
    login: "Login",
    signup: "Sign Up",
    loginToAccount: "Login to your account",
    createAccount: "Create a new account",
    emailLabel: "Email",
    passwordLabel: "Password",
    invalidEmail: "Invalid email address",
    passwordMinLength: "Password must be at least 6 characters",
    loginSuccess: "Logged in successfully",
    welcomeBack: "Welcome back!",
    signupSuccess: "Signed up successfully",
    checkEmail: "A verification email has been sent. Please check your inbox.",
    authError: "An error occurred",
    invalidCredentials: "Invalid email or password",
    userExists: "User already registered, try logging in",
    emailNotConfirmed: "Please confirm your email before logging in",
    passwordBreached: "This password has been found in a public data breach. For your security, please choose a different, unique password.",
    googleSignInError: "Error signing in with Google",
    or: "or",
    noAccount: "Don't have an account?",
    haveAccount: "Already have an account?",
    forgotPassword: "Forgot password?",
    resetPassword: "Reset Password",
    resetEmailSent: "Sent successfully",
    resetEmailDesc: "A password reset link has been sent to your email",
    resetError: "Error sending email, please try again",
    sendResetEmail: "Send reset link",
    backToLogin: "Back to login",
    invalidResetLink: "The reset link is invalid or has expired",
    passwordsDoNotMatch: "Passwords do not match",
    passwordResetSuccess: "Password updated successfully",
    passwordResetSuccessDesc: "You can now log in with your new password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    setNewPassword: "Set New Password",
    
    // MFA
    twoFactorAuth: "Two-Factor Authentication",
    enterAuthCode: "Enter the code from your authenticator app",
    verificationCode: "Verification Code",
    verifyAndLogin: "Verify and Login",
    mfaCodeError: "Verification code must be 6 digits",
    mfaCodeWrong: "Incorrect verification code, please try again",
    
    // Email Verification
    verifyingEmail: "Verifying your email...",
    pleaseWait: "Please wait",
    emailVerified: "Email verified successfully!",
    emailVerifiedDesc: "The email address {email} has been verified. You can now log in.",
    goToLogin: "Go to login",
    tokenExpired: "Link expired",
    tokenExpiredDesc: "The verification link has expired. Please sign up again.",
    backToSignup: "Back to signup",
    verificationFailed: "Verification failed",
    verificationFailedDesc: "The link is invalid or has already been used.",
    
    myVoice: "My Voice",
    voiceCloning: "Voice Cloning",
    voiceCloningDesc: "Create a custom voice from your recording",
    
    // Night Monitoring
    nightMonitoringTitle: "Night Monitoring",
    nightMonitoringDesc: "Alert caregiver when user is awake at night",
    nightMonitoringEyeControlOnly: "Night monitoring is only available in EyeControl mode",
    nightCaregiverEmail: "Caregiver Email",
    nightCaregiverEmailDesc: "Alerts will be sent to this address",
    nightHoursRange: "Night Hours Range",
    startTime: "Start Time",
    endTime: "End Time",
    awakeDurationThreshold: "Awake Duration for Alert",
    awakeDurationDesc: "If user is awake longer than this, an alert will be sent",
    minutes: "minutes",
    howItWorks: "How it works?",
    nightMonitoringInfo1: "When user is asleep, EyeControl sends continuous Enter signal",
    nightMonitoringInfo2: "When signal stops for extended time, system detects wakefulness",
    nightMonitoringInfo3: "After configured time, alert is sent to caregiver",
    cloneAgain: "Clone Again",
    cloneVoice: "Clone Voice",
    
    // User Contacts
    caregiverAlerts: "Contacts",
    userContactsDescription: "Contacts to whom the user can send messages to stay in touch and call for help.",
    addContact: "Add Contact",
    savedContacts: "Saved Contacts",
    caregiverQRTitle: "Connect Caregiver Device",
    caregiverQRDesc: "Scan to connect a phone device",
    caregiverQRInstructions: "Scanning the code enables receiving messages from the user as Push notifications to your personal phone, even when the browser is closed. You can set up regular messages and/or help alert notifications.",
    linkCopied: "Link copied!",
    copyFailed: "Failed to copy",
    copyLink: "Copy Link",
    connectedCaregivers: "Saved Contacts",
    noCaregiversConnected: "No contacts connected yet",
    caregiverRemoved: "Device removed successfully",
    removeError: "Error removing device",
    unknownDevice: "Unknown device",
    confirmDeleteCaregiver: "Delete Contact",
    confirmDeleteCaregiverDesc: "This contact will no longer receive notifications. You can always reconnect them through settings.",
    recentlyConnected: "Recently connected",
    loginRequired: "Please log in to view QR code",
    howPushAlertsWork: "How does it work?",
    pushAlertInfo1: "Contacts scan the code or open the link on their phone.",
    pushAlertInfo2: "Approve receiving notifications in their browser.",
    pushAlertInfo3: "Choose notification type: All (including help alerts) or regular messages only to stay in touch.",
    pushAlertInfo4: "Receive messages from the user as notifications to their personal phone.",
    pushAlertInfo5: "If help alerts are enabled – receive an instant alert when the user presses the help button.",
    sendTestNotification: "Send Test Notification",
    testNotificationSent: "Test notification sent successfully!",
    testNotificationFailed: "Failed to send test notification",
    noCaregiversToNotify: "No caregivers connected to notify",
    qrExpiresAt: "Valid until:",
    qrExpired: "QR code expired",
    refresh: "Refresh",
    qrAutoRefreshing: "Auto-refreshing QR code...",
    messagesOnly: "Messages only",
    allAlerts: "All",
    notificationTypeAll: "All (including help alerts)",
    notificationTypeMessagesOnly: "Regular messages only",
    qrAutoRefreshed: "QR code refreshed successfully",
    refreshQR: "Refresh code",
    enterCodeAt: "at",
    generateNewQR: "Generate new QR",
    orEnterCode: "Or enter code:",
    iphoneCodeInstruction: "For iPhone users: enter the following code after installation",
    allCaregiversRemoved: "All devices removed successfully",
    clearAllCaregivers: "Remove all contacts",
    pushNotConfigured: "Push notifications not yet configured",
    clearError: "Error clearing devices",
    
    // Settings - Help Alert
    helpAlertSound: "Help Sound",
    helpAlertSoundDesc: "Choose what plays when you press help",
    voiceAlert: "Voice",
    sirenAlert: "Siren",
    beepAlert: "Beep",
    trainAlert: "Train",
    
    // Settings - Security
    security: "Security",
    twoFactorSetup: "Two-Factor Authentication (2FA)",
    twoFactorSetupDesc: "Add an extra layer of security to your account",
    setup2FA: "Setup 2FA",
    auditLog: "Security Log",
    auditLogDesc: "Recent security actions on your account",
    noAuditLogs: "No security actions to display",
    auditTokenRegister: "Caregiver device registration",
    auditEmailAlert: "Email alert",
    auditPushAlert: "Push notification",
    auditLinkGenerate: "QR link generation",
    
    // Sidebar
    main: "Home",
    disableTracking: "Disable Tracking",
    logout: "Logout",
    
    // Smart Home page
    buttons: "Buttons",
    hueTab: "Hue",
    haTab: "HA",
    settingsTab: "Settings",
    addButtonLabel: "Add Button",
    noLightsFound: "No lights found",
    checkHueConnection: "Check your Hue connection",
    hueError: "Error loading Hue lights",
    lightTurnedOn: "Light turned on",
    lightTurnedOff: "Light turned off",
    lightControlError: "Error controlling light",
    brightnessError: "Error setting brightness",
    haError: "Error loading Home Assistant",
    noHAEntities: "No devices found",
    checkHAConnection: "Check your Home Assistant connection",
    actionCompleted: "Action completed",
    deviceControlError: "Error controlling device",
    buttonTriggered: "Triggered!",
    buttonTriggerError: "Error triggering button",
    buttonUpdated: "Button updated",
    buttonAdded: "Button added",
    buttonDeleted: "Button deleted",
    fillNameAndUrl: "Please fill in name and webhook URL",
    editButton: "Edit Button",
    newButton: "New Button",
    iconLabel: "Icon",
    colorLabel: "Color",
    methodLabel: "Method",
    saveChanges: "Save Changes",
    
    // Smart Home Settings
    smartHomeEnabled: "Enabled - Configure in Smart Home screen",
    smartHomeDisabled: "Enable to control smart home",
    philipsHueSettings: "Philips Hue Settings",
    bridgeIP: "Bridge IP Address",
    hueUsername: "Username",
    hueInstructions: "Press the bridge button then click 'Connect'",
    connect: "Connect",
    homeAssistantSettings: "Home Assistant Settings",
    serverUrl: "Server URL",
    accessToken: "Access Token",
    
    // Button icons
    iconPower: "Power",
    iconLamp: "Lamp",
    iconSun: "Sun",
    iconMoon: "Moon",
    iconHome: "Home",
    iconPlay: "Play",
    
    // Colors
    colorTeal: "Teal",
    colorOrange: "Orange",
    colorBlue: "Blue",
    colorGreen: "Green",
    colorPurple: "Purple",
    colorPink: "Pink",
    colorYellow: "Yellow",
    colorRed: "Red",
    
    // Translator page
    realtimeTranslator: "Real-time Translator",
    speaking: "Speaking",
    translation: "Translation",
    pressToStart: "Press to start",
    listening: "Listening...",
    pressMicToSpeak: "Press the microphone and start speaking",
    speechRecognitionError: "Speech recognition error",
    allowMicAccess: "Please allow microphone access in your browser",
    browserNotSupported: "Browser does not support speech recognition",
    translationError: "Translation error",
    
    // AI Chat page (additional)
    chatCleared: "Chat cleared",
    helloImHere: "Hello! I'm here to help",
    writeMessageBelow: "Write a message below and I'll respond",
    readAloud: "Read aloud",
    sendMessageError: "Error sending message",
    
    // AAC Keyboard page
    aacKeyboardTitle: "AAC Keyboard",
    aacTip: "Tip:",
    aacTipText: "In acronym mode, type the first letter of each word",
    aacExample: 'For example: "hay" = "how are you"',
    
    // YouTube page (additional)
    popular: "Popular",
    searchYoutube: "Search YouTube",
    typeToSearch: "Type what to search...",
    popularVideos: "Popular Videos",
    homePage: "Home Page",
    searchResults: "Search Results",
    recommendedVideos: "Recommended Videos",
    watchHistory: "Watch History",
    searchError: "Search error",
    loginError: "Login error",
    loginToSearch: "Login to search",
    googleSignInRequired: "Google sign-in required",
    signInWithGoogleToSearch: "Sign in with Google to search YouTube videos",
    signInWithGoogle: "Sign in with Google",
    closeVideo: "Close",
    muteVideo: "Mute",
    unmuteVideo: "Unmute",
    skipForward: "10 seconds forward",
    skipBackward: "10 seconds back",
    newSearch: "New Search",
    pauseVideo: "Pause",
    playVideo: "Play",
    timesWatched: "times watched",
    loginToWatch: "Connect with Google to watch YouTube",
    connectWithGoogle: "Connect with Google",
    noHistory: "No watch history",
    clearHistory: "Clear history",
    historySaved: "Video saved to history",
    historyCleared: "History cleared",
    linkGoogleAccount: "Link Google Account",
    linkGoogleDescription: "Do you want to add Google sign-in to your account? This will let you sign in with either email or Google.",
    useGoogleOnlyForYouTube: "Just for YouTube",
    linkToMyAccount: "Link to my account",
    
    // Spotify page
    spotifyTitle: "Spotify",
    welcomeToSpotify: "Welcome to Spotify",
    connectToSpotify: "Connect to your Spotify account to access your playlists and songs",
    loginToSpotify: "Login to Spotify",
    spotifySetup: "Spotify Setup",
    spotifySetupDesc: "To connect to Spotify, create an app at",
    enterClientId: "Enter Client ID",
    continueAndLogin: "Continue and Login",
    yourPlaylists: "Your Playlists",
    noPlaylistsFound: "No playlists found",
    songsCount: "songs",
    disconnectSpotify: "Disconnect",
    useArrowsHint: "Use ↑↓ arrows for navigation and Enter to select",
    previousTrack: "Previous track",
    nextTrack: "Next track",
    play: "Play",
    pause: "Pause",
    connectingToPlayer: "Connecting to player...",
    premiumRequired: "Premium account required for full playback",
    
    // TV page (additional)
    selectChannel: "Select channel to start",
    noChannelsFound: "No channels found",
    channelLoadError: "Error loading channels",
    channelPlayError: "Cannot play channel",
    channelError: "Channel playback error",
    formatNotSupported: "Browser does not support this format",
    tryAgain: "Try again",
    generalCategory: "General",
    israel: "Israel",
    usa: "USA",
    russiaCountry: "Russia",
    saudiArabia: "Saudi Arabia",
    restOfWorld: "Rest of World",
    fullscreen: "Fullscreen",
    exitFullscreen: "Exit Fullscreen",
    
    // Radio page (additional)
    genresLabel: "Genres",
    countriesLabel: "Countries",
    noStationsFound: "No stations found",
    playingNow: "Playing now",
    pausedStatus: "Paused",
    uk: "UK",
    franceCountry: "France",
    germanyCountry: "Germany",
    spainCountry: "Spain",
    italyCountry: "Italy",
    brazilCountry: "Brazil",
    japanCountry: "Japan",
    indiaCountry: "India",
    greeceCountry: "Greece",
    turkeyCountry: "Turkey",
    polandCountry: "Poland",
    popGenre: "Pop",
    rockGenre: "Rock",
    jazzGenre: "Jazz",
    classicalGenre: "Classical",
    electronicGenre: "Electronic",
    hiphopGenre: "Hip Hop",
    countryGenre: "Country",
    bluesGenre: "Blues",
    reggaeGenre: "Reggae",
    ambientGenre: "Ambient",
    oldiesGenre: "Oldies",
    the80sGenre: "80s",
    the90sGenre: "90s",
    danceGenre: "Dance",
    soulGenre: "Soul",
    latinGenre: "Latin",
    loungeGenre: "Lounge",
    metalGenre: "Metal",
    alternativeGenre: "Alternative",
    chilloutGenre: "Chillout",
    
    // Device check
    deviceNotSupported: "This app is designed for tablets and computers in landscape mode",
    deviceNotSupportedDesc: "For the best experience, use a device with a larger screen or rotate your screen to landscape",
    minScreenSize: "Minimum screen size: 10 inches",
    
    // Voice control overlay
    listeningStatus: "Listening...",
    notListeningStatus: 'Not listening - say "EyeControl" to activate',
    
    // Onboarding
    whichLanguage: "What is the user's language?",
    whichLanguageFemale: "What is the user's language?",
    whichLanguageMale: "What is the user's language?",
    canChangeInSettings: "You can change this in settings at any time",
    greatReadyFemale: "Excellent",
    greatReadyMale: "Excellent",
    greatReady: "Excellent",
    niceToMeet: "Nice to meet you!",
    labelName: "Name:",
    labelAddress: "Address:",
    labelLanguage: "Language:",
    labelControlMethod: "Control Method:",
    
    // Scanning action labels
    actionSelect: "Select",
    actionCancel: "Cancel",
    actionNext: "Next",
    actionPrev: "Previous",
    actionBack: "Back",
    actionUp: "Up",
    actionDown: "Down",
    actionLeft: "Left",
    actionRight: "Right",
    
    // Pricing page
    pricingTitle: "Choose Your Plan",
    pricingSubtitle: "7-day free trial for any plan",
    monthly: "Monthly",
    yearly: "Yearly",
    yearlyDiscount: "(20% off)",
    personal: "Personal",
    group: "Group",
    forTeams: "For Teams",
    perMonth: "per month",
    perUserPerMonth: "per user per month",
    minUsers: "5 users minimum",
    users: "Users",
    regularPrice: "Regular price:",
    salePrice: "Sale price:",
    startFreeTrial: "Start Free Trial",
    whatsIncluded: "What's included:",
    startWith7Days: "Start with 7 free days",
    blackFridaySale: "Black Friday Sale",
    limitedTimeOffer: "Special limited time offer",
    featureEyeTracking: "Advanced eye tracking",
    featureCommBoard: "Full communication board",
    featureSmartTyping: "Smart quick typing",
    featureCaregiverMsg: "Send messages to caregiver",
    featureTvYoutube: "TV and YouTube access",
    featureGames: "Accessible games",
    featureSupport: "Full technical support",
    featureUpdates: "Automatic updates",

    // Onboarding (additional)
    welcomeToAyuni: "Welcome to EyeControl App",
    aacAppDescription: "Alternative and Augmentative Communication App",
    letsSetup: "Let's configure some settings to personalize the system",
    letsStart: "Let's Start",
    whatIsYourName: "What is the user's name?",
    willUseForPersonal: "We'll use this name for personal greetings",
    yourName: "User name",
    howToAddress: "How should we address the user?",
    willUseForAddressing: "We'll use this for personalized communication",
    genderFemale: "Female",
    genderFemaleDesc: "Feminine addressing",
    genderMale: "Male",
    genderMaleDesc: "Masculine addressing",
    genderNeutral: "Neutral",
    genderNeutralDesc: "Neutral addressing",
    letsStartFemale: "Let's start!",
    letsStartMale: "Let's start!",
    letsStartNeutral: "Let's start!",
    backToEdit: "Back to edit",
    
    // Contacts page additional
    noEmailAddress: "No email address",
    setEmailFirst: "Set caregiver email first",
    messageFromAyuni: "Message from EyeControl App",
    noPhoneNumber: "No phone number",
    setPhoneFirst: "Set caregiver phone first",
    errorTitle: "Error",
    pleaseLoginFirst: "Please login first",
    notificationSent: "Notification sent",
    sentToDevices: "Sent to {0} devices",
    scanQRInSettings: "Scan the QR code in settings",
    failedToSendNotification: "Failed to send notification",
    pushAlert: "Push Alert",
    emailSent: "Email sent",
    messageSentTo: "Message sent to {email}",
    failedToSendEmail: "Failed to send email",
    
    // Board Builder (unique additions)
    newBoard: "New Board",
    boardUpdated: "Board updated successfully!",
    boardSaved: "Board saved successfully!",
    confirmBtn: "Confirm",
    gridSize: "Grid Size",
    cellsCount: "cells",
    utterancesCount: "utterances",
    saveBtn: "Save",
    finishBtn: "Finish",
    
    // Help Alert
    iNeedHelpMale: "I need help!",
    iNeedHelpFemale: "I need help!",
    closeBtn: "Close",
    whatHappened: "What happened?",
    toCloseText: "to close",
    
    // Emergency Board
    emergencyPainMale: "I'm in pain",
    emergencyPainFemale: "I'm in pain",
    emergencyCallCaregiver: "Call caregiver",
    emergencyBreathing: "Hard to breathe",
    emergencyNotWellMale: "I don't feel well",
    emergencyNotWellFemale: "I don't feel well",
    emergencyBathroom: "Bathroom",
    emergencyThirsty: "I want to drink",
    emergencySuction: "Need suction",
    emergencyPosition: "Change position",
    addCard: "Add Card",
    resetToDefault: "Reset to Default",
    undo: "Undo",
    doneEditing: "Done Editing",
    editBtn: "Edit",
    editItem: "Edit Item",
    addNewItem: "Add New Item",
    textMale: "Text (Male)",
    textFemale: "Text (Female)",
    emojiLabel: "Emoji",
    cancelBtn: "Cancel",
    theUser: "User",
    userSelected: "selected:",
    
    // Legal page
    legalInfo: "Legal Information",
    privacyPolicy: "Privacy Policy",
    cookiesPolicy: "Cookies Policy",
    termsAndConditions: "Terms and Conditions",
    refundPolicyTitle: "Refund Policy",
    openSource: "Open Source",
    openSourceAttribution: "Open Source Attribution",
    cookiesInUse: "Cookies in Use",
    essentialCookies: "Essential",
    essentialDesc: "Cookies required for the app to function properly",
    functionalCookies: "Functional",
    functionalDesc: "Cookies that enhance functionality and personalization",
    analyticsCookies: "Analytics",
    analyticsDesc: "Cookies used to understand how visitors use the app",
    notCurrentlyUsed: "Not currently used",
    userSettingsCookie: "Stores user preferences and settings",
    cookieConsentCookie: "Remembers cookie consent choices",
    aacDictionaryCookie: "Stores learned words and phrases",
    communicationBoardsCookie: "Stores custom communication boards",
    smartHomeSettingsCookie: "Stores smart home integration settings",
    ayuniUsesLibraries: "EyeControl App uses the following open source libraries:",
    
    // Caregiver Connect Page
    caregiverConnectTitle: "Connect Contact",
    caregiverConnectPatientLabel: "Connect to account:",
    caregiverConnectDescription: "Enable push notifications on this device to receive messages from {patientName}",
    caregiverConnectNotificationTypeTitle: "Choose notification type",
    caregiverConnectAllAlerts: "All (including help alerts)",
    caregiverConnectMessagesOnly: "Regular messages only (to keep in touch)",
    caregiverConnectEnterCodeInstruction: "Enter the code shown on the user's screen",
    caregiverConnectEnableButton: "Enable Notifications",
    caregiverConnectDeviceNote: "You'll receive notifications on this device",
    caregiverConnectContactNameLabel: "Contact Name",
    caregiverConnectContactNamePlaceholder: "e.g., Mom, David the caregiver",
    caregiverConnectContactNameHint: "Enter your name so the user can identify you",
    caregiverConnectSuccess: "Connected!",
    caregiverConnectSuccessDesc: "You will now receive alerts when {patientName} sends messages.",
    caregiverConnectSuccessNote: "You can close this page. Notifications will arrive even when the browser is closed.",
    caregiverConnectError: "Connection Failed",
    caregiverConnectTryAgain: "Try Again",
    caregiverConnectUnsupported: "Not Supported",
    caregiverConnectUnsupportedDesc: "Push notifications are not supported on this browser. Please try using Chrome, Firefox, or Edge on a mobile device or desktop.",
    caregiverConnectInvalidLink: "Invalid Link",
    caregiverConnectInvalidLinkDesc: "This link is missing required information. Please scan a valid QR code from the EyeControl App.",
    caregiverConnectRequestingPermission: "Setting up notifications...",
    caregiverConnectPermissionDenied: "Permission denied or failed to get notification token. Make sure notifications are enabled in your browser settings.",
    caregiverConnectContactNameRequired: "Please enter your name",
    caregiverConnectMissingPatientId: "Invalid link - patient ID missing",
    
    // iOS PWA Install
    iosInstallRequired: "First step: Install the app",
    iosInstallExplanation: "On iPhone, first add this app to your Home Screen, then open it from there.",
    iosInstallSteps: "How to do it:",
    iosStep1Tap: "Tap",
    iosStep1Share: "(Share) at the bottom",
    iosStep2Tap: "Select",
    iosStep2AddToHome: "Add to Home Screen",
    iosStep3Open: "Open the app from the new icon",
    iosStep4EnterCode: "Enter the code shown on the user's screen",
    iosInstallNote: "This is only needed once. After installation, notifications will work automatically.",
    enterCodePlaceholder: "Enter code",
    aboutApp: "About EyeControl App",
  },

  ar: {
    // Navigation & Layout
    home: "الرئيسية",
    back: "رجوع",
    settings: "الإعدادات",
    help: "مساعدة",
    rest: "راحة",
    clock: "الساعة",
    volume: "مستوى الصوت",
    control: "التحكم",
    cookies: "ملفات تعريف الارتباط",
    
    // Home page
    goodMorning: "صباح الخير",
    goodAfternoon: "مساء الخير",
    goodEvening: "مساء الخير",
    goodNight: "تصبح على خير",
    whatToDo: "ماذا تريد أن تفعل اليوم؟",
    whatToDoMale: "ماذا تريد أن تفعل اليوم؟",
    whatToDoFemale: "ماذا تريدين أن تفعلي اليوم؟",
    quickSpeak: "كلام سريع:",
    
    // Quick phrases
    hello: "مرحباً",
    thanks: "شكراً",
    yes: "نعم",
    no: "لا",
    please: "من فضلك",
    water: "ماء",
    food: "طعام",
    
    // Main actions
    communicationBoard: "لوحة التواصل",
    contacts: "جهات الاتصال",
    games: "ألعاب",
    youtube: "يوتيوب",
    spotify: "سبوتيفاي",
    keyboard: "لوحة مفاتيح",
    keyboardShort: "لوحة مفاتيح",
    translator: "مترجم",
    history: "السجل",
    music: "موسيقى",
    tv: "تلفزيون",
    radio: "راديو",
    calendar: "التقويم",
    news: "أخبار",
    guide: "دليل",
    smartHome: "المنزل الذكي",
    more: "المزيد",
    aiChat: "محادثة AI",
    aacKeyboard: "لوحة مفاتيح AAC",
    entertainment: "وسائط",
    
    // Settings page
    settingsTitle: "الإعدادات",
    appearance: "المظهر",
    darkMode: "الوضع الداكن",
    lightMode: "الوضع الفاتح",
    darkModeDesc: "التبديل بين العرض الداكن والفاتح",
    fontSize: "حجم الخط",
    small: "صغير",
    medium: "متوسط",
    large: "كبير",
    
    soundAndVoice: "الصوت والكلام",
    muteAll: "كتم الأصوات",
    muteAllDesc: "إيقاف جميع الأصوات",
    voiceSelection: "اختيار الصوت",
    voiceSelectionDesc: "اختر بين صوت ذكر أو أنثى",
    female: "أنثى",
    male: "ذكر",
    speechSpeed: "سرعة الكلام",
    speechLanguage: "لغة الكلام",
    speechLanguageDesc: "لغة الإخراج الصوتي (الافتراضي: لغة المستخدم)",
    
    accessibility: "إمكانية الوصول",
    keyboardNav: "التنقل بلوحة المفاتيح",
    keyboardNavDesc: "تفعيل التنقل بمفاتيح الأسهم",
    // Head tracking settings
    headTrackingRange: "نطاق حركة الرأس",
    headTrackingRangeDesc: "كم يجب تحريك الرأس للوصول إلى حافة الشاشة",
    rangeWide: "حركة كثيرة",
    rangeNarrow: "حركة قليلة",
    // Gaze tracking settings
    gazeTrackingSmoothing: "تنعيم المؤشر",
    gazeTrackingSmoothingDesc: "مدى نعومة حركة المؤشر - أبطأ = أكثر نعومة",
    smoothingLow: "دقيق (متقطع)",
    smoothingHigh: "ناعم (أبطأ)",
    
    profile: "الملف الشخصي",
    profileMale: "الملف الشخصي",
    profileFemale: "الملف الشخصي",
    name: "الاسم",
    enterName: "أدخل الاسم",
    addressing: "المخاطبة",
    neutral: "محايد",
    language: "اللغة",
    hebrew: "עברית",
    english: "English",
    arabic: "العربية",
    russian: "Русский",
    
    // Contacts page
    contactsTitle: "جهات الاتصال",
    email: "البريد الإلكتروني",
    sms: "رسالة نصية",
    whatsapp: "واتساب",
    caregiverDetails: "تفاصيل مقدم الرعاية",
    phone: "الهاتف",
    notSet: "غير محدد",
    caregiverSettings: "إعدادات مقدم الرعاية",
    caregiverEmail: "بريد مقدم الرعاية",
    pushNotificationsDescription: "لتكوين إشعارات Push لمقدمي الرعاية، انتقل إلى الإعدادات",
    goToSettings: "انتقل إلى الإعدادات",
    save: "حفظ",
    savedSuccessfully: "تم الحفظ بنجاح",
    caregiverUpdated: "تم تحديث تفاصيل مقدم الرعاية",
    to: "إلى",
    toOptional: "إلى (اختياري - الافتراضي: مقدم الرعاية)",
    message: "رسالة",
    writeMessage: "اكتب رسالتك...",
    noPhone: "لا يوجد رقم هاتف",
    enterPhoneOrSet: "يرجى إدخال رقم هاتف أو تعيين هاتف مقدم الرعاية",
    noEmail: "لا يوجد بريد إلكتروني",
    enterEmailOrSet: "يرجى إدخال بريد إلكتروني أو تعيين بريد مقدم الرعاية",
    
    // Help alert
    needHelpMale: "أحتاج مساعدة!",
    needHelpFemale: "أحتاج مساعدة!",
    close: "إغلاق",
    pressEnterToClose: "اضغط Enter للإغلاق",
    pressMale: "اضغط",
    pressFemale: "اضغطي",
    toClose: "للإغلاق",
    emoji: "رمز تعبيري",
    cells: "خلايا",
    icon: "أيقونة",
    orChooseEmoji: "أو اختر رمز تعبيري",
    preview: "معاينة",
    textMalePlaceholder: "مثال: أشعر بالألم",
    textFemalePlaceholder: "مثال: أشعر بالألم",
    openSourceDescription: "يستخدم EyeControl App مكتبات مفتوحة المصدر التالية:",
    cookiesInUseSubtitle: "Cookies in Use",
    notInUse: "غير مستخدم حالياً",

    
    // Rest mode
    restMode: "وضع الراحة",
    pressToWake: "الشاشة أو Enter للاستيقاظ",
    restModeDwellInstruction: "حافظ على نظرك على الدائرة لمدة 3 ثوانٍ",
    restModeDwellInstructionMale: "حافظ على نظرك على الدائرة لمدة 3 ثوانٍ",
    restModeDwellInstructionFemale: "حافظي على نظرك على الدائرة لمدة 3 ثوانٍ",
    restModeSelectInstruction: "قم بإجراء التحديد 3 مرات للخروج",
    restModeSelectInstructionMale: "قم بإجراء التحديد 3 مرات للخروج",
    restModeSelectInstructionFemale: "قومي بإجراء التحديد 3 مرات للخروج",
    restModeVoiceInstruction: "قل الرقم ثلاث مرات",
    restModeVoiceInstructionMale: "قل الرقم ثلاث مرات",
    restModeVoiceInstructionFemale: "قولي الرقم ثلاث مرات",
    pressEscapeToWake: "يمكنك الضغط على Escape للخروج السريع",
    mediaRestBlinkInstruction: "اغمض 3 مرات للخروج",
    mediaRestBlinkInstructionMale: "اغمض 3 مرات للخروج",
    mediaRestBlinkInstructionFemale: "اغمضي 3 مرات للخروج",
    
    // Time info
    sunday: "الأحد",
    monday: "الإثنين",
    tuesday: "الثلاثاء",
    wednesday: "الأربعاء",
    thursday: "الخميس",
    friday: "الجمعة",
    saturday: "السبت",
    day: "يوم",
    january: "يناير",
    february: "فبراير",
    march: "مارس",
    april: "أبريل",
    may: "مايو",
    june: "يونيو",
    july: "يوليو",
    august: "أغسطس",
    september: "سبتمبر",
    october: "أكتوبر",
    november: "نوفمبر",
    december: "ديسمبر",
    loadingLocation: "جاري تحميل الموقع...",
    locationUnavailable: "الموقع غير متاح",
    unknownLocation: "موقع غير معروف",
    locationError: "خطأ في تحميل الموقع",
    noLocationPermission: "لا يوجد إذن للموقع",
    loadingWeather: "جاري تحميل الطقس...",
    weatherUnavailable: "الطقس غير متاح",
    
    // Volume
    volumeTitle: "مستوى الصوت",
    veryLow: "منخفض جداً",
    low: "منخفض",
    mediumVol: "متوسط",
    high: "عالي",
    veryHigh: "عالي جداً",
    navInstructions: "↑↓ للتنقل • Enter للاختيار",
    
    // Control Methods
    controlMethodsTitle: "كيف تريد التحكم في التطبيق؟",
    controlMethodsSubtitle: "اختر طريقة التحكم المناسبة لك",
    control_standard_pointer_title: "اللمس / الماوس",
    control_standard_pointer_desc: "التحكم القياسي باللمس أو الماوس",
    control_voice_title: "التحكم الصوتي",
    control_voice_desc: "التحكم بالأوامر الصوتية",
    control_eye_control_title: "جهاز EyeControl",
    control_eye_control_desc: "التحكم بجهاز EyeControl",
    control_external_switch_title: "مفاتيح خارجية",
    control_external_switch_desc: "التحكم بالمفاتيح",
    control_gaze_tracking_title: "تتبع النظر",
    control_gaze_tracking_desc: "التحكم بحركات العين",
    control_head_tracking_title: "تتبع الرأس",
    control_head_tracking_desc: "التحكم بحركات الرأس",
    control_mouth_gestures_title: "إيماءات الفم",
    control_mouth_gestures_desc: "التحكم بحركات الفم",
    controlSetup: "إعداد التحكم",
    selectGesturesMale: "اختر الإيماءات التي يمكنك أداؤها",
    selectGesturesFemale: "اختاري الإيماءات التي يمكنك أداؤها",
    lookUp: "نظر للأعلى",
    lookDown: "نظر للأسفل",
    lookLeft: "نظر لليسار",
    lookRight: "نظر لليمين",
    blink: "رمش",
    gesture1Desc: "إيماءة واحدة - اختيار فقط (مسح تلقائي)",
    gesture2Desc: "إيماءتان - اختيار ورجوع",
    gesture3Desc: "ثلاث إيماءات - اختيار، التالي، ورجوع",
    continueButton: "متابعة",
    previousButton: "السابق",
    nextButton: "التالي",
    
    // AAC & Communication
    aacTitle: "لوحة مفاتيح AAC",
    speak: "تحدث",
    clear: "مسح",
    delete: "حذف",
    space: "مسافة",
    enter: "إدخال",
    wordCompletion: "إكمال الكلمات",
    acronymMode: "وضع الاختصارات",
    suggestions: "اقتراحات",
    recentWords: "كلمات حديثة",
    addToDictionary: "إضافة للقاموس",
    
    // Communication Board
    boardTitle: "لوحة التواصل",
    editBoard: "تحرير اللوحة",
    editBoards: "تحرير اللوحات",
    userContacts: "جهات الاتصال",
    userContactsTitle: "جهات اتصال المستخدم",
    editHelpBoard: "تحرير لوحة المساعدة",
    editCommunicationBoard: "تحرير لوحة التواصل",
    editTopActionBar: "تحرير شريط الإجراءات العلوي",
    addCategory: "إضافة فئة",
    spatialNavigation: "التنقل المكاني",
    createBoard: "إنشاء لوحة جديدة",
    boardName: "اسم اللوحة",
    selectIcon: "اختر أيقونة",
    selectColor: "اختر لون",
    category: "فئة",
    utterance: "عبارة",
    rows: "صفوف",
    columns: "أعمدة",
    deleteBoard: "حذف اللوحة",
    saveBoard: "حفظ اللوحة",
    
    // Actions menu
    speakAction: "نطق",
    sendToContacts: "إرسال لجهات الاتصال",
    sendToAI: "إرسال لمحادثة AI",
    translateAction: "ترجمة",
    addToDict: "إضافة للقاموس",
    
    // Translation
    translateTitle: "ترجمة",
    selectLanguage: "اختر اللغة",
    translatedText: "النص المترجم",
    speakTranslation: "نطق الترجمة",
    
    // AI Chat
    aiChatTitle: "محادثة مع AI",
    typeMessage: "اكتب رسالة...",
    sendMessage: "إرسال",
    clearChat: "مسح المحادثة",
    aiThinking: "AI يفكر...",
    
    // YouTube
    youtubeTitle: "يوتيوب",
    searchVideos: "بحث عن فيديوهات",
    search: "بحث",
    searchTab: "بحث",
    noResults: "لا توجد نتائج",
    views: "مشاهدات",
    
    // TV & Radio
    tvTitle: "تلفزيون",
    radioTitle: "راديو",
    selectCountry: "اختر الدولة",
    selectGenre: "اختر النوع",
    channels: "قنوات",
    stations: "محطات",
    nowPlaying: "يعمل الآن",
    
    // Games
    gamesTitle: "ألعاب",
    accessibleGameHub: "مركز الألعاب المتاحة",
    accessibleGameHubDesc: "ألعاب مكيفة لجميع طرق التحكم",
    memoryGame: "لعبة الذاكرة",
    memoryGameDesc: "اعثر على أزواج متطابقة من البطاقات",
    game2048: "2048",
    game2048Desc: "ادمج البلاطات للوصول إلى 2048",
    slidingPuzzle: "لغز التحريك",
    slidingPuzzleDesc: "حل اللغز بأقل الحركات",
    simonSays: "سيمون يقول",
    simonSaysDesc: "كرر أنماط الألوان",
    dinoRunner: "دينو رانر",
    dinoRunnerDesc: "اقفز فوق العوائق - مفتاح واحد",
    pongGame: "بونج",
    pongGameDesc: "تنس الطاولة - مفتاحان",
    spaceDefender: "مدافع الفضاء",
    spaceDefenderDesc: "دافع عن سفينتك - 5 مفاتيح",
    balloonPopper: "فرقعة البالونات",
    balloonPopperDesc: "تركيز النظر - بدون نقر",
    gridMemoryGame: "ذاكرة الأرقام",
    gridMemoryDesc: "التحكم الصوتي - قل رقماً",
    moves: "الحركات",
    newGame: "لعبة جديدة",
    wonInMoves: "فزت في {0} حركات!",
    gameSoonAvailable: "اللعبة قادمة قريباً",
    cellScanning: "مسح الخلايا",
    rowScanning: "مسح الصفوف",
    ticTacToe: "إكس أو",
    puzzle: "لغز",
    startGame: "بدء اللعبة",
    yourTurn: "دورك",
    aiTurn: "دور AI",
    youWin: "فزت!",
    youWon: "فزت!",
    aiWins: "AI فاز",
    draw: "تعادل",
    playAgain: "العب مرة أخرى",
    gameOver: "انتهت اللعبة",
    score: "النقاط",
    highScore: "أعلى نتيجة",
    up: "أعلى",
    down: "أسفل",
    left: "يسار",
    right: "يمين",
    slidingPuzzleHint: "انقر على البلاطات المجاورة لتحريكها",
    simonSaysHint: "كرر التسلسل بالنقر على الألوان",
    watchTheSequence: "شاهد التسلسل...",
    missed: "فائتة",
    dinoTapToJump: "اضغط على أي مفتاح أو المس الشاشة للقفز",
    dinoTapAnywhere: "المس أي مكان للقفز",
    pongInstructions: "استخدم أسهم أعلى/أسفل أو الأزرار للتحكم بالمضرب",
    balloonPopperInstructions: "أبقِ نظرك على البالون لثانية لتفجيره",
    balloonPopperHint: "حرك نظرك فوق البالون وابقَ ثانية لتفجيره | بدون نقر!",
    
    // Smart Home
    smartHomeTitle: "المنزل الذكي",
    lights: "الإضاءة",
    lightsOn: "تشغيل",
    lightsOff: "إيقاف",
    brightness: "السطوع",
    webhookButtons: "أزرار Webhook",
    addButton: "إضافة زر",
    buttonName: "اسم الزر",
    webhookUrl: "عنوان Webhook",
    
    // Scanning
    scanningSettings: "إعدادات المسح",
    automaticScan: "مسح تلقائي",
    manualScan: "مسح يدوي",
    scanSpeed: "سرعة المسح",
    rowAndColumn: "صف وعمود",
    cellByCell: "خلية بخلية",
    
    // New SRS scanning/cursor settings
    dwellTime: "وقت التوقف",
    dwellTimeDesc: "كم من الوقت للبقاء على عنصر قبل الاختيار",
    seconds: "ثواني",
    firstItemDelay: "تأخير العنصر الأول",
    firstItemDelayDesc: "توقف إضافي عند الدخول إلى مجموعة جديدة",
    offSetting: "إيقاف",
    normalSetting: "عادي",
    longSetting: "طويل",
    cursorSettings: "إعدادات المؤشر",
    cursorMagnetism: "مغناطيسية المؤشر",
    cursorMagnetismDesc: "سحب المؤشر نحو الأزرار",
    weakSetting: "ضعيف",
    strongSetting: "قوي",
    cursorSmoothingSetting: "تنعيم المؤشر",
    cursorSmoothingDesc: "مستوى استقرار حركة المؤشر",
    lowSetting: "منخفض",
    highSetting: "عالي",
    
    scanMode: "وضع المسح",
    cellByCellMode: "خلية بخلية",
    cellByCellDesc: "المسح يمر على كل خلية بشكل منفصل",
    rowAndColumnMode: "صف وعمود",
    rowAndColumnDesc: "أولاً اختر صف، ثم خلية في الصف",
    scanSpeedLabel: "سرعة المسح",
    slow: "بطيء",
    fast: "سريع",
    automaticScanning: "مسح تلقائي",
    gestureScanning: "مسح بالإيماءات",
    selectScanTypeMale: "اختر نوع المسح:",
    selectScanTypeFemale: "اختاري نوع المسح:",
    
    // Head/Gaze Tracking
    headTrackingTitle: "تتبع الرأس - الإعدادات",
    gazeTrackingTitle: "تتبع النظر - الإعدادات",
    mouthGesturesTitle: "إيماءات الفم - الإعدادات",
    calibration: "المعايرة",
    startCalibration: "بدء المعايرة",
    calibrationComplete: "اكتملت المعايرة",
    lookAtPoint: "انظر إلى النقطة",
    sensitivity: "الحساسية",
    testTracking: "اختبار التتبع",
    finishSetup: "إنهاء الإعداد",
    
    // Mouth Gestures
    selectGestures: "اختر حتى 3 إيماءات للتحكم",
    smile: "ابتسامة",
    smileDesc: "ابتسم بشكل واسع",
    openMouth: "فتح الفم",
    openMouthDesc: "افتح فمك بشكل واسع",
    kiss: "قبلة",
    kissDesc: "اجمع شفتيك",
    
    // Voice Control
    voiceControlTitle: "التحكم الصوتي - الإعدادات",
    wakeWord: "كلمة التنبيه",
    voiceCommands: "الأوامر الصوتية",
    sayCommand: "قل أمراً",
    
    // External Switch
    externalSwitchTitle: "المفاتيح الخارجية - الإعدادات",
    switchCount: "عدد المفاتيح",
    assignActions: "تعيين الإجراءات",
    pressSwitch: "اضغط على مفتاح",
    pressSwitchFemale: "اضغطي على مفتاح",
    switchLabel: "مفتاح",
    switchesLabel: "مفاتيح",
    switch1Desc: "مفتاح واحد - اختيار فقط (مسح تلقائي)",
    switch2Desc: "مفتاحان - اختيار ورجوع",
    switch3Desc: "ثلاثة مفاتيح - اختيار، التالي، الرجوع",
    switch4Desc: "أربعة مفاتيح - اختيار، التالي، السابق ورجوع",
    switch5Desc: "خمسة مفاتيح - تنقل اتجاهي كامل",
    selectSwitchCountMale: "اختر عدد المفاتيح:",
    selectSwitchCountFemale: "اختاري عدد المفاتيح:",
    scanType: "نوع المسح",
    automaticScanType: "تلقائي",
    manualScanType: "يدوي",
    cursorMovesAutoSelect: "المؤشر يتحرك تلقائياً، اضغط للاختيار",
    cursorMovesOnPress: "المؤشر يتحرك فقط عند الضغط على المفتاح",
    recordSwitchInputMale: "اضغط على كل مفتاح لتسجيل إدخاله",
    recordSwitchInputFemale: "اضغطي على كل مفتاح لتسجيل إدخاله",
    testSwitchInputMale: "اضغط على كل مفتاح للتحقق من أن النظام يتعرف عليه",
    testSwitchInputFemale: "اضغطي على كل مفتاح للتحقق من أن النظام يتعرف عليه",
    recorded: "مسجّل",
    pressToRecordMale: "اضغط على المفتاح...",
    pressToRecordFemale: "اضغطي على المفتاح...",
    allSwitchesConfigured: "تم تكوين جميع المفاتيح بنجاح!",
    selectAction: "اختيار",
    cancelAction: "إلغاء",
    nextAction: "التالي",
    previousAction: "السابق",
    backAction: "رجوع",
    upAction: "أعلى",
    downAction: "أسفل",
    leftAction: "يسار",
    rightAction: "يمين",
    
    // Action Mapping
    actionMappingTitle: "ربط الإجراءات",
    clickGestureToChangeMale: "انقر على إيماءة لتغييرها:",
    clickGestureToChangeFemale: "انقري على إيماءة لتغييرها:",
    selectGesturePrompt: "اختر إيماءة",
    blinkGesture: "رمش / إغلاق العينين",
    blinkGestureShort: "رمش",
    lookUpGesture: "نظر لأعلى (أعلى)",
    lookUpGestureShort: "نظر لأعلى",
    lookDownGesture: "نظر لأسفل (أسفل)",
    lookDownGestureShort: "نظر لأسفل",
    lookLeftGesture: "نظر لليسار (يسار)",
    lookLeftGestureShort: "نظر لليسار",
    lookRightGesture: "نظر لليمين (يمين)",
    lookRightGestureShort: "نظر لليمين",
    selectEnter: "اختيار (Enter)",
    fullDirectionalNav: "تنقل مكاني كامل",
    fullDirectionalNavDesc: "تنقل حر في جميع الاتجاهات",
    advancedNav: "تنقل متقدم",
    advancedNavDesc: "اختيار، التالي، السابق ورجوع",
    manualScanNav: "مسح يدوي",
    manualScanNavDesc: "اختيار، التالي والرجوع",
    autoScanWithCancel: "مسح مع رجوع",
    autoScanWithCancelDesc: "مسح تلقائي مع خيار الرجوع",
    autoScanOnly: "مسح تلقائي",
    autoScanOnlyDesc: "المسح يتحرك تلقائياً، إيماءة واحدة للاختيار",
    
    // Head/Gaze Tracking Setup
    faceAndEyeDetection: "كشف الوجه والعينين",
    faceAndEyeDetectionDesc: "النظام يكشف وجهك وعينيك. تأكد أن وجهك في منتصف الشاشة.",
    searchingForFace: "جاري البحث عن وجه...",
    tooClose: "قريب جداً - ابتعد عن الكاميرا",
    tooFar: "بعيد جداً - اقترب من الكاميرا",
    distanceGood: "المسافة ممتازة!",
    initializingTracking: "جاري تهيئة التتبع...",
    eyePointsMarkedCyan: "نقاط العين محددة باللون السماوي",
    foundPreviousCalibration: "تم العثور على معايرة سابقة - يمكنك استخدامها أو إعادة المعايرة",
    usePreviousCalibration: "استخدم المعايرة السابقة",
    recalibrate: "أعد المعايرة",
    foundPreviousSetup: "تم العثور على إعداد سابق - يمكنك البدء فوراً أو الإعداد مجدداً",
    startImmediately: "ابدأ فوراً",
    setupAgain: "أعد الإعداد",
    testGazeTracking: "اختبار تتبع النظر",
    lookAtContinueButton: "انظر إلى زر \"متابعة\" لتفعيله",
    excellentClickToContinue: "ممتاز! انقر للمتابعة",
    gazeTrackingActiveTitle: "وضع النظر نشط",
    gazeTrackingReadyDesc: "النظام جاهز! سيتبع المؤشر نظرك. توقف على عنصر لاختياره.",
    testButton: "زر",
    cameraErrorCannotAccess: "لا يمكن الوصول للكاميرا - تأكد من توصيل الكاميرا ومنح الإذن",
    videoElementError: "خطأ في الوصول لعنصر الفيديو",
    faceModelLoadError: "خطأ في تحميل نموذج كشف الوجه",
    
    // Mouth Gesture Setup
    neutralCalibration: "معايرة الحالة المحايدة",
    neutralCalibrationDesc: "أرخِ وجهك في حالة طبيعية",
    gestureCalibration: "معايرة الإيماءة",
    performGesture: "قم بأداء الإيماءة",
    gestureTestTitle: "اختبار الإيماءات",
    testGesturesDesc: "قم بأداء الإيماءات التي اخترتها للتحقق من أن النظام يتعرف عليها",
    allGesturesTestedSuccess: "تم اختبار جميع الإيماءات بنجاح!",
    
    // Voice Control Setup
    voiceControlSetupTitle: "التحكم الصوتي",
    voiceControlTestTitle: "اختبار التحكم الصوتي",
    voiceControlExplanation: "كل زر على الشاشة سيظهر رقماً بجانبه. قل الرقم للضغط على الزر.",
    voiceControlExplanationFemale: "كل زر على الشاشة سيظهر رقماً بجانبه. قولي الرقم للضغط على الزر.",
    voiceControlExample: 'مثال: قل "1" للضغط على الزر الأول',
    voiceControlExampleFemale: 'مثال: قولي "1" للضغط على الزر الأول',
    voiceControlWakeWord: 'كلمة التنبيه: "EyeControl"',
    voiceControlWakeWordDesc: 'قل "EyeControl" لإيقاف أو استئناف الاستماع. عند الإيقاف، ستختفي الأرقام من الشاشة.',
    voiceControlWakeWordDescFemale: 'قولي "EyeControl" لإيقاف أو استئناف الاستماع. عند الإيقاف، ستختفي الأرقام من الشاشة.',
    voiceControlSubtitle: "تحكم في التطبيق بصوتك",
    nowYourTurn: "الآن دورك!",
    sayTheNumber: "قل الرقم بجانب الزر الأخضر",
    sayTheNumberFemale: "قولي الرقم بجانب الزر الأخضر",
    youSaid: "قلت:",
    listeningActive: "جاري الاستماع...",
    clickToStart: "انقر للبدء",
    startTest: "ابدأ الاختبار",
    successes: "النجاحات:",
    buttonLabel: "زر",
    
    // Head Tracking Setup
    headTrackingSetupTitle: "تتبع الرأس",
    faceDetectionTitle: "كشف الوجه",
    faceDetectionDesc: "النظام يكتشف وجهك. تأكد من أن وجهك في منتصف الشاشة.",
    trackingTestTitle: "اختبار التتبع",
    trackingTestDesc: 'حرّك رأسك للوصول بالنقطة إلى زر "متابعة"',
    cursorActiveTitle: "وضع المؤشر نشط",
    cursorActiveDesc: "النظام جاهز! سيتبع المؤشر حركات رأسك. توقف على عنصر لاختياره.",
    
    // Gaze Tracking Setup
    gazeTrackingSetupTitle: "تتبع النظر",
    gazeTestDesc: 'انظر إلى زر "متابعة" لتفعيله',
    gazeActiveTitle: "وضع النظر نشط",
    gazeActiveDesc: "النظام جاهز! سيتبع المؤشر نظرك. توقف على عنصر لاختياره.",
    
    // Mouth Gesture Setup (additional)
    mouthGestureSetupTitle: "إعداد إيماءات الفم",
    selectUpTo3Gestures: "اختر حتى 3 إيماءات تريد استخدامها للتحكم",
    selectUpTo3GesturesFemale: "اختاري حتى 3 إيماءات تريدين استخدامها للتحكم",
    actionMapping: "ربط الإجراءات",
    selectActionForGesture: "اختر ماذا ستفعل كل إيماءة",
    selectActionForGestureFemale: "اختاري ماذا ستفعل كل إيماءة",
    scanSettingsTitle: "إعدادات المسح",
    scanModeLabel: "وضع المسح:",
    manualScanning: "مسح يدوي",
    gesture3ManualDesc: "3 إيماءات - تحرك المؤشر للأمام والخلف",
    gesture2AutoDesc: "إيماءتان - المسح يتحرك تلقائياً، إيماءة للاختيار وإيماءة للرجوع",
    gesture1AutoDesc: "إيماءة واحدة - المسح يتحرك تلقائياً، إيماءة للاختيار فقط",
    scanCellsMode: "خلايا",
    rowsAndColumns: "صفوف وأعمدة",
    scanSpeedSeconds: "سرعة المسح: {0} ثانية",
    usePreviousCalibrationOption: "تم العثور على معايرة سابقة - يمكنك استخدامها أو إعادة المعايرة",
    usePreviousBtn: "استخدم المعايرة السابقة",
    recalibrateBtn: "أعد المعايرة",
    neutralCalibrationTitle: "المعايرة - وجه مسترخي",
    keepFaceRelaxed: "حافظ على وجهك مسترخياً وفمك مغلقاً. انقر على الزر للالتقاط.",
    keepFaceRelaxedFemale: "حافظي على وجهك مسترخياً وفمك مغلقاً. انقري على الزر للالتقاط.",
    faceDetected: "تم كشف الوجه ✓",
    faceNotDetected: "لم يتم كشف الوجه",
    capturing: "جاري الالتقاط...",
    capture: "التقاط",
    gestureCalibrationTitle: "المعايرة - {0}",
    performGestureDesc: "قم بالإيماءة: {0}",
    performGestureDescFemale: "قومي بالإيماءة: {0}",
    gestureTestDesc: "قم بكل إيماءة للتحقق من أن النظام يتعرف عليها",
    gestureTestDescFemale: "قومي بكل إيماءة للتحقق من أن النظام يتعرف عليها",
    neutralState: "محايد",
    allGesturesDetected: "تم كشف جميع الإيماءات بنجاح!",
    setupComplete: "اكتمل الإعداد!",
    gesturesCalibrated: "تمت معايرة إيماءات الفم بنجاح. يمكنك الآن استخدامها للتحكم في التطبيق.",
    gesturesCalibratedFemale: "تمت معايرة إيماءات الفم بنجاح. يمكنك الآن استخدامها للتحكم في التطبيق.",
    configStage: "الإعدادات",
    calibrateStage: "المعايرة",
    calibrateGestureStage: "معايرة الإيماءات",
    testStage: "الاختبار",
    completeStage: "مكتمل",
    
    // External Switch Setup
    switchSetupTitle: "إعداد المفاتيح",
    recordingSwitchesTitle: "تسجيل المفاتيح",
    testingSwitchesTitle: "اختبار المفاتيح",
    stageXOfY: "المرحلة {0} من {1}",
    pressSwitchToRecord: "اضغط على كل مفتاح لتسجيل إدخاله",
    pressSwitchToRecordFemale: "اضغطي على كل مفتاح لتسجيل إدخاله",
    recordedLabel: "مسجل: {0}",
    pressSwitchPrompt: "اضغط على المفتاح...",
    pressSwitchPromptFemale: "اضغطي على المفتاح...",
    pressSwitchToTest: "اضغط على كل مفتاح للتحقق من أن النظام يتعرف عليه",
    pressSwitchToTestFemale: "اضغطي على كل مفتاح للتحقق من أن النظام يتعرف عليه",
    allSwitchesRecognized: "ممتاز! تم التعرف على جميع المفاتيح بنجاح",
    
    // Additional switch setup keys
    performEachGestureToTest: "قم بكل إيماءة للتحقق من أن النظام يتعرف عليها",
    performEachGestureToTestFemale: "قومي بكل إيماءة للتحقق من أن النظام يتعرف عليها",
    
    // General UI
    loading: "جاري التحميل...",
    error: "خطأ",
    retry: "إعادة المحاولة",
    cancel: "إلغاء",
    confirm: "تأكيد",
    edit: "تحرير",
    add: "إضافة",
    remove: "إزالة",
    next: "التالي",
    previous: "السابق",
    finish: "إنهاء",
    continue: "متابعة",
    skip: "تخطي",
    select: "اختيار",
    selected: "محدد",
    
    // Camera/Tracking Errors
    cameraError: "لا يمكن الوصول إلى الكاميرا - تأكد من توصيل الكاميرا ومنح الإذن",
    videoError: "خطأ في الوصول إلى عنصر الفيديو",
    faceModelError: "خطأ في تحميل نموذج اكتشاف الوجه",
    searchingFace: "جارٍ البحث عن وجه...",
    
    // Guide
    guideTitle: "دليل المستخدم",
    guideIntro: "مرحباً بك في دليل مستخدم EyeControl App",
    guideIntroDesc: "EyeControl App هو نظام تواصل بديل ومعزز (AAC) متقدم مصمم للأشخاص ذوي الإعاقات التواصلية والحركية. سيساعدك هذا الدليل على التعرف على جميع الميزات في النظام.",
    
    // Guide sections
    guideControlMethods: "طرق التحكم",
    guideControlMethodsDesc: "يدعم النظام جهاز EyeControl واللمس والمفاتيح الخارجية:",
    guideControlEyeControl: "جهاز EyeControl - جهاز تواصل يعتمد على النظر للتحكم الكامل في التطبيق",
    guideControlEyeControlGestures: "↳ اختيار الإيماءات: يمكن اختيار 1–6 إيماءات للعين (مثل الرمش، النظر لأعلى/أسفل). 4 إيماءات فأكثر تُفعّل وضع التحكم اليدوي — كل إيماءة تنفذ إجراءً محدداً",
    guideControlEyeControlScanning: "↳ المسح التلقائي: حتى 3 إيماءات تُفعّل المسح التلقائي — يتنقل النظام بين العناصر بسرعة قابلة للضبط. يمكن ضبط سرعة المسح في الإعدادات",
    guideControlTouch: "اللمس/الماوس - التحكم القياسي باللمس أو النقر بالماوس",
    guideControlHead: "تتبع الرأس - تحكم في المؤشر بتحريك رأسك. الكاميرا تتبع حركات رأسك",
    guideControlGaze: "تتبع النظر - تحكم في المؤشر بحركات العين باستخدام معايرة 9 نقاط",
    guideControlMouth: "إيماءات الفم - تحكم في المسح بالابتسامة أو فتح الفم أو القبلة",
    guideControlSwitch: "المفاتيح الخارجية - وصّل 1-5 مفاتيح فعلية للتحكم في المسح",
    guideControlVoice: "التحكم الصوتي - أعط أوامر صوتية للتنقل والاختيار",
    
    guideCommunication: "التواصل",
    guideCommunicationDesc: "أدوات تواصل متقدمة:",
    guideCommBoard: "لوحة التواصل - لوحات مخصصة مع فئات وعبارات. انقر على عنصر لنطقه",
    guideCommAAC: "لوحة مفاتيح AAC - الكتابة مع إكمال الكلمات الذكي ووضع الاختصارات والنطق",
    guideCommAI: "محادثة AI - تحدث مع مساعد AI ذكي يمكنه مساعدتك في صياغة الرسائل",
    guideCommContacts: "جهات الاتصال - أرسل رسائل SMS أو واتساب أو بريد إلكتروني لمقدم الرعاية أو جهات اتصال أخرى",
    guideCommTranslator: "المترجم - ترجم النص إلى لغات مختلفة مع خيار النطق",

    guideContacts: "جهات الاتصال",
    guideContactsDesc: "يمكن حفظ جهات اتصال المستخدم عبر القائمة > جهات الاتصال.",
    guideContactsItem0: "يمكن حفظ جهات اتصال المستخدم لإرسال الرسائل من النظام",
    guideContactsItem1: "يمكن لجهات الاتصال مسح رمز QR أو فتح رابط على هواتفهم لتأكيد استقبال رسائل المستخدم كإشعارات على الهاتف الشخصي",
    guideContactsItem2: "يمكن اختيار نوع الإشعارات: الكل (بما في ذلك نداء المساعدة) — أو الرسائل العادية فقط للتواصل",
    guideContactsItem3: "ستتلقى جهات الاتصال إشعارات وفقاً للرسائل التي يرسلها المستخدم",
    guideContactsItem4: "إذا كان استقبال نداء المساعدة مفعّلاً — يُرسل تنبيه فوري عندما يضغط المستخدم على زر المساعدة",

    guideMedia: "الوسائط والترفيه",
    guideMediaDesc: "يوتيوب والراديو والموسيقى مباشرة من التطبيق:",
    guideMediaYT: "يوتيوب - ابحث وشاهد الفيديوهات مباشرة في التطبيق",
    guideMediaTV: "التلفزيون - شاهد قنوات IPTV من إسرائيل وحول العالم",
    guideMediaRadio: "الراديو - استمع لمحطات الراديو حسب الدولة أو النوع",
    guideMediaGames: "الألعاب - ألعاب الذاكرة وإكس-أو والألغاز",
    
    guideSmartHome: "المنزل الذكي",
    guideSmartHomeDesc: "تحكم في الأجهزة الذكية في منزلك:",
    guideSmartLights: "الإضاءة - التحكم في مصابيح Philips Hue",
    guideSmartHA: "Home Assistant - الاتصال بنظام Home Assistant",
    guideSmartWebhook: "Webhooks - أزرار مخصصة لإجراءات Make/Zapier/IFTTT",
    
    guideSettings: "الإعدادات",
    guideSettingsDesc: "خصص النظام حسب احتياجاتك:",
    guideSettingsAppearance: "المظهر - الوضع الداكن/الفاتح، حجم الخط",
    guideSettingsVoice: "الصوت - اختر صوت ذكر/أنثى، سرعة الكلام، كتم الصوت",
    guideSettingsProfile: "الملف الشخصي - الاسم، اللغة، أسلوب المخاطبة",
    guideSettingsControl: "التحكم - عيّن طريقة التحكم المفضلة لديك",
    guideSettingsBoards: "محرر اللوحات – تخصيص المحتوى والشاشات المختلفة للمستخدم. الشاشة الرئيسية والترفيه- تحديد المحتوى والترتيب المكاني. طلب المساعدة- تحرير الرسائل التي تظهر بعد طلب المساعدة. لوحة التواصل- تحرير الرسائل والعناصر المرئية والترتيب المكاني. لوحة المفاتيح- تحرير الإجراءات المصاحبة.",
    
    guideAccessibility: "إمكانية الوصول",
    guideAccessibilityDesc: "ميزات إمكانية الوصول المتقدمة:",
    guideAccessScanning: "المسح - مسح تلقائي أو يدوي لعناصر الشاشة",
    guideAccessDwell: "النقر بالتوقف - نقر تلقائي بعد التوقف على عنصر",
    guideAccessHelp: "زر المساعدة - تنبيه صوتي أو صوت لطلب المساعدة",
    guideAccessRest: "وضع الراحة - شاشة داكنة للاستراحة من النظام",
    
    guideTips: "نصائح",
    guideTipsDesc: "نصائح للاستخدام الفعال:",
    guideTip1: "ابدأ بأبسط طريقة تحكم لك وتقدم تدريجياً",
    guideTip2: "اضبط سرعة المسح وحساسية التتبع لأقصى راحة",
    guideTip3: "أضف الكلمات الشائعة إلى قاموسك الشخصي للوصول السريع",
    guideTip4: "استخدم لوحات التواصل المخصصة لمواضيع محددة",
    guideTip5: "يمكنك بناء لوحة تواصل مخصصة للمواضيع اليومية واحتياجاتك الخاصة",
    
    // Auth
    login: "تسجيل الدخول",
    signup: "إنشاء حساب",
    loginToAccount: "سجل دخولك إلى حسابك",
    createAccount: "إنشاء حساب جديد",
    emailLabel: "البريد الإلكتروني",
    passwordLabel: "كلمة المرور",
    invalidEmail: "عنوان بريد إلكتروني غير صالح",
    passwordMinLength: "يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل",
    loginSuccess: "تم تسجيل الدخول بنجاح",
    welcomeBack: "مرحباً بعودتك!",
    signupSuccess: "تم التسجيل بنجاح",
    checkEmail: "تم إرسال بريد التحقق. يرجى التحقق من صندوق الوارد.",
    authError: "حدث خطأ",
    invalidCredentials: "بريد إلكتروني أو كلمة مرور غير صحيحة",
    userExists: "المستخدم مسجل بالفعل، حاول تسجيل الدخول",
    emailNotConfirmed: "يرجى تأكيد بريدك الإلكتروني قبل تسجيل الدخول",
    passwordBreached: "تم العثور على كلمة المرور هذه في قائمة كلمات مرور مسربة. من أجل أمان حسابك، يرجى اختيار كلمة مرور مختلفة وفريدة.",
    googleSignInError: "خطأ في تسجيل الدخول باستخدام Google",
    or: "أو",
    noAccount: "ليس لديك حساب؟",
    haveAccount: "لديك حساب بالفعل؟",
    forgotPassword: "نسيت كلمة المرور؟",
    resetPassword: "إعادة تعيين كلمة المرور",
    resetEmailSent: "تم الإرسال بنجاح",
    resetEmailDesc: "تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني",
    resetError: "خطأ في إرسال البريد، يرجى المحاولة مرة أخرى",
    sendResetEmail: "إرسال رابط",
    backToLogin: "العودة لتسجيل الدخول",
    invalidResetLink: "رابط إعادة التعيين غير صالح أو منتهي الصلاحية",
    passwordsDoNotMatch: "كلمات المرور غير متطابقة",
    passwordResetSuccess: "تم تحديث كلمة المرور بنجاح",
    passwordResetSuccessDesc: "يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة",
    newPassword: "كلمة مرور جديدة",
    confirmNewPassword: "تأكيد كلمة المرور الجديدة",
    setNewPassword: "تعيين كلمة مرور جديدة",
    
    // MFA
    twoFactorAuth: "التحقق بخطوتين",
    enterAuthCode: "أدخل الرمز من تطبيق المصادقة",
    verificationCode: "رمز التحقق",
    verifyAndLogin: "تحقق وسجل الدخول",
    mfaCodeError: "يجب أن يحتوي رمز التحقق على 6 أرقام",
    mfaCodeWrong: "رمز التحقق غير صحيح، يرجى المحاولة مرة أخرى",
    
    // Email Verification
    verifyingEmail: "جارٍ التحقق من بريدك الإلكتروني...",
    pleaseWait: "يرجى الانتظار",
    emailVerified: "تم التحقق من البريد الإلكتروني بنجاح!",
    emailVerifiedDesc: "تم التحقق من عنوان البريد الإلكتروني {email}. يمكنك الآن تسجيل الدخول.",
    goToLogin: "الذهاب لتسجيل الدخول",
    tokenExpired: "انتهت صلاحية الرابط",
    tokenExpiredDesc: "انتهت صلاحية رابط التحقق. يرجى التسجيل مرة أخرى.",
    backToSignup: "العودة للتسجيل",
    verificationFailed: "فشل التحقق",
    verificationFailedDesc: "الرابط غير صالح أو تم استخدامه بالفعل.",
    
    myVoice: "صوتي",
    voiceCloning: "استنساخ الصوت",
    voiceCloningDesc: "إنشاء صوت مخصص من تسجيلك",
    
    // Night Monitoring
    nightMonitoringTitle: "مراقبة الليل",
    nightMonitoringDesc: "تنبيه مقدم الرعاية عندما يكون المستخدم مستيقظًا في الليل",
    nightMonitoringEyeControlOnly: "مراقبة الليل متاحة فقط في وضع التحكم بالعين",
    nightCaregiverEmail: "بريد مقدم الرعاية",
    nightCaregiverEmailDesc: "سيتم إرسال التنبيهات إلى هذا العنوان",
    nightHoursRange: "نطاق ساعات الليل",
    startTime: "وقت البدء",
    endTime: "وقت الانتهاء",
    awakeDurationThreshold: "مدة الاستيقاظ للتنبيه",
    awakeDurationDesc: "إذا كان المستخدم مستيقظًا لفترة أطول من هذه، سيتم إرسال تنبيه",
    minutes: "دقائق",
    howItWorks: "كيف يعمل؟",
    nightMonitoringInfo1: "عندما يكون المستخدم نائمًا، يرسل التحكم بالعين إشارة Enter مستمرة",
    nightMonitoringInfo2: "عندما تتوقف الإشارة لفترة طويلة، يكتشف النظام الاستيقاظ",
    nightMonitoringInfo3: "بعد الوقت المحدد، يتم إرسال تنبيه إلى مقدم الرعاية",
    cloneAgain: "استنساخ مرة أخرى",
    cloneVoice: "استنساخ الصوت",
    
    // User Contacts
    caregiverAlerts: "جهات الاتصال",
    userContactsDescription: "جهات اتصال يمكن للمستخدم إرسال رسائل إليهم للبقاء على اتصال وطلب المساعدة عند الحاجة.",
    addContact: "إضافة جهة اتصال",
    savedContacts: "جهات الاتصال المحفوظة",
    caregiverQRTitle: "توصيل جهاز مقدم الرعاية",
    caregiverQRDesc: "امسح لتوصيل جهاز هاتف",
    caregiverQRInstructions: "مسح الرمز يتيح استلام رسائل من المستخدم كإشعارات Push على هاتفك الشخصي، حتى عندما يكون المتصفح مغلقًا. يمكنك إعداد رسائل عادية و/أو تنبيهات طلب المساعدة.",
    linkCopied: "تم نسخ الرابط!",
    copyFailed: "فشل النسخ",
    copyLink: "نسخ الرابط",
    connectedCaregivers: "جهات الاتصال المحفوظة",
    noCaregiversConnected: "لا توجد جهات اتصال متصلة بعد",
    caregiverRemoved: "تمت إزالة الجهاز بنجاح",
    removeError: "خطأ في إزالة الجهاز",
    unknownDevice: "جهاز غير معروف",
    confirmDeleteCaregiver: "حذف جهة اتصال",
    confirmDeleteCaregiverDesc: "لن يتلقى جهة الاتصال هذه إشعارات بعد الآن. يمكنك دائمًا إعادة توصيله عبر الإعدادات.",
    recentlyConnected: "متصل حديثًا",
    loginRequired: "يرجى تسجيل الدخول لعرض رمز QR",
    howPushAlertsWork: "كيف تعمل التنبيهات؟",
    pushAlertInfo1: "جهات الاتصال تمسح الرمز أو تفتح الرابط على هواتفهم.",
    pushAlertInfo2: "يوافقون على تلقي الإشعارات في متصفحهم.",
    pushAlertInfo3: "يختارون نوع الإشعارات: الكل (بما في ذلك تنبيهات المساعدة) أو رسائل عادية فقط للتواصل.",
    pushAlertInfo4: "يتلقون رسائل من المستخدم كإشعارات إلى هاتفهم الشخصي.",
    pushAlertInfo5: "إذا تم تفعيل تنبيهات المساعدة- يتلقون تنبيهًا فوريًا عند ضغط المستخدم على زر المساعدة.",
    sendTestNotification: "إرسال إشعار تجريبي",
    testNotificationSent: "تم إرسال الإشعار التجريبي بنجاح!",
    testNotificationFailed: "فشل إرسال الإشعار التجريبي",
    noCaregiversToNotify: "لا يوجد مقدمو رعاية متصلون للإشعار",
    qrExpiresAt: "صالح حتى:",
    qrExpired: "انتهت صلاحية الرمز",
    refresh: "تحديث",
    qrAutoRefreshing: "تحديث رمز QR تلقائيًا...",
    messagesOnly: "الرسائل فقط",
    allAlerts: "الكل",
    notificationTypeAll: "الكل (بما في ذلك تنبيهات المساعدة)",
    notificationTypeMessagesOnly: "الرسائل العادية فقط",
    qrAutoRefreshed: "تم تحديث رمز QR بنجاح",
    refreshQR: "تحديث الرمز",
    enterCodeAt: "في الموقع",
    generateNewQR: "إنشاء QR جديد",
    orEnterCode: "أو أدخل الرمز:",
    iphoneCodeInstruction: "لمستخدمي iPhone: أدخل الرمز التالي بعد التثبيت",
    allCaregiversRemoved: "تمت إزالة جميع الأجهزة بنجاح",
    clearAllCaregivers: "إزالة جميع جهات الاتصال",
    pushNotConfigured: "لم يتم تكوين إشعارات Push بعد",
    clearError: "خطأ في مسح الأجهزة",
    
    // Settings - Help Alert
    helpAlertSound: "صوت المساعدة",
    helpAlertSoundDesc: "اختر ما يُشغَّل عند الضغط على المساعدة",
    voiceAlert: "صوت",
    sirenAlert: "صفارة إنذار",
    beepAlert: "صفير",
    trainAlert: "قطار",
    
    // Settings - Security
    security: "الأمان",
    twoFactorSetup: "التحقق بخطوتين (2FA)",
    twoFactorSetupDesc: "أضف طبقة أمان إضافية لحسابك",
    setup2FA: "إعداد 2FA",
    auditLog: "سجل الأمان",
    auditLogDesc: "إجراءات الأمان الأخيرة في حسابك",
    noAuditLogs: "لا توجد إجراءات أمان لعرضها",
    auditTokenRegister: "تسجيل جهاز مقدم الرعاية",
    auditEmailAlert: "تنبيه بريد إلكتروني",
    auditPushAlert: "إشعار فوري",
    auditLinkGenerate: "إنشاء رابط QR",
    
    // Sidebar
    main: "الرئيسية",
    disableTracking: "إيقاف التتبع",
    logout: "تسجيل الخروج",
    
    // Smart Home page
    buttons: "أزرار",
    hueTab: "Hue",
    haTab: "HA",
    settingsTab: "الإعدادات",
    addButtonLabel: "إضافة زر",
    noLightsFound: "لم يتم العثور على مصابيح",
    checkHueConnection: "تحقق من اتصال Hue",
    hueError: "خطأ في تحميل مصابيح Hue",
    lightTurnedOn: "تم تشغيل المصباح",
    lightTurnedOff: "تم إيقاف المصباح",
    lightControlError: "خطأ في التحكم بالمصباح",
    brightnessError: "خطأ في ضبط السطوع",
    haError: "خطأ في تحميل Home Assistant",
    noHAEntities: "لم يتم العثور على أجهزة",
    checkHAConnection: "تحقق من اتصال Home Assistant",
    actionCompleted: "تم تنفيذ الإجراء",
    deviceControlError: "خطأ في التحكم بالجهاز",
    buttonTriggered: "تم التشغيل!",
    buttonTriggerError: "خطأ في تشغيل الزر",
    buttonUpdated: "تم تحديث الزر",
    buttonAdded: "تم إضافة الزر",
    buttonDeleted: "تم حذف الزر",
    fillNameAndUrl: "يرجى ملء الاسم وعنوان webhook",
    editButton: "تعديل الزر",
    newButton: "زر جديد",
    iconLabel: "أيقونة",
    colorLabel: "لون",
    methodLabel: "طريقة",
    saveChanges: "حفظ التغييرات",
    
    // Smart Home Settings
    smartHomeEnabled: "مفعّل - قم بالتهيئة في شاشة المنزل الذكي",
    smartHomeDisabled: "فعّل للتحكم في المنزل الذكي",
    philipsHueSettings: "إعدادات Philips Hue",
    bridgeIP: "عنوان IP للجسر",
    hueUsername: "اسم المستخدم",
    hueInstructions: "اضغط على زر الجسر ثم انقر 'اتصال'",
    connect: "اتصال",
    homeAssistantSettings: "إعدادات Home Assistant",
    serverUrl: "عنوان الخادم",
    accessToken: "رمز الوصول",
    
    // Button icons
    iconPower: "تشغيل",
    iconLamp: "مصباح",
    iconSun: "شمس",
    iconMoon: "قمر",
    iconHome: "منزل",
    iconPlay: "تشغيل",
    
    // Colors
    colorTeal: "أزرق مخضر",
    colorOrange: "برتقالي",
    colorBlue: "أزرق",
    colorGreen: "أخضر",
    colorPurple: "بنفسجي",
    colorPink: "وردي",
    colorYellow: "أصفر",
    colorRed: "أحمر",
    
    // Translator page
    realtimeTranslator: "مترجم في الوقت الفعلي",
    speaking: "يتحدث",
    translation: "ترجمة",
    pressToStart: "اضغط للبدء",
    listening: "يستمع...",
    pressMicToSpeak: "اضغط على الميكروفون وابدأ بالتحدث",
    speechRecognitionError: "خطأ في التعرف على الكلام",
    allowMicAccess: "يرجى السماح بالوصول إلى الميكروفون في المتصفح",
    browserNotSupported: "المتصفح لا يدعم التعرف على الكلام",
    translationError: "خطأ في الترجمة",
    
    // AI Chat page (additional)
    chatCleared: "تم مسح المحادثة",
    helloImHere: "مرحباً! أنا هنا للمساعدة",
    writeMessageBelow: "اكتب رسالة أدناه وسأرد عليك",
    readAloud: "اقرأ بصوت عالٍ",
    sendMessageError: "خطأ في إرسال الرسالة",
    
    // AAC Keyboard page
    aacKeyboardTitle: "لوحة مفاتيح AAC",
    aacTip: "نصيحة:",
    aacTipText: "في وضع الاختصارات، اكتب الحرف الأول من كل كلمة",
    aacExample: 'مثال: "hay" = "how are you"',
    
    // YouTube page (additional)
    popular: "شائع",
    searchYoutube: "بحث في يوتيوب",
    typeToSearch: "اكتب ما تريد البحث عنه...",
    popularVideos: "فيديوهات شائعة",
    homePage: "الصفحة الرئيسية",
    searchResults: "نتائج البحث",
    recommendedVideos: "فيديوهات موصى بها",
    watchHistory: "سجل المشاهدة",
    searchError: "خطأ في البحث",
    loginError: "خطأ في تسجيل الدخول",
    loginToSearch: "سجل الدخول للبحث",
    googleSignInRequired: "تسجيل الدخول بـ Google مطلوب",
    signInWithGoogleToSearch: "سجل الدخول بـ Google للبحث في فيديوهات YouTube",
    signInWithGoogle: "تسجيل الدخول بـ Google",
    closeVideo: "إغلاق",
    muteVideo: "كتم الصوت",
    unmuteVideo: "إلغاء كتم الصوت",
    skipForward: "10 ثوانٍ للأمام",
    skipBackward: "10 ثوانٍ للخلف",
    newSearch: "بحث جديد",
    pauseVideo: "إيقاف مؤقت",
    playVideo: "تشغيل",
    timesWatched: "مرات المشاهدة",
    loginToWatch: "اتصل بجوجل لمشاهدة يوتيوب",
    connectWithGoogle: "اتصل بجوجل",
    noHistory: "لا يوجد سجل مشاهدة",
    clearHistory: "مسح السجل",
    historySaved: "تم حفظ الفيديو في السجل",
    historyCleared: "تم مسح السجل",
    linkGoogleAccount: "ربط حساب Google",
    linkGoogleDescription: "هل تريد إضافة تسجيل الدخول بـ Google إلى حسابك؟ سيتيح لك ذلك تسجيل الدخول بالبريد الإلكتروني أو Google.",
    useGoogleOnlyForYouTube: "فقط ليوتيوب",
    linkToMyAccount: "ربط بحسابي",
    
    // Spotify page
    spotifyTitle: "سبوتيفاي",
    welcomeToSpotify: "مرحباً بك في سبوتيفاي",
    connectToSpotify: "اتصل بحسابك في سبوتيفاي للوصول إلى قوائم التشغيل والأغاني",
    loginToSpotify: "تسجيل الدخول إلى سبوتيفاي",
    spotifySetup: "إعداد سبوتيفاي",
    spotifySetupDesc: "للاتصال بسبوتيفاي، أنشئ تطبيقاً في",
    enterClientId: "أدخل Client ID",
    continueAndLogin: "متابعة وتسجيل الدخول",
    yourPlaylists: "قوائم التشغيل الخاصة بك",
    noPlaylistsFound: "لم يتم العثور على قوائم تشغيل",
    songsCount: "أغاني",
    disconnectSpotify: "قطع الاتصال",
    useArrowsHint: "استخدم الأسهم ↑↓ للتنقل و Enter للاختيار",
    previousTrack: "المسار السابق",
    nextTrack: "المسار التالي",
    play: "تشغيل",
    pause: "إيقاف مؤقت",
    connectingToPlayer: "جارٍ الاتصال بالمشغل...",
    premiumRequired: "يلزم حساب Premium للتشغيل الكامل",
    
    // TV page (additional)
    selectChannel: "اختر قناة للبدء",
    noChannelsFound: "لم يتم العثور على قنوات",
    channelLoadError: "خطأ في تحميل القنوات",
    channelPlayError: "لا يمكن تشغيل القناة",
    channelError: "خطأ في تشغيل القناة",
    formatNotSupported: "المتصفح لا يدعم هذا التنسيق",
    tryAgain: "حاول مرة أخرى",
    generalCategory: "عام",
    israel: "إسرائيل",
    usa: "الولايات المتحدة",
    russiaCountry: "روسيا",
    saudiArabia: "السعودية",
    restOfWorld: "بقية العالم",
    fullscreen: "ملء الشاشة",
    exitFullscreen: "الخروج من ملء الشاشة",
    
    // Radio page (additional)
    genresLabel: "الأنواع",
    countriesLabel: "الدول",
    noStationsFound: "لم يتم العثور على محطات",
    playingNow: "يتم التشغيل الآن",
    pausedStatus: "متوقف مؤقتاً",
    uk: "المملكة المتحدة",
    franceCountry: "فرنسا",
    germanyCountry: "ألمانيا",
    spainCountry: "إسبانيا",
    italyCountry: "إيطاليا",
    brazilCountry: "البرازيل",
    japanCountry: "اليابان",
    indiaCountry: "الهند",
    greeceCountry: "اليونان",
    turkeyCountry: "تركيا",
    polandCountry: "بولندا",
    popGenre: "بوب",
    rockGenre: "روك",
    jazzGenre: "جاز",
    classicalGenre: "كلاسيكي",
    electronicGenre: "إلكتروني",
    hiphopGenre: "هيب هوب",
    countryGenre: "كانتري",
    bluesGenre: "بلوز",
    reggaeGenre: "ريغي",
    ambientGenre: "أمبينت",
    oldiesGenre: "كلاسيكيات",
    the80sGenre: "الثمانينات",
    the90sGenre: "التسعينات",
    danceGenre: "راقص",
    soulGenre: "سول",
    latinGenre: "لاتيني",
    loungeGenre: "لاونج",
    metalGenre: "ميتال",
    alternativeGenre: "بديل",
    chilloutGenre: "تشيل أوت",
    
    // Device check
    deviceNotSupported: "هذا التطبيق مصمم للأجهزة اللوحية وأجهزة الكمبيوتر في الوضع الأفقي",
    deviceNotSupportedDesc: "للحصول على أفضل تجربة، استخدموا جهازًا بشاشة أكبر أو قوموا بتدوير الشاشة إلى الوضع الأفقي (لاندسكيب)",
    minScreenSize: "الحد الأدنى لحجم الشاشة: 10 بوصات",
    
    // Voice control overlay
    listeningStatus: "أستمع...",
    notListeningStatus: 'لا أستمع - قل "EyeControl" للتفعيل',
    
    // Onboarding
    whichLanguage: "أي لغة تريد استخدامها؟",
    canChangeInSettings: "يمكنك تغيير هذا في الإعدادات في أي وقت",
    greatReadyFemale: "رائع",
    greatReadyMale: "رائع",
    greatReady: "رائع",
    niceToMeet: "تشرفنا!",
    labelName: "الاسم:",
    labelAddress: "المخاطبة:",
    labelLanguage: "اللغة:",
    labelControlMethod: "طريقة التحكم:",
    
    // Scanning action labels
    actionSelect: "اختيار",
    actionCancel: "إلغاء",
    actionNext: "التالي",
    actionPrev: "السابق",
    actionBack: "رجوع",
    actionUp: "أعلى",
    actionDown: "أسفل",
    actionLeft: "يسار",
    actionRight: "يمين",
    
    // Pricing page
    pricingTitle: "اختر خطتك",
    pricingSubtitle: "7 أيام تجربة مجانية لأي خطة",
    monthly: "شهري",
    yearly: "سنوي",
    yearlyDiscount: "(خصم 20%)",
    personal: "شخصي",
    group: "جماعي",
    forTeams: "للفرق",
    perMonth: "شهرياً",
    perUserPerMonth: "لكل مستخدم شهرياً",
    minUsers: "5 مستخدمين كحد أدنى",
    users: "المستخدمون",
    regularPrice: "السعر العادي:",
    salePrice: "سعر العرض:",
    startFreeTrial: "ابدأ التجربة المجانية",
    whatsIncluded: "ما المتضمن:",
    startWith7Days: "ابدأ مع 7 أيام مجانية",
    blackFridaySale: "عرض الجمعة السوداء",
    limitedTimeOffer: "عرض خاص لفترة محدودة",
    featureEyeTracking: "تتبع العين المتقدم",
    featureCommBoard: "لوحة تواصل كاملة",
    featureSmartTyping: "كتابة سريعة ذكية",
    featureCaregiverMsg: "إرسال رسائل للمقدم الرعاية",
    featureTvYoutube: "وصول للتلفزيون ويوتيوب",
    featureGames: "ألعاب سهلة الوصول",
    featureSupport: "دعم فني كامل",
    featureUpdates: "تحديثات تلقائية",
    
    // Contacts page additional
    noEmailAddress: "لا يوجد بريد إلكتروني",
    setEmailFirst: "حدد بريد مقدم الرعاية أولاً",
    messageFromAyuni: "رسالة من EyeControl App",
    noPhoneNumber: "لا يوجد رقم هاتف",
    setPhoneFirst: "حدد هاتف مقدم الرعاية أولاً",
    errorTitle: "خطأ",
    pleaseLoginFirst: "يرجى تسجيل الدخول أولاً",
    notificationSent: "تم إرسال الإشعار",
    sentToDevices: "تم الإرسال إلى {0} أجهزة",
    scanQRInSettings: "امسح رمز QR في الإعدادات",
    failedToSendNotification: "فشل إرسال الإشعار",
    pushAlert: "تنبيه Push",
    emailSent: "تم إرسال البريد الإلكتروني",
    messageSentTo: "تم إرسال الرسالة إلى {email}",
    failedToSendEmail: "فشل إرسال البريد الإلكتروني",
    
    // Board Builder (unique additions)
    newBoard: "لوحة جديدة",
    boardUpdated: "تم تحديث اللوحة بنجاح!",
    boardSaved: "تم حفظ اللوحة بنجاح!",
    confirmBtn: "تأكيد",
    gridSize: "حجم الشبكة",
    cellsCount: "خلايا",
    utterancesCount: "عبارات",
    saveBtn: "حفظ",
    finishBtn: "إنهاء",
    
    // Help Alert
    iNeedHelpMale: "أحتاج مساعدة!",
    iNeedHelpFemale: "أحتاج مساعدة!",
    closeBtn: "إغلاق",
    whatHappened: "ماذا حدث؟",
    toCloseText: "للإغلاق",
    
    // Emergency Board
    emergencyPainMale: "أشعر بالألم",
    emergencyPainFemale: "أشعر بالألم",
    emergencyCallCaregiver: "اتصل بمقدم الرعاية",
    emergencyBreathing: "صعوبة في التنفس",
    emergencyNotWellMale: "لا أشعر بخير",
    emergencyNotWellFemale: "لا أشعر بخير",
    emergencyBathroom: "الحمام",
    emergencyThirsty: "أريد أن أشرب",
    emergencySuction: "بحاجة شفط",
    emergencyPosition: "تغيير الوضعية",
    addCard: "إضافة بطاقة",
    resetToDefault: "إعادة للافتراضي",
    undo: "تراجع",
    doneEditing: "انتهاء التعديل",
    editBtn: "تعديل",
    editItem: "تعديل العنصر",
    addNewItem: "إضافة عنصر جديد",
    textMale: "النص (ذكر)",
    textFemale: "النص (أنثى)",
    emojiLabel: "إيموجي",
    cancelBtn: "إلغاء",
    theUser: "المستخدم",
    userSelected: "اختار:",
    
    // Legal page
    legalInfo: "معلومات قانونية",
    privacyPolicy: "سياسة الخصوصية",
    cookiesPolicy: "سياسة ملفات تعريف الارتباط",
    termsAndConditions: "الشروط والأحكام",
    refundPolicyTitle: "سياسة الاسترداد",
    openSource: "مفتوح المصدر",
    openSourceAttribution: "إسناد المصدر المفتوح",
    cookiesInUse: "ملفات تعريف الارتباط المستخدمة",
    essentialCookies: "أساسية",
    essentialDesc: "ملفات تعريف الارتباط المطلوبة لعمل التطبيق بشكل صحيح",
    functionalCookies: "وظيفية",
    functionalDesc: "ملفات تعريف الارتباط التي تعزز الوظائف والتخصيص",
    analyticsCookies: "تحليلية",
    analyticsDesc: "ملفات تعريف الارتباط المستخدمة لفهم كيفية استخدام الزوار للتطبيق",
    notCurrentlyUsed: "غير مستخدم حالياً",
    userSettingsCookie: "تخزين تفضيلات وإعدادات المستخدم",
    cookieConsentCookie: "تذكر خيارات الموافقة على ملفات تعريف الارتباط",
    aacDictionaryCookie: "تخزين الكلمات والعبارات المكتسبة",
    communicationBoardsCookie: "تخزين لوحات التواصل المخصصة",
    smartHomeSettingsCookie: "تخزين إعدادات المنزل الذكي",
    ayuniUsesLibraries: "يستخدم EyeControl App مكتبات المصدر المفتوح التالية:",
    
    // Caregiver Connect Page
    caregiverConnectTitle: "ربط جهة اتصال",
    caregiverConnectPatientLabel: "الاتصال بحساب:",
    caregiverConnectDescription: "تفعيل إشعارات الدفع على هذا الجهاز لتلقي رسائل من {patientName}",
    caregiverConnectNotificationTypeTitle: "اختر نوع الإشعارات",
    caregiverConnectAllAlerts: "الكل (بما في ذلك طلبات المساعدة)",
    caregiverConnectMessagesOnly: "الرسائل العادية فقط (للبقاء على اتصال)",
    caregiverConnectEnterCodeInstruction: "أدخل الرمز الظاهر على شاشة المستخدم",
    caregiverConnectEnableButton: "تفعيل الإشعارات",
    caregiverConnectDeviceNote: "ستصلك الإشعارات على هذا الجهاز",
    caregiverConnectContactNameLabel: "اسم جهة الاتصال",
    caregiverConnectContactNamePlaceholder: "مثال: أمي، داود المعالج",
    caregiverConnectContactNameHint: "أدخل اسمك حتى يتمكن المستخدم من التعرف عليك",
    caregiverConnectSuccess: "تم الاتصال!",
    caregiverConnectSuccessDesc: "ستتلقى إشعارات عندما يرسل {patientName} رسائل.",
    caregiverConnectSuccessNote: "يمكنك إغلاق هذه الصفحة. ستصل الإشعارات حتى عند إغلاق المتصفح.",
    caregiverConnectError: "فشل الاتصال",
    caregiverConnectTryAgain: "حاول مرة أخرى",
    caregiverConnectUnsupported: "غير مدعوم",
    caregiverConnectUnsupportedDesc: "إشعارات الدفع غير مدعومة في هذا المتصفح. يرجى استخدام Chrome أو Firefox أو Edge.",
    caregiverConnectInvalidLink: "رابط غير صالح",
    caregiverConnectInvalidLinkDesc: "هذا الرابط ينقصه معلومات مطلوبة. يرجى مسح رمز QR صالح.",
    caregiverConnectRequestingPermission: "جارٍ إعداد الإشعارات...",
    caregiverConnectPermissionDenied: "تم رفض الإذن أو فشل في الحصول على رمز الإشعارات. تأكد من تفعيل الإشعارات في إعدادات المتصفح.",
    caregiverConnectContactNameRequired: "يرجى إدخال اسمك",
    caregiverConnectMissingPatientId: "رابط غير صالح - معرف المستخدم مفقود",
    
    // iOS PWA Install
    iosInstallRequired: "الخطوة الأولى: تثبيت التطبيق",
    iosInstallExplanation: "على iPhone، أضف التطبيق أولاً إلى الشاشة الرئيسية، ثم افتحه من هناك.",
    iosInstallSteps: "كيف تفعل ذلك:",
    iosStep1Tap: "اضغط على",
    iosStep1Share: "(مشاركة) في الأسفل",
    iosStep2Tap: "اختر",
    iosStep2AddToHome: "إضافة إلى الشاشة الرئيسية",
    iosStep3Open: "افتحوا التطبيق من الأيقونة الجديدة",
    iosStep4EnterCode: "أدخلوا الرمز الظاهر على شاشة المستخدم",
    iosInstallNote: "هذا مطلوب مرة واحدة فقط. بعد التثبيت، ستعمل الإشعارات تلقائياً.",
    enterCodePlaceholder: "أدخلوا الرمز",
    aboutApp: "حول تطبيق EyeControl",
  },


  ru: {
    // Navigation & Layout
    home: "Главная",
    back: "Назад",
    settings: "Настройки",
    help: "Помощь",
    rest: "Отдых",
    clock: "Часы",
    volume: "Громкость",
    control: "Управление",
    
    // Home page
    goodMorning: "Доброе утро",
    goodAfternoon: "Добрый день",
    goodEvening: "Добрый вечер",
    goodNight: "Доброй ночи",
    whatToDo: "Что бы вы хотели сделать сегодня?",
    whatToDoMale: "Что бы ты хотел сделать сегодня?",
    whatToDoFemale: "Что бы ты хотела сделать сегодня?",
    quickSpeak: "Быстрая речь:",
    
    // Quick phrases
    hello: "Привет",
    thanks: "Спасибо",
    yes: "Да",
    no: "Нет",
    please: "Пожалуйста",
    water: "Вода",
    food: "Еда",
    
    // Main actions
    communicationBoard: "Говорить",
    contacts: "Контакты",
    games: "Игры",
    youtube: "YouTube",
    spotify: "Spotify",
    keyboard: "Клавиатура",
    keyboardShort: "Клавиатура",
    translator: "Переводчик",
    history: "История",
    music: "Музыка",
    tv: "Телевидение",
    radio: "Радио",
    calendar: "Календарь",
    news: "Новости",
    guide: "Руководство",
    smartHome: "Умный дом",
    more: "Ещё",
    aiChat: "AI Чат",
    aacKeyboard: "AAC Клавиатура",
    entertainment: "Медиа",
    
    // Settings page
    settingsTitle: "Настройки",
    appearance: "Внешний вид",
    darkMode: "Тёмный режим",
    lightMode: "Светлый режим",
    darkModeDesc: "Переключение между тёмным и светлым отображением",
    fontSize: "Размер шрифта",
    small: "Маленький",
    medium: "Средний",
    large: "Большой",
    
    soundAndVoice: "Звук и голос",
    muteAll: "Отключить звуки",
    muteAllDesc: "Выключить все звуки",
    voiceSelection: "Выбор голоса",
    voiceSelectionDesc: "Выберите мужской или женский голос",
    female: "Женский",
    male: "Мужской",
    speechSpeed: "Скорость речи",
    speechLanguage: "Язык речи",
    speechLanguageDesc: "Язык голосового вывода (по умолчанию: язык пользователя)",
    
    accessibility: "Доступность",
    keyboardNav: "Навигация с клавиатуры",
    keyboardNavDesc: "Включить навигацию клавишами стрелок",
    // Head tracking settings
    headTrackingRange: "Диапазон движения головы",
    headTrackingRangeDesc: "Сколько нужно двигать головой чтобы достичь края экрана",
    rangeWide: "Много движения",
    rangeNarrow: "Мало движения",
    // Gaze tracking settings
    gazeTrackingSmoothing: "Сглаживание курсора",
    gazeTrackingSmoothingDesc: "Насколько плавно движется курсор - медленнее = плавнее",
    smoothingLow: "Точно (дёрганый)",
    smoothingHigh: "Плавно (медленнее)",
    
    profile: "Профиль",
    profileMale: "Профиль пользователя",
    profileFemale: "Профиль пользователя",
    name: "Имя",
    enterName: "Введите имя",
    addressing: "Обращение",
    neutral: "Нейтральное",
    language: "Язык",
    hebrew: "עברית",
    english: "English",
    arabic: "العربية",
    russian: "Русский",
    
    // Contacts page
    contactsTitle: "Контакты",
    email: "Email",
    sms: "SMS",
    whatsapp: "WhatsApp",
    caregiverDetails: "Данные опекуна",
    phone: "Телефон",
    notSet: "Не задано",
    caregiverSettings: "Настройки опекуна",
    caregiverEmail: "Email опекуна",
    pushNotificationsDescription: "Для настройки Push-уведомлений для опекунов перейдите в Настройки",
    goToSettings: "Перейти в настройки",
    save: "Сохранить",
    savedSuccessfully: "Успешно сохранено",
    caregiverUpdated: "Данные опекуна обновлены",
    to: "Кому",
    toOptional: "Кому (необязательно - по умолчанию: опекун)",
    message: "Сообщение",
    writeMessage: "Напишите сообщение...",
    noPhone: "Нет номера телефона",
    enterPhoneOrSet: "Введите номер телефона или укажите телефон опекуна",
    noEmail: "Нет адреса email",
    enterEmailOrSet: "Введите email или укажите email опекуна",
    
    // Help alert
    needHelpMale: "Мне нужна помощь!",
    needHelpFemale: "Мне нужна помощь!",
    close: "Закрыть",
    pressEnterToClose: "Нажмите Enter для закрытия",
    pressMale: "Нажми",
    pressFemale: "Нажми",
    toClose: "для закрытия",
    emoji: "Эмодзи",
    cells: "ячеек",
    icon: "Иконка",
    orChooseEmoji: "Или выберите эмодзи",
    preview: "Предпросмотр",
    textMalePlaceholder: "напр. Мне больно",
    textFemalePlaceholder: "напр. Мне больно",
    openSourceDescription: "EyeControl App использует следующие библиотеки с открытым исходным кодом:",
    cookiesInUseSubtitle: "Используемые Cookie",
    notInUse: "В настоящее время не используется",

    
    // Rest mode
    restMode: "Режим отдыха",
    pressToWake: "экран или Enter для пробуждения",
    restModeDwellInstruction: "Удерживайте взгляд на круге в течение 3 секунд",
    restModeDwellInstructionMale: "Удерживайте взгляд на круге в течение 3 секунд",
    restModeDwellInstructionFemale: "Удерживайте взгляд на круге в течение 3 секунд",
    restModeSelectInstruction: "Выполните выбранное действие 3 раза, чтобы выйти",
    restModeSelectInstructionMale: "Выполните выбранное действие 3 раза, чтобы выйти",
    restModeSelectInstructionFemale: "Выполните выбранное действие 3 раза, чтобы выйти",
    restModeVoiceInstruction: "Произнесите число три раза",
    restModeVoiceInstructionMale: "Произнесите число три раза",
    restModeVoiceInstructionFemale: "Произнесите число три раза",
    pressEscapeToWake: "Можно нажать Escape для быстрого выхода",
    mediaRestBlinkInstruction: "Моргните 3 раза для выхода",
    mediaRestBlinkInstructionMale: "Моргните 3 раза для выхода",
    mediaRestBlinkInstructionFemale: "Моргните 3 раза для выхода",
    
    // Time info
    sunday: "Воскресенье",
    monday: "Понедельник",
    tuesday: "Вторник",
    wednesday: "Среда",
    thursday: "Четверг",
    friday: "Пятница",
    saturday: "Суббота",
    day: "",
    january: "Январь",
    february: "Февраль",
    march: "Март",
    april: "Апрель",
    may: "Май",
    june: "Июнь",
    july: "Июль",
    august: "Август",
    september: "Сентябрь",
    october: "Октябрь",
    november: "Ноябрь",
    december: "Декабрь",
    loadingLocation: "Загрузка местоположения...",
    locationUnavailable: "Местоположение недоступно",
    unknownLocation: "Неизвестное местоположение",
    locationError: "Ошибка загрузки местоположения",
    noLocationPermission: "Нет разрешения на местоположение",
    loadingWeather: "Загрузка погоды...",
    weatherUnavailable: "Погода недоступна",
    
    // Volume
    volumeTitle: "Громкость",
    veryLow: "Очень низкая",
    low: "Низкая",
    mediumVol: "Средняя",
    high: "Высокая",
    veryHigh: "Очень высокая",
    navInstructions: "↑↓ Навигация • Enter для выбора",
    
    // Control Methods
    controlMethodsTitle: "Как вы хотите управлять приложением?",
    controlMethodsSubtitle: "Выберите подходящий метод управления",
    control_standard_pointer_title: "Касание / Мышь",
    control_standard_pointer_desc: "Стандартное управление касанием или мышью",
    control_voice_title: "Голосовое управление",
    control_voice_desc: "Управление голосовыми командами",
    control_eye_control_title: "Устройство EyeControl",
    control_eye_control_desc: "Управление с устройством EyeControl",
    control_external_switch_title: "Внешние переключатели",
    control_external_switch_desc: "Управление переключателями",
    control_gaze_tracking_title: "Отслеживание взгляда",
    control_gaze_tracking_desc: "Управление движениями глаз",
    control_head_tracking_title: "Отслеживание головы",
    control_head_tracking_desc: "Управление движениями головы",
    control_mouth_gestures_title: "Жесты рта",
    control_mouth_gestures_desc: "Управление движениями рта",
    controlSetup: "Настройка управления",
    selectGesturesMale: "Выберите жесты, которые вы можете выполнять",
    selectGesturesFemale: "Выберите жесты, которые вы можете выполнять",
    lookUp: "Взгляд вверх",
    lookDown: "Взгляд вниз",
    lookLeft: "Взгляд влево",
    lookRight: "Взгляд вправо",
    blink: "Моргание",
    continueButton: "Продолжить",
    previousButton: "Назад",
    nextButton: "Далее",
    
    // AAC & Communication
    aacTitle: "AAC Клавиатура",
    speak: "Говорить",
    clear: "Очистить",
    delete: "Удалить",
    space: "Пробел",
    enter: "Ввод",
    wordCompletion: "Завершение слов",
    acronymMode: "Режим аббревиатур",
    suggestions: "Предложения",
    recentWords: "Недавние слова",
    addToDictionary: "Добавить в словарь",
    
    // Communication Board
    boardTitle: "Доска общения",
    editBoard: "Редактировать доску",
    editBoards: "Редактирование досок",
    userContacts: "Контакты",
    userContactsTitle: "Контакты пользователя",
    editHelpBoard: "Редактировать доску помощи",
    editCommunicationBoard: "Редактировать доску общения",
    editTopActionBar: "Редактировать панель действий",
    addCategory: "Добавить категорию",
    spatialNavigation: "Пространственная навигация",
    createBoard: "Создать новую доску",
    boardName: "Название доски",
    selectIcon: "Выбрать иконку",
    selectColor: "Выбрать цвет",
    category: "Категория",
    utterance: "Высказывание",
    rows: "Строки",
    columns: "Столбцы",
    deleteBoard: "Удалить доску",
    saveBoard: "Сохранить доску",
    
    // Actions menu
    speakAction: "Произнести",
    sendToContacts: "Отправить контактам",
    sendToAI: "Отправить в AI чат",
    translateAction: "Перевести",
    addToDict: "Добавить в словарь",
    
    // Translation
    translateTitle: "Перевод",
    selectLanguage: "Выбрать язык",
    translatedText: "Переведённый текст",
    speakTranslation: "Произнести перевод",
    
    // AI Chat
    aiChatTitle: "Чат с AI",
    typeMessage: "Введите сообщение...",
    sendMessage: "Отправить",
    clearChat: "Очистить чат",
    aiThinking: "AI думает...",
    
    // YouTube
    youtubeTitle: "YouTube",
    searchVideos: "Поиск видео",
    search: "Поиск",
    searchTab: "Поиск",
    noResults: "Результаты не найдены",
    views: "просмотров",
    
    // TV & Radio
    tvTitle: "Телевидение",
    radioTitle: "Радио",
    selectCountry: "Выбрать страну",
    selectGenre: "Выбрать жанр",
    channels: "Каналы",
    stations: "Станции",
    nowPlaying: "Сейчас играет",
    
    // Games
    gamesTitle: "Игры",
    accessibleGameHub: "Центр доступных игр",
    accessibleGameHubDesc: "Игры, адаптированные для всех методов управления",
    memoryGame: "Игра на память",
    memoryGameDesc: "Найдите совпадающие пары карт",
    game2048: "2048",
    game2048Desc: "Объединяйте плитки, чтобы достичь 2048",
    slidingPuzzle: "Пятнашки",
    slidingPuzzleDesc: "Решите головоломку за меньшее число ходов",
    simonSays: "Саймон говорит",
    simonSaysDesc: "Повторите последовательность цветов",
    dinoRunner: "Дино Раннер",
    dinoRunnerDesc: "Прыгайте через препятствия - один переключатель",
    pongGame: "Понг",
    pongGameDesc: "Настольный теннис - два переключателя",
    spaceDefender: "Защитник космоса",
    spaceDefenderDesc: "Защищайте свой корабль - 5 переключателей",
    balloonPopper: "Лопни шарики",
    balloonPopperDesc: "Отслеживание взгляда - без кликов",
    gridMemoryGame: "Числовая память",
    gridMemoryDesc: "Голосовое управление - назовите число",
    moves: "Ходы",
    newGame: "Новая игра",
    wonInMoves: "Вы выиграли за {0} ходов!",
    gameSoonAvailable: "Игра скоро появится",
    cellScanning: "Сканирование ячеек",
    rowScanning: "Сканирование строк",
    ticTacToe: "Крестики-нолики",
    puzzle: "Пазл",
    startGame: "Начать игру",
    yourTurn: "Ваш ход",
    aiTurn: "Ход AI",
    youWin: "Вы победили!",
    youWon: "Вы победили!",
    aiWins: "AI победил",
    draw: "Ничья",
    playAgain: "Играть снова",
    gameOver: "Игра окончена",
    score: "Счёт",
    highScore: "Рекорд",
    up: "Вверх",
    down: "Вниз",
    left: "Влево",
    right: "Вправо",
    slidingPuzzleHint: "Нажмите на соседние плитки, чтобы переместить их",
    simonSaysHint: "Повторите последовательность, нажимая на цвета",
    watchTheSequence: "Смотрите последовательность...",
    missed: "Пропущено",
    dinoTapToJump: "Нажмите любую клавишу или коснитесь экрана для прыжка",
    dinoTapAnywhere: "Коснитесь в любом месте для прыжка",
    pongInstructions: "Используйте стрелки вверх/вниз или кнопки для управления ракеткой",
    balloonPopperInstructions: "Задержите взгляд на шарике на секунду, чтобы лопнуть его",
    balloonPopperHint: "Наведите взгляд на шарик и задержитесь на секунду | Без кликов!",
    
    // Smart Home
    smartHomeTitle: "Умный дом",
    lights: "Освещение",
    lightsOn: "Включить",
    lightsOff: "Выключить",
    brightness: "Яркость",
    webhookButtons: "Кнопки Webhook",
    addButton: "Добавить кнопку",
    buttonName: "Название кнопки",
    webhookUrl: "URL Webhook",
    
    // Scanning
    scanningSettings: "Настройки сканирования",
    automaticScan: "Автоматическое сканирование",
    manualScan: "Ручное сканирование",
    scanSpeed: "Скорость сканирования",
    rowAndColumn: "Строка и столбец",
    cellByCell: "Ячейка за ячейкой",
    
    // New SRS scanning/cursor settings
    dwellTime: "Время удержания",
    dwellTimeDesc: "Сколько оставаться на элементе перед выбором",
    seconds: "секунд",
    firstItemDelay: "Задержка первого элемента",
    firstItemDelayDesc: "Дополнительная пауза при входе в новую группу",
    offSetting: "Выкл",
    normalSetting: "Обычный",
    longSetting: "Длинный",
    cursorSettings: "Настройки курсора",
    cursorMagnetism: "Магнетизм курсора",
    cursorMagnetismDesc: "Притяжение курсора к кнопкам",
    weakSetting: "Слабый",
    strongSetting: "Сильный",
    cursorSmoothingSetting: "Сглаживание курсора",
    cursorSmoothingDesc: "Уровень стабильности движения курсора",
    lowSetting: "Низкий",
    highSetting: "Высокий",
    
    scanMode: "Режим сканирования",
    cellByCellMode: "Ячейка за ячейкой",
    cellByCellDesc: "Сканирование проходит по каждой ячейке отдельно",
    rowAndColumnMode: "Строка и столбец",
    rowAndColumnDesc: "Сначала выбор строки, затем ячейки в строке",
    scanSpeedLabel: "Скорость сканирования",
    slow: "Медленно",
    fast: "Быстро",
    automaticScanning: "Автоматическое сканирование",
    gestureScanning: "Сканирование по жестам",
    selectScanTypeMale: "Выберите тип сканирования:",
    selectScanTypeFemale: "Выберите тип сканирования:",
    
    // Head/Gaze Tracking
    headTrackingTitle: "Отслеживание головы - Настройка",
    gazeTrackingTitle: "Отслеживание взгляда - Настройка",
    mouthGesturesTitle: "Жесты рта - Настройка",
    calibration: "Калибровка",
    startCalibration: "Начать калибровку",
    calibrationComplete: "Калибровка завершена",
    lookAtPoint: "Смотрите на точку",
    sensitivity: "Чувствительность",
    testTracking: "Проверить отслеживание",
    finishSetup: "Завершить настройку",
    
    // Mouth Gestures
    selectGestures: "Выберите до 3 жестов для управления",
    smile: "Улыбка",
    smileDesc: "Широко улыбнитесь",
    openMouth: "Открытый рот",
    openMouthDesc: "Широко откройте рот",
    kiss: "Поцелуй",
    kissDesc: "Сложите губы трубочкой",
    
    // Voice Control
    voiceControlTitle: "Голосовое управление - Настройка",
    wakeWord: "Слово активации",
    voiceCommands: "Голосовые команды",
    sayCommand: "Скажите команду",
    
    // External Switch
    externalSwitchTitle: "Внешние переключатели - Настройка",
    switchCount: "Количество переключателей",
    assignActions: "Назначить действия",
    pressSwitch: "Нажмите переключатель",
    pressSwitchFemale: "Нажмите переключатель",
    switchLabel: "переключатель",
    switchesLabel: "переключателей",
    switch1Desc: "Один переключатель - только выбор (автоматическое сканирование)",
    switch2Desc: "Два переключателя - выбор и возврат",
    switch3Desc: "Три переключателя - выбор, далее, возврат",
    switch4Desc: "Четыре переключателя - выбор, далее, назад и возврат",
    switch5Desc: "Пять переключателей - полная навигация по направлениям",
    selectSwitchCountMale: "Выберите количество переключателей:",
    selectSwitchCountFemale: "Выберите количество переключателей:",
    scanType: "Тип сканирования",
    automaticScanType: "Автоматическое",
    manualScanType: "Ручное",
    cursorMovesAutoSelect: "Курсор двигается автоматически, нажмите для выбора",
    cursorMovesOnPress: "Курсор двигается только при нажатии переключателя",
    recordSwitchInputMale: "Нажмите каждый переключатель, чтобы записать его ввод",
    recordSwitchInputFemale: "Нажмите каждый переключатель, чтобы записать его ввод",
    testSwitchInputMale: "Нажмите каждый переключатель, чтобы убедиться, что система его распознаёт",
    testSwitchInputFemale: "Нажмите каждый переключатель, чтобы убедиться, что система его распознаёт",
    recorded: "Записано",
    pressToRecordMale: "Нажмите переключатель...",
    pressToRecordFemale: "Нажмите переключатель...",
    allSwitchesConfigured: "Все переключатели настроены успешно!",
    selectAction: "Выбор",
    cancelAction: "Отмена",
    nextAction: "Далее",
    previousAction: "Назад",
    backAction: "Возврат",
    upAction: "Вверх",
    downAction: "Вниз",
    leftAction: "Влево",
    rightAction: "Вправо",
    
    // Action Mapping
    actionMappingTitle: "Назначение действий",
    clickGestureToChangeMale: "Нажмите на жест, чтобы изменить его:",
    clickGestureToChangeFemale: "Нажмите на жест, чтобы изменить его:",
    selectGesturePrompt: "Выберите жест",
    blinkGesture: "Моргание / Закрытие глаз",
    blinkGestureShort: "Моргание",
    lookUpGesture: "Взгляд вверх (вверх)",
    lookUpGestureShort: "Взгляд вверх",
    lookDownGesture: "Взгляд вниз (вниз)",
    lookDownGestureShort: "Взгляд вниз",
    lookLeftGesture: "Взгляд влево (влево)",
    lookLeftGestureShort: "Взгляд влево",
    lookRightGesture: "Взгляд вправо (вправо)",
    lookRightGestureShort: "Взгляд вправо",
    selectEnter: "Выбор (Enter)",
    fullDirectionalNav: "Полная пространственная навигация",
    fullDirectionalNavDesc: "Свободная навигация во всех направлениях",
    advancedNav: "Расширенная навигация",
    advancedNavDesc: "Выбор, далее, назад и возврат",
    manualScanNav: "Ручное сканирование",
    manualScanNavDesc: "Выбор, далее и возврат",
    autoScanWithCancel: "Сканирование с возвратом",
    autoScanWithCancelDesc: "Автоматическое сканирование с возможностью возврата",
    autoScanOnly: "Автоматическое сканирование",
    autoScanOnlyDesc: "Сканирование двигается автоматически, один жест для выбора",
    
    // Head/Gaze Tracking Setup
    faceAndEyeDetection: "Распознавание лица и глаз",
    faceAndEyeDetectionDesc: "Система распознаёт ваше лицо и глаза. Убедитесь, что ваше лицо находится в центре экрана.",
    searchingForFace: "Поиск лица...",
    tooClose: "Слишком близко - отодвиньтесь от камеры",
    tooFar: "Слишком далеко - подойдите ближе к камере",
    distanceGood: "Отличное расстояние!",
    initializingTracking: "Инициализация отслеживания...",
    eyePointsMarkedCyan: "Точки глаз отмечены голубым цветом",
    foundPreviousCalibration: "Найдена предыдущая калибровка - можете использовать её или откалибровать заново",
    usePreviousCalibration: "Использовать предыдущую калибровку",
    recalibrate: "Откалибровать заново",
    foundPreviousSetup: "Найдена предыдущая настройка - можете начать сразу или настроить заново",
    startImmediately: "Начать сразу",
    setupAgain: "Настроить заново",
    testGazeTracking: "Тест отслеживания взгляда",
    lookAtContinueButton: "Смотрите на кнопку \"Продолжить\", чтобы активировать её",
    excellentClickToContinue: "Отлично! Нажмите для продолжения",
    gazeTrackingActiveTitle: "Режим взгляда активен",
    gazeTrackingReadyDesc: "Система готова! Курсор будет следовать за вашим взглядом. Остановитесь на элементе, чтобы выбрать его.",
    testButton: "Кнопка",
    cameraErrorCannotAccess: "Не удаётся получить доступ к камере - убедитесь, что камера подключена и разрешение предоставлено",
    videoElementError: "Ошибка доступа к видео элементу",
    faceModelLoadError: "Ошибка загрузки модели распознавания лица",
    
    // Mouth Gesture Setup
    neutralCalibration: "Калибровка нейтрального состояния",
    neutralCalibrationDesc: "Расслабьте лицо в естественном положении",
    gestureCalibration: "Калибровка жеста",
    performGesture: "Выполните жест",
    gestureTestTitle: "Тест жестов",
    testGesturesDesc: "Выполните выбранные жесты, чтобы убедиться, что система их распознаёт",
    allGesturesTestedSuccess: "Все жесты успешно протестированы!",
    gesture1Desc: "Один жест - только выбор (автоматическое сканирование)",
    gesture2Desc: "Два жеста - выбор и возврат",
    gesture3Desc: "Три жеста - выбор, далее, и возврат",
    
    // Voice Control Setup
    voiceControlSetupTitle: "Голосовое управление",
    voiceControlTestTitle: "Тест голосового управления",
    voiceControlExplanation: "Рядом с каждой кнопкой на экране будет показан номер. Просто скажите номер, чтобы нажать кнопку.",
    voiceControlExplanationFemale: "Рядом с каждой кнопкой на экране будет показан номер. Просто скажите номер, чтобы нажать кнопку.",
    voiceControlExample: 'Например: скажите "1", чтобы нажать первую кнопку',
    voiceControlExampleFemale: 'Например: скажите "1", чтобы нажать первую кнопку',
    voiceControlWakeWord: 'Слово активации: "EyeControl"',
    voiceControlWakeWordDesc: 'Скажите "EyeControl", чтобы приостановить или возобновить прослушивание. При паузе номера исчезнут с экрана.',
    voiceControlWakeWordDescFemale: 'Скажите "EyeControl", чтобы приостановить или возобновить прослушивание. При паузе номера исчезнут с экрана.',
    voiceControlSubtitle: "Управляйте приложением голосом",
    nowYourTurn: "Теперь ваша очередь!",
    sayTheNumber: "Скажите номер рядом с зелёной кнопкой",
    sayTheNumberFemale: "Скажите номер рядом с зелёной кнопкой",
    youSaid: "Вы сказали:",
    listeningActive: "Слушаю...",
    clickToStart: "Нажмите для начала",
    startTest: "Начать тест",
    successes: "Успехи:",
    buttonLabel: "Кнопка",
    
    // Head Tracking Setup
    headTrackingSetupTitle: "Отслеживание головы",
    faceDetectionTitle: "Обнаружение лица",
    faceDetectionDesc: "Система обнаруживает ваше лицо. Убедитесь, что лицо находится в центре экрана.",
    trackingTestTitle: "Тест отслеживания",
    trackingTestDesc: 'Двигайте головой, чтобы достичь кнопки "Продолжить" курсором',
    cursorActiveTitle: "Режим курсора активен",
    cursorActiveDesc: "Система готова! Курсор будет следовать за движениями вашей головы. Остановитесь на элементе, чтобы выбрать его.",
    
    // Gaze Tracking Setup
    gazeTrackingSetupTitle: "Отслеживание взгляда",
    gazeTestDesc: 'Посмотрите на кнопку "Продолжить", чтобы активировать её',
    gazeActiveTitle: "Режим взгляда активен",
    gazeActiveDesc: "Система готова! Курсор будет следовать за вашим взглядом. Остановитесь на элементе, чтобы выбрать его.",
    
    // Mouth Gesture Setup (additional)
    mouthGestureSetupTitle: "Настройка жестов рта",
    selectUpTo3Gestures: "Выберите до 3 жестов для управления",
    selectUpTo3GesturesFemale: "Выберите до 3 жестов для управления",
    actionMapping: "Назначение действий",
    selectActionForGesture: "Выберите, что будет делать каждый жест",
    selectActionForGestureFemale: "Выберите, что будет делать каждый жест",
    scanSettingsTitle: "Настройки сканирования",
    scanModeLabel: "Режим сканирования:",
    manualScanning: "Ручное сканирование",
    gesture3ManualDesc: "3 жеста - вы двигаете курсор вперёд и назад",
    gesture2AutoDesc: "2 жеста - сканирование двигается автоматически, жест для выбора и жест для возврата",
    gesture1AutoDesc: "Один жест - сканирование двигается автоматически, жест только для выбора",
    scanCellsMode: "Ячейки",
    rowsAndColumns: "Строки и столбцы",
    scanSpeedSeconds: "Скорость сканирования: {0} сек",
    usePreviousCalibrationOption: "Найдена предыдущая калибровка - можно использовать её или откалибровать заново",
    usePreviousBtn: "Использовать предыдущую",
    recalibrateBtn: "Откалибровать заново",
    neutralCalibrationTitle: "Калибровка - Расслабленное лицо",
    keepFaceRelaxed: "Держите лицо расслабленным, рот закрыт. Нажмите кнопку для захвата.",
    keepFaceRelaxedFemale: "Держите лицо расслабленным, рот закрыт. Нажмите кнопку для захвата.",
    faceDetected: "Лицо обнаружено ✓",
    faceNotDetected: "Лицо не обнаружено",
    capturing: "Захват...",
    capture: "Захват",
    gestureCalibrationTitle: "Калибровка - {0}",
    performGestureDesc: "Выполните жест: {0}",
    performGestureDescFemale: "Выполните жест: {0}",
    gestureTestDesc: "Выполните каждый жест, чтобы убедиться, что система его распознаёт",
    gestureTestDescFemale: "Выполните каждый жест, чтобы убедиться, что система его распознаёт",
    neutralState: "Нейтральный",
    allGesturesDetected: "Все жесты успешно распознаны!",
    setupComplete: "Настройка завершена!",
    gesturesCalibrated: "Жесты рта успешно откалиброваны. Теперь вы можете использовать их для управления приложением.",
    gesturesCalibratedFemale: "Жесты рта успешно откалиброваны. Теперь вы можете использовать их для управления приложением.",
    configStage: "Настройки",
    calibrateStage: "Калибровка",
    calibrateGestureStage: "Калибровка жестов",
    testStage: "Тест",
    completeStage: "Завершено",
    
    // External Switch Setup
    switchSetupTitle: "Настройка переключателей",
    recordingSwitchesTitle: "Запись переключателей",
    testingSwitchesTitle: "Тестирование переключателей",
    stageXOfY: "Этап {0} из {1}",
    pressSwitchToRecord: "Нажмите каждый переключатель для записи его ввода",
    pressSwitchToRecordFemale: "Нажмите каждый переключатель для записи его ввода",
    recordedLabel: "Записано: {0}",
    pressSwitchPrompt: "Нажмите переключатель...",
    pressSwitchPromptFemale: "Нажмите переключатель...",
    pressSwitchToTest: "Нажмите каждый переключатель, чтобы убедиться, что система его распознаёт",
    pressSwitchToTestFemale: "Нажмите каждый переключатель, чтобы убедиться, что система его распознаёт",
    allSwitchesRecognized: "Отлично! Все переключатели успешно распознаны",
    
    // Additional switch setup keys
    performEachGestureToTest: "Выполните каждый жест, чтобы убедиться, что система его распознаёт",
    performEachGestureToTestFemale: "Выполните каждый жест, чтобы убедиться, что система его распознаёт",
    
    // General UI
    loading: "Загрузка...",
    error: "Ошибка",
    retry: "Повторить",
    cancel: "Отмена",
    confirm: "Подтвердить",
    edit: "Редактировать",
    add: "Добавить",
    remove: "Удалить",
    next: "Далее",
    previous: "Назад",
    finish: "Завершить",
    continue: "Продолжить",
    skip: "Пропустить",
    select: "Выбрать",
    selected: "Выбрано",
    
    // Camera/Tracking Errors
    cameraError: "Не удается получить доступ к камере - убедитесь, что камера подключена и разрешение предоставлено",
    videoError: "Ошибка доступа к видеоэлементу",
    faceModelError: "Ошибка загрузки модели распознавания лиц",
    searchingFace: "Поиск лица...",
    
    // Guide
    guideTitle: "Руководство пользователя",
    guideIntro: "Добро пожаловать в руководство пользователя EyeControl App",
    guideIntroDesc: "EyeControl App - это продвинутая система альтернативной и дополнительной коммуникации (AAC), предназначенная для людей с нарушениями общения и двигательными нарушениями. Это руководство поможет вам узнать обо всех функциях системы.",
    
    // Guide sections
    guideControlMethods: "Методы управления",
    guideControlMethodsDesc: "Система поддерживает устройство EyeControl, сенсорное управление и внешние переключатели:",
    guideControlEyeControl: "Устройство EyeControl - Устройство связи на основе взгляда для полного управления приложением",
    guideControlEyeControlGestures: "↳ Выбор жестов: можно выбрать 1–6 жестов глаз (например, моргание, взгляд вверх/вниз). 4+ жеста включают режим ручного управления — каждый жест выполняет конкретное действие",
    guideControlEyeControlScanning: "↳ Авто-сканирование: до 3 жестов активируют автоматическое сканирование — система перебирает элементы с регулируемой скоростью. Скорость сканирования настраивается в настройках",
    guideControlTouch: "Касание/Мышь - Стандартное управление касанием или кликом мыши",
    guideControlHead: "Отслеживание головы - Управляйте курсором движением головы. Камера отслеживает движения вашей головы",
    guideControlGaze: "Отслеживание взгляда - Управляйте курсором движениями глаз с калибровкой по 9 точкам",
    guideControlMouth: "Жесты рта - Управляйте сканированием улыбкой, открытием рта или поцелуем",
    guideControlSwitch: "Внешние переключатели - Подключите 1-5 физических переключателей для управления сканированием",
    guideControlVoice: "Голосовое управление - Давайте голосовые команды для навигации и выбора",
    
    guideCommunication: "Общение",
    guideCommunicationDesc: "Продвинутые инструменты общения:",
    guideCommBoard: "Доска общения - Настраиваемые доски с категориями и высказываниями. Нажмите на элемент, чтобы произнести его",
    guideCommAAC: "AAC Клавиатура - Набор с умным завершением слов, режимом аббревиатур и озвучиванием",
    guideCommAI: "AI Чат - Общайтесь с умным AI-помощником, который может помочь составить сообщения",
    guideCommContacts: "Контакты - Отправляйте SMS, WhatsApp или email сообщения опекуну или другим контактам",
    guideCommTranslator: "Переводчик - Переводите текст на разные языки с возможностью озвучивания",

    guideContacts: "Контакты",
    guideContactsDesc: "Вы можете сохранять контакты пользователя через Меню > Контакты.",
    guideContactsItem0: "Можно сохранять контакты пользователя для отправки сообщений из системы",
    guideContactsItem1: "Контакты могут отсканировать QR-код или открыть ссылку на телефоне, чтобы подтвердить получение сообщений от пользователя в виде push-уведомлений",
    guideContactsItem2: "Можно выбрать тип уведомлений: Все (включая вызов помощи) — или только обычные сообщения для поддержания связи",
    guideContactsItem3: "Контакты будут получать уведомления в соответствии с сообщениями, которые отправляет пользователь",
    guideContactsItem4: "Если включён приём вызова помощи — немедленное уведомление отправляется, когда пользователь нажимает кнопку помощи",

    guideMedia: "Медиа и развлечения",
    guideMediaDesc: "YouTube, радио и музыка прямо из приложения:",
    guideMediaYT: "YouTube - Ищите и смотрите видео прямо в приложении",
    guideMediaTV: "Телевидение - Смотрите IPTV каналы из Израиля и со всего мира",
    guideMediaRadio: "Радио - Слушайте радиостанции по стране или жанру",
    guideMediaGames: "Игры - Игры на память, крестики-нолики и пазлы",
    
    guideSmartHome: "Умный дом",
    guideSmartHomeDesc: "Управляйте умными устройствами в вашем доме:",
    guideSmartLights: "Освещение - Управление лампами Philips Hue",
    guideSmartHA: "Home Assistant - Подключение к системе Home Assistant",
    guideSmartWebhook: "Webhooks - Настраиваемые кнопки для действий Make/Zapier/IFTTT",
    
    guideSettings: "Настройки",
    guideSettingsDesc: "Настройте систему под свои нужды:",
    guideSettingsAppearance: "Внешний вид - Тёмный/светлый режим, размер шрифта",
    guideSettingsVoice: "Голос - Выберите мужской/женский голос, скорость речи, отключение звука",
    guideSettingsProfile: "Профиль - Имя, язык, стиль обращения",
    guideSettingsControl: "Управление - Установите предпочтительный метод управления",
    guideSettingsBoards: "Редактор досок – персонализация контента и экранов для пользователя. Главный экран и развлечения- выбор содержания и пространственного расположения. Вызов помощи- редактирование сообщений после вызова помощи. Доска общения- редактирование сообщений, визуальных элементов и расположения. Клавиатура- редактирование вспомогательных действий.",
    
    guideAccessibility: "Доступность",
    guideAccessibilityDesc: "Продвинутые функции доступности:",
    guideAccessScanning: "Сканирование - Автоматическое или ручное сканирование элементов на экране",
    guideAccessDwell: "Клик по задержке - Автоматический клик после наведения на элемент",
    guideAccessHelp: "Кнопка помощи - Голосовое оповещение или звук для вызова помощи",
    guideAccessRest: "Режим отдыха - Тёмный экран для перерыва от системы",
    
    guideTips: "Советы",
    guideTipsDesc: "Советы для эффективного использования:",
    guideTip1: "Начните с самого простого для вас метода управления и постепенно продвигайтесь",
    guideTip2: "Настройте скорость сканирования и чувствительность отслеживания для максимального комфорта",
    guideTip3: "Добавьте часто используемые слова в личный словарь для быстрого доступа",
    guideTip4: "Используйте настраиваемые доски общения для конкретных тем",
    guideTip5: "Создайте персонализированную доску общения для ежедневных тем и потребностей",
    
    // Auth
    login: "Войти",
    signup: "Регистрация",
    loginToAccount: "Войти в свой аккаунт",
    createAccount: "Создать новый аккаунт",
    emailLabel: "Email",
    passwordLabel: "Пароль",
    invalidEmail: "Неверный адрес email",
    passwordMinLength: "Пароль должен содержать минимум 6 символов",
    loginSuccess: "Успешный вход",
    welcomeBack: "С возвращением!",
    signupSuccess: "Успешная регистрация",
    checkEmail: "Письмо для подтверждения отправлено. Проверьте почту.",
    authError: "Произошла ошибка",
    invalidCredentials: "Неверный email или пароль",
    userExists: "Пользователь уже зарегистрирован, попробуйте войти",
    emailNotConfirmed: "Подтвердите email перед входом",
    passwordBreached: "Этот пароль был найден в утечке данных. Для вашей безопасности выберите другой, уникальный пароль.",
    googleSignInError: "Ошибка входа через Google",
    or: "или",
    noAccount: "Нет аккаунта?",
    haveAccount: "Уже есть аккаунт?",
    forgotPassword: "Забыли пароль?",
    resetPassword: "Сброс пароля",
    resetEmailSent: "Успешно отправлено",
    resetEmailDesc: "Ссылка для сброса пароля отправлена на ваш email",
    resetError: "Ошибка отправки, попробуйте снова",
    sendResetEmail: "Отправить ссылку",
    backToLogin: "Назад к входу",
    invalidResetLink: "Ссылка недействительна или истекла",
    passwordsDoNotMatch: "Пароли не совпадают",
    passwordResetSuccess: "Пароль успешно обновлен",
    passwordResetSuccessDesc: "Теперь вы можете войти с новым паролем",
    newPassword: "Новый пароль",
    confirmNewPassword: "Подтвердите новый пароль",
    setNewPassword: "Установить новый пароль",
    
    // MFA
    twoFactorAuth: "Двухфакторная аутентификация",
    enterAuthCode: "Введите код из приложения аутентификации",
    verificationCode: "Код подтверждения",
    verifyAndLogin: "Подтвердить и войти",
    mfaCodeError: "Код должен содержать 6 цифр",
    mfaCodeWrong: "Неверный код, попробуйте снова",
    
    // Email Verification
    verifyingEmail: "Проверка вашего email...",
    pleaseWait: "Пожалуйста, подождите",
    emailVerified: "Email успешно подтвержден!",
    emailVerifiedDesc: "Адрес {email} подтвержден. Теперь вы можете войти.",
    goToLogin: "Перейти к входу",
    tokenExpired: "Ссылка истекла",
    tokenExpiredDesc: "Ссылка для подтверждения истекла. Зарегистрируйтесь снова.",
    backToSignup: "Назад к регистрации",
    verificationFailed: "Ошибка подтверждения",
    verificationFailedDesc: "Ссылка недействительна или уже была использована.",
    
    myVoice: "Мой голос",
    voiceCloning: "Клонирование голоса",
    voiceCloningDesc: "Создать свой голос из записи",
    
    // Night Monitoring
    nightMonitoringTitle: "Ночной мониторинг",
    nightMonitoringDesc: "Оповещение опекуна, когда пользователь не спит ночью",
    nightMonitoringEyeControlOnly: "Ночной мониторинг доступен только в режиме EyeControl",
    nightCaregiverEmail: "Email опекуна",
    nightCaregiverEmailDesc: "Оповещения будут отправлены на этот адрес",
    nightHoursRange: "Диапазон ночных часов",
    startTime: "Время начала",
    endTime: "Время окончания",
    awakeDurationThreshold: "Длительность бодрствования для оповещения",
    awakeDurationDesc: "Если пользователь не спит дольше этого времени, будет отправлено оповещение",
    minutes: "минут",
    howItWorks: "Как это работает?",
    nightMonitoringInfo1: "Когда пользователь спит, EyeControl отправляет непрерывный сигнал Enter",
    nightMonitoringInfo2: "Когда сигнал прекращается надолго, система определяет бодрствование",
    nightMonitoringInfo3: "По истечении настроенного времени опекуну отправляется оповещение",
    cloneAgain: "Клонировать снова",
    cloneVoice: "Клонировать голос",
    
    // User Contacts
    caregiverAlerts: "Контакты",
    userContactsDescription: "Контакты, которым пользователь может отправлять сообщения для поддержания связи и вызова помощи при необходимости.",
    addContact: "Добавить контакт",
    savedContacts: "Сохранённые контакты",
    caregiverQRTitle: "Подключить устройство опекуна",
    caregiverQRDesc: "Сканируйте для подключения телефона",
    caregiverQRInstructions: "Сканирование кода позволяет получать сообщения от пользователя в виде Push-уведомлений на ваш телефон, даже когда браузер закрыт. Вы можете настроить обычные сообщения и/или уведомления о вызове помощи.",
    linkCopied: "Ссылка скопирована!",
    copyFailed: "Не удалось скопировать",
    copyLink: "Копировать ссылку",
    connectedCaregivers: "Сохранённые контакты",
    noCaregiversConnected: "Контакты ещё не подключены",
    caregiverRemoved: "Устройство успешно удалено",
    removeError: "Ошибка удаления устройства",
    unknownDevice: "Неизвестное устройство",
    confirmDeleteCaregiver: "Удалить контакт",
    confirmDeleteCaregiverDesc: "Контакт больше не будет получать уведомления. Вы всегда можете повторно подключить его в настройках.",
    recentlyConnected: "Недавно подключено",
    loginRequired: "Войдите для просмотра QR-кода",
    howPushAlertsWork: "Как работают оповещения?",
    pushAlertInfo1: "Контакты сканируют код или открывают ссылку на телефоне.",
    pushAlertInfo2: "Разрешают получение уведомлений в браузере.",
    pushAlertInfo3: "Выбирают тип уведомлений: Все (включая вызов помощи) или только обычные сообщения для связи.",
    pushAlertInfo4: "Получают сообщения от пользователя как уведомления на личный телефон.",
    pushAlertInfo5: "Если включены вызовы помощи- получают мгновенное оповещение при нажатии кнопки помощи.",
    sendTestNotification: "Отправить тестовое уведомление",
    testNotificationSent: "Тестовое уведомление успешно отправлено!",
    testNotificationFailed: "Ошибка отправки тестового уведомления",
    noCaregiversToNotify: "Нет подключённых опекунов для уведомления",
    qrExpiresAt: "Действителен до:",
    qrExpired: "QR-код истёк",
    refresh: "Обновить",
    qrAutoRefreshing: "Автообновление QR-кода...",
    messagesOnly: "Только сообщения",
    allAlerts: "Все",
    notificationTypeAll: "Все (включая вызов помощи)",
    notificationTypeMessagesOnly: "Только обычные сообщения",
    qrAutoRefreshed: "QR-код успешно обновлён",
    refreshQR: "Обновить код",
    enterCodeAt: "на сайте",
    generateNewQR: "Создать новый QR",
    orEnterCode: "Или введите код:",
    iphoneCodeInstruction: "Для пользователей iPhone: введите следующий код после установки",
    allCaregiversRemoved: "Все устройства успешно удалены",
    clearAllCaregivers: "Удалить все контакты",
    pushNotConfigured: "Push-уведомления ещё не настроены",
    clearError: "Ошибка при очистке устройств",
    
    // Settings - Help Alert
    helpAlertSound: "Звук помощи",
    helpAlertSoundDesc: "Выберите что воспроизводить при нажатии помощи",
    voiceAlert: "Голос",
    sirenAlert: "Сирена",
    beepAlert: "Сигнал",
    trainAlert: "Поезд",
    
    // Settings - Security
    security: "Безопасность",
    twoFactorSetup: "Двухфакторная аутентификация (2FA)",
    twoFactorSetupDesc: "Добавить дополнительный уровень защиты",
    setup2FA: "Настроить 2FA",
    auditLog: "Журнал безопасности",
    auditLogDesc: "Недавние действия безопасности в вашем аккаунте",
    noAuditLogs: "Нет действий безопасности для отображения",
    auditTokenRegister: "Регистрация устройства опекуна",
    auditEmailAlert: "Email-уведомление",
    auditPushAlert: "Push-уведомление",
    auditLinkGenerate: "Создание QR-ссылки",
    
    // Sidebar
    main: "Главная",
    disableTracking: "Выкл. отслеживание",
    logout: "Выход",
    
    // Smart Home page
    buttons: "Кнопки",
    hueTab: "Hue",
    haTab: "HA",
    settingsTab: "Настройки",
    addButtonLabel: "Добавить кнопку",
    noLightsFound: "Лампы не найдены",
    checkHueConnection: "Проверьте подключение Hue",
    hueError: "Ошибка загрузки ламп Hue",
    lightTurnedOn: "Лампа включена",
    lightTurnedOff: "Лампа выключена",
    lightControlError: "Ошибка управления лампой",
    brightnessError: "Ошибка установки яркости",
    haError: "Ошибка загрузки Home Assistant",
    noHAEntities: "Устройства не найдены",
    checkHAConnection: "Проверьте подключение Home Assistant",
    actionCompleted: "Действие выполнено",
    deviceControlError: "Ошибка управления устройством",
    buttonTriggered: "Активировано!",
    buttonTriggerError: "Ошибка активации кнопки",
    buttonUpdated: "Кнопка обновлена",
    buttonAdded: "Кнопка добавлена",
    buttonDeleted: "Кнопка удалена",
    fillNameAndUrl: "Заполните название и URL webhook",
    editButton: "Редактировать кнопку",
    newButton: "Новая кнопка",
    iconLabel: "Иконка",
    colorLabel: "Цвет",
    methodLabel: "Метод",
    saveChanges: "Сохранить изменения",
    
    // Smart Home Settings
    smartHomeEnabled: "Включено - Настройте на экране умного дома",
    smartHomeDisabled: "Включите для управления умным домом",
    philipsHueSettings: "Настройки Philips Hue",
    bridgeIP: "IP-адрес моста",
    hueUsername: "Имя пользователя",
    hueInstructions: "Нажмите кнопку на мосте, затем нажмите 'Подключить'",
    connect: "Подключить",
    homeAssistantSettings: "Настройки Home Assistant",
    serverUrl: "URL сервера",
    accessToken: "Токен доступа",
    
    // Button icons
    iconPower: "Питание",
    iconLamp: "Лампа",
    iconSun: "Солнце",
    iconMoon: "Луна",
    iconHome: "Дом",
    iconPlay: "Воспроизвести",
    
    // Colors
    colorTeal: "Бирюзовый",
    colorOrange: "Оранжевый",
    colorBlue: "Синий",
    colorGreen: "Зелёный",
    colorPurple: "Фиолетовый",
    colorPink: "Розовый",
    colorYellow: "Жёлтый",
    colorRed: "Красный",
    
    // Translator page
    realtimeTranslator: "Переводчик в реальном времени",
    speaking: "Говорит",
    translation: "Перевод",
    pressToStart: "Нажмите для начала",
    listening: "Слушает...",
    pressMicToSpeak: "Нажмите на микрофон и начните говорить",
    speechRecognitionError: "Ошибка распознавания речи",
    allowMicAccess: "Разрешите доступ к микрофону в браузере",
    browserNotSupported: "Браузер не поддерживает распознавание речи",
    translationError: "Ошибка перевода",
    
    // AI Chat page (additional)
    chatCleared: "Чат очищен",
    helloImHere: "Привет! Я здесь, чтобы помочь",
    writeMessageBelow: "Напишите сообщение ниже, и я отвечу",
    readAloud: "Прочитать вслух",
    sendMessageError: "Ошибка отправки сообщения",
    
    // AAC Keyboard page
    aacKeyboardTitle: "AAC Клавиатура",
    aacTip: "Совет:",
    aacTipText: "В режиме аббревиатур введите первую букву каждого слова",
    aacExample: 'Например: "hay" = "how are you"',
    
    // YouTube page (additional)
    popular: "Популярное",
    searchYoutube: "Поиск на YouTube",
    typeToSearch: "Введите поисковый запрос...",
    popularVideos: "Популярные видео",
    homePage: "Главная страница",
    searchResults: "Результаты поиска",
    recommendedVideos: "Рекомендуемые видео",
    watchHistory: "История просмотров",
    searchError: "Ошибка поиска",
    loginError: "Ошибка входа",
    loginToSearch: "Войдите для поиска",
    googleSignInRequired: "Требуется вход через Google",
    signInWithGoogleToSearch: "Войдите через Google для поиска видео на YouTube",
    signInWithGoogle: "Войти через Google",
    closeVideo: "Закрыть",
    muteVideo: "Выключить звук",
    unmuteVideo: "Включить звук",
    skipForward: "10 секунд вперёд",
    skipBackward: "10 секунд назад",
    newSearch: "Новый поиск",
    pauseVideo: "Пауза",
    playVideo: "Воспроизвести",
    timesWatched: "просмотров",
    loginToWatch: "Войдите через Google для просмотра YouTube",
    connectWithGoogle: "Войти через Google",
    noHistory: "История просмотров пуста",
    clearHistory: "Очистить историю",
    historySaved: "Видео сохранено в истории",
    historyCleared: "История очищена",
    linkGoogleAccount: "Связать аккаунт Google",
    linkGoogleDescription: "Хотите добавить вход через Google в свой аккаунт? Это позволит входить через email или Google.",
    useGoogleOnlyForYouTube: "Только для YouTube",
    linkToMyAccount: "Связать с моим аккаунтом",
    
    // Spotify page
    spotifyTitle: "Spotify",
    welcomeToSpotify: "Добро пожаловать в Spotify",
    connectToSpotify: "Подключитесь к Spotify для доступа к плейлистам и песням",
    loginToSpotify: "Войти в Spotify",
    spotifySetup: "Настройка Spotify",
    spotifySetupDesc: "Для подключения к Spotify создайте приложение на",
    enterClientId: "Введите Client ID",
    continueAndLogin: "Продолжить и войти",
    yourPlaylists: "Ваши плейлисты",
    noPlaylistsFound: "Плейлисты не найдены",
    songsCount: "песен",
    disconnectSpotify: "Отключить",
    useArrowsHint: "Используйте ↑↓ для навигации и Enter для выбора",
    previousTrack: "Предыдущий трек",
    nextTrack: "Следующий трек",
    play: "Воспроизвести",
    pause: "Пауза",
    connectingToPlayer: "Подключение к плееру...",
    premiumRequired: "Для полного воспроизведения требуется Premium",
    
    // TV page (additional)
    selectChannel: "Выберите канал для начала",
    noChannelsFound: "Каналы не найдены",
    channelLoadError: "Ошибка загрузки каналов",
    channelPlayError: "Не удаётся воспроизвести канал",
    channelError: "Ошибка воспроизведения канала",
    formatNotSupported: "Браузер не поддерживает этот формат",
    tryAgain: "Попробовать снова",
    generalCategory: "Общее",
    israel: "Израиль",
    usa: "США",
    russiaCountry: "Россия",
    saudiArabia: "Саудовская Аравия",
    restOfWorld: "Остальной мир",
    fullscreen: "Полный экран",
    exitFullscreen: "Выйти из полного экрана",
    
    // Radio page (additional)
    genresLabel: "Жанры",
    countriesLabel: "Страны",
    noStationsFound: "Станции не найдены",
    playingNow: "Сейчас играет",
    pausedStatus: "На паузе",
    uk: "Великобритания",
    franceCountry: "Франция",
    germanyCountry: "Германия",
    spainCountry: "Испания",
    italyCountry: "Италия",
    brazilCountry: "Бразилия",
    japanCountry: "Япония",
    indiaCountry: "Индия",
    greeceCountry: "Греция",
    turkeyCountry: "Турция",
    polandCountry: "Польша",
    popGenre: "Поп",
    rockGenre: "Рок",
    jazzGenre: "Джаз",
    classicalGenre: "Классика",
    electronicGenre: "Электроника",
    hiphopGenre: "Хип-хоп",
    countryGenre: "Кантри",
    bluesGenre: "Блюз",
    reggaeGenre: "Регги",
    ambientGenre: "Эмбиент",
    oldiesGenre: "Ретро",
    the80sGenre: "80-е",
    the90sGenre: "90-е",
    danceGenre: "Танцевальная",
    soulGenre: "Соул",
    latinGenre: "Латино",
    loungeGenre: "Лаунж",
    metalGenre: "Метал",
    alternativeGenre: "Альтернатива",
    chilloutGenre: "Чилаут",
    
    // Device check
    deviceNotSupported: "Это приложение предназначено для планшетов и компьютеров в альбомном режиме",
    deviceNotSupportedDesc: "Для лучшего опыта используйте устройство с большим экраном или поверните экран в альбомный режим (ландскейп)",
    minScreenSize: "Минимальный размер экрана: 10 дюймов",
    
    // Voice control overlay
    listeningStatus: "Слушаю...",
    notListeningStatus: 'Не слушаю - скажите "EyeControl" для активации',
    
    // Onboarding
    whichLanguage: "Какой язык использовать?",
    canChangeInSettings: "Вы можете изменить это в настройках в любое время",
    greatReadyFemale: "Отлично",
    greatReadyMale: "Отлично",
    greatReady: "Отлично",
    niceToMeet: "Приятно познакомиться!",
    labelName: "Имя:",
    labelAddress: "Обращение:",
    labelLanguage: "Язык:",
    labelControlMethod: "Способ управления:",
    
    // Scanning action labels
    actionSelect: "Выбор",
    actionCancel: "Отмена",
    actionNext: "Следующий",
    actionPrev: "Предыдущий",
    actionBack: "Назад",
    actionUp: "Вверх",
    actionDown: "Вниз",
    actionLeft: "Влево",
    actionRight: "Вправо",
    
    // Pricing page
    pricingTitle: "Выберите свой план",
    pricingSubtitle: "7 дней бесплатной пробной версии для любого плана",
    monthly: "Ежемесячно",
    yearly: "Ежегодно",
    yearlyDiscount: "(скидка 20%)",
    personal: "Личный",
    group: "Групповой",
    forTeams: "Для команд",
    perMonth: "в месяц",
    perUserPerMonth: "за пользователя в месяц",
    minUsers: "минимум 5 пользователей",
    users: "Пользователи",
    regularPrice: "Обычная цена:",
    salePrice: "Цена со скидкой:",
    startFreeTrial: "Начать бесплатную пробную версию",
    whatsIncluded: "Что включено:",
    startWith7Days: "Начните с 7 бесплатных дней",
    blackFridaySale: "Распродажа Black Friday",
    limitedTimeOffer: "Специальное предложение на ограниченное время",
    featureEyeTracking: "Продвинутое отслеживание глаз",
    featureCommBoard: "Полная коммуникационная доска",
    featureSmartTyping: "Умный быстрый набор",
    featureCaregiverMsg: "Отправка сообщений опекуну",
    featureTvYoutube: "Доступ к ТВ и YouTube",
    featureGames: "Доступные игры",
    featureSupport: "Полная техническая поддержка",
    featureUpdates: "Автоматические обновления",
    
    // Contacts page additional
    noEmailAddress: "Нет адреса электронной почты",
    setEmailFirst: "Сначала укажите email опекуна",
    messageFromAyuni: "Сообщение от EyeControl App",
    noPhoneNumber: "Нет номера телефона",
    setPhoneFirst: "Сначала укажите телефон опекуна",
    errorTitle: "Ошибка",
    pleaseLoginFirst: "Сначала войдите в систему",
    notificationSent: "Уведомление отправлено",
    sentToDevices: "Отправлено на {0} устройств",
    scanQRInSettings: "Отсканируйте QR-код в настройках",
    failedToSendNotification: "Не удалось отправить уведомление",
    pushAlert: "Push-уведомление",
    emailSent: "Письмо отправлено",
    messageSentTo: "Сообщение отправлено на {email}",
    failedToSendEmail: "Не удалось отправить письмо",
    
    // Board Builder (unique additions)
    newBoard: "Новая доска",
    boardUpdated: "Доска успешно обновлена!",
    boardSaved: "Доска успешно сохранена!",
    confirmBtn: "Подтвердить",
    gridSize: "Размер сетки",
    cellsCount: "ячеек",
    utterancesCount: "высказываний",
    saveBtn: "Сохранить",
    finishBtn: "Завершить",
    
    // Help Alert
    iNeedHelpMale: "Мне нужна помощь!",
    iNeedHelpFemale: "Мне нужна помощь!",
    closeBtn: "Закрыть",
    whatHappened: "Что случилось?",
    toCloseText: "для закрытия",
    
    // Emergency Board
    emergencyPainMale: "Мне больно",
    emergencyPainFemale: "Мне больно",
    emergencyCallCaregiver: "Позвать опекуна",
    emergencyBreathing: "Трудно дышать",
    emergencyNotWellMale: "Мне плохо",
    emergencyNotWellFemale: "Мне плохо",
    emergencyBathroom: "Туалет",
    emergencyThirsty: "Хочу пить",
    emergencySuction: "Нужна аспирация",
    emergencyPosition: "Сменить положение",
    addCard: "Добавить карточку",
    resetToDefault: "Сбросить по умолчанию",
    undo: "Отменить",
    doneEditing: "Завершить редактирование",
    editBtn: "Редактировать",
    editItem: "Редактировать элемент",
    addNewItem: "Добавить новый элемент",
    textMale: "Текст (мужской)",
    textFemale: "Текст (женский)",
    emojiLabel: "Эмодзи",
    cancelBtn: "Отмена",
    theUser: "Пользователь",
    userSelected: "выбрал:",
    
    // Legal page
    legalInfo: "Юридическая информация",
    privacyPolicy: "Политика конфиденциальности",
    cookiesPolicy: "Политика cookies",
    termsAndConditions: "Условия использования",
    refundPolicyTitle: "Политика возврата",
    openSource: "Открытый исходный код",
    openSourceAttribution: "Атрибуция открытого исходного кода",
    cookiesInUse: "Используемые cookies",
    essentialCookies: "Необходимые",
    essentialDesc: "Cookies, необходимые для работы приложения",
    functionalCookies: "Функциональные",
    functionalDesc: "Cookies для улучшения функциональности и персонализации",
    analyticsCookies: "Аналитические",
    analyticsDesc: "Cookies для понимания использования приложения",
    notCurrentlyUsed: "Не используется в настоящее время",
    userSettingsCookie: "Хранение настроек и предпочтений пользователя",
    cookieConsentCookie: "Запоминание согласия на cookies",
    aacDictionaryCookie: "Хранение выученных слов и фраз",
    communicationBoardsCookie: "Хранение пользовательских досок общения",
    smartHomeSettingsCookie: "Хранение настроек умного дома",
    ayuniUsesLibraries: "EyeControl App использует следующие библиотеки с открытым исходным кодом:",
    
    // Caregiver Connect Page
    caregiverConnectTitle: "Подключить контакт",
    caregiverConnectPatientLabel: "Подключение к аккаунту:",
    caregiverConnectDescription: "Включить push-уведомления на этом устройстве для получения сообщений от {patientName}",
    caregiverConnectNotificationTypeTitle: "Выберите тип уведомлений",
    caregiverConnectAllAlerts: "Все (включая запросы о помощи)",
    caregiverConnectMessagesOnly: "Только обычные сообщения (для связи)",
    caregiverConnectEnterCodeInstruction: "Введите код, отображаемый на экране пользователя",
    caregiverConnectEnableButton: "Включить уведомления",
    caregiverConnectDeviceNote: "Вы будете получать уведомления на это устройство",
    caregiverConnectContactNameLabel: "Имя контакта",
    caregiverConnectContactNamePlaceholder: "Например: Мама, Давид сиделка",
    caregiverConnectContactNameHint: "Введите ваше имя, чтобы пользователь мог вас узнать",
    caregiverConnectSuccess: "Подключено!",
    caregiverConnectSuccessDesc: "Вы будете получать уведомления, когда {patientName} отправляет сообщения.",
    caregiverConnectSuccessNote: "Вы можете закрыть эту страницу. Уведомления будут приходить даже при закрытом браузере.",
    caregiverConnectError: "Ошибка подключения",
    caregiverConnectTryAgain: "Попробовать снова",
    caregiverConnectUnsupported: "Не поддерживается",
    caregiverConnectUnsupportedDesc: "Push-уведомления не поддерживаются в этом браузере. Попробуйте Chrome, Firefox или Edge.",
    caregiverConnectInvalidLink: "Недействительная ссылка",
    caregiverConnectInvalidLinkDesc: "В этой ссылке отсутствует необходимая информация. Отсканируйте действительный QR-код.",
    caregiverConnectRequestingPermission: "Настройка уведомлений...",
    caregiverConnectPermissionDenied: "Разрешение отклонено или не удалось получить токен уведомлений. Убедитесь, что уведомления включены в настройках браузера.",
    caregiverConnectContactNameRequired: "Пожалуйста, введите ваше имя",
    caregiverConnectMissingPatientId: "Недействительная ссылка - отсутствует идентификатор пользователя",
    
    // iOS PWA Install
    iosInstallRequired: "Первый шаг: установите приложение",
    iosInstallExplanation: "На iPhone сначала добавьте приложение на главный экран, затем откройте его оттуда.",
    iosInstallSteps: "Как это сделать:",
    iosStep1Tap: "Нажмите",
    iosStep1Share: "(Поделиться) внизу",
    iosStep2Tap: "Выберите",
    iosStep2AddToHome: "На экран Домой",
    iosStep3Open: "Откройте приложение с новой иконки",
    iosStep4EnterCode: "Введите код, отображаемый на экране пользователя",
    iosInstallNote: "Это нужно сделать только один раз. После установки уведомления будут работать автоматически.",
    enterCodePlaceholder: "Введите код",
    aboutApp: "О приложении EyeControl",
  },
} as const;

export type TranslationKey = keyof typeof translations.he;
